import React, { useState, useEffect, useRef ,useCallback} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import { Button, Heading, Text } from '../../common';
import maverickPortalhttp from '../../utils/webService/webService';
import maverickPortalApiEndPoint from '../../config/apiEndPoint';
import { InputText } from '../../components/form';
import { display, fontSize, maxHeight, width } from '@mui/system';
import { useSearchParams } from 'react-router-dom';
import { Slider, Box, Typography } from '@mui/material';
import { debounce } from 'lodash';
import ErrorScreen1 from '../../assets/images/ErrorScreen1.png';
import ImageUploadQuestion from '../../components/form/ImageUpload';
import VideoUploadQuestion from '../../components/form/VideoUpload';
import VideoResponseUpload from '../../components/form/VideoResponseUpload';
import { FaMicrophone, FaPause, FaTrash } from 'react-icons/fa';
import AudioRecorder from '../../components/form/AudioRecorder.js';
import mixPanel from '../../utils/helpers/mixPanel';
import { uploadVideoInChunks } from '../../utils/multipartVideoUpload';
import {
  clearAllVideoUploadSessions,
  clearVideoUploadSession,
  getVideoUploadSession,
  listVideoUploadSessions,
  saveVideoUploadSession,
} from '../../utils/videoUploadSession';
import { maverickPortalconfig } from '../../config/apiConfig';
import { validateWebLinkUrl, validateUrlOnMount } from '../../utils/helpers/urlValidator';
import Select from 'react-select';
import MobileDatePicker from 'react-mobile-datepicker';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
// components
import ImageQuestionMedia from '../../components/ImageQuestionMedia';
import WelcomeScreen from './WelcomeScreen';
import ResponseScreen from './ResponseScreens';
import RankingQuestion from './RankingQuestion';
import CustomSlider from './CustomSlider';
import NPSQuestion from './NPSQuestion';
import FetchErrorScreen from './FetchErrorScreen';
import ProfileScreen from './ProfileScreen';
import ProjectClosedScreen from './ProjectClosedScreen';
import InvalidProjectScreen from './InvalidProjectScreen';
import LikertDropdown, { isCustomLikertQuestion, isMatrixQuestion } from './LikertDropdown';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import signupBg from '../../assets/images/signup_bg.png';
import explorastoryPromoVideo from '../../assets/images/Explorastory_promo_video.mp4';

/** Toasts for screener/form submit — rendered next to Submit in the active section */
const WEBLINK_DASHBOARD_SUBMIT_TOAST_ID = 'weblink-dashboard-submit-toast';
/** Toasts for profile step 2 submit — rendered in ProfileScreen above profile Submit */
const WEBLINK_PROFILE_SUBMIT_TOAST_ID = 'weblink-profile-submit-toast';

const isLikertChoiceAnswered = answer => {
  if (Array.isArray(answer)) return answer.length > 0;
  return answer !== undefined && answer !== null && answer !== '';
};

const likertAnswerIncludesScale = (answer, scaleId) => {
  if (!isLikertChoiceAnswered(answer)) return false;
  const selected = Array.isArray(answer) ? answer : [answer];
  return selected.some(id => Number(id) === Number(scaleId));
};

const SubmitToastSlot = styled.div`
  position: fixed;
  top: 74px;
  left: 50%;
  transform: translateX(-50%);
  width: min(420px, calc(100vw - 24px));
  max-width: min(420px, calc(100vw - 24px));
  margin: 0;
  min-height: 0;
  z-index: 99999;
  pointer-events: none;
  .Toastify__toast-container {
    position: fixed !important;
    top: 44px !important;
    left: 49% !important;
    right: auto !important;
    bottom: auto !important;
    transform: translateX(-50%) !important;
    width: 85% !important;
    padding: 0 !important;
    pointer-events: none !important;
  }
  .Toastify__toast {
    margin-bottom: 0.5rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    pointer-events: auto;
  }
`;

const DashboardContainer = styled.div`
  min-height: 100%;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 62px;
`;

const DashboardContent = styled.div`
  padding: 0;
  width: 100%;
  margin: 0;
`;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow-y: auto;
  padding: 20px;
`;

const PopupContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 90%;
  width: 500px;
  margin: 20px auto;
  overflow-y: auto;
  max-height: 90vh;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
`;

const StyledButton = styled(Button)`
  width: 100%;
  margin: 0.5rem 0;
`;

const PermissionDeniedPopup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow-y: auto;
  padding: 20px;
`;

const PermissionContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 90%;
  width: 500px;
  margin: 20px auto;
  overflow-y: auto;
  max-height: 90vh;
`;

const AuthSplash = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 18px 34px 18px;
  overflow: auto;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url(${signupBg});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    opacity: 0.1;
    pointer-events: none;
  }
`;

const AuthSplashCard = styled.div`
  width: min(520px, 100%);
  padding: 20px 18px 26px 18px;
  position: relative;
  z-index: 1;
`;

const AuthSplashLogo = styled.img`
  width: 150px;
  height: auto;
  display: block;
  margin: 0 auto 26px auto;
  transform: translateY(-10px);
`;

const AuthSplashTitle = styled.div`
  text-align: center;
  font-size: 22px;
  line-height: 1.25;
  font-weight: 700;
  color: #5b5b5b;
  max-width: 360px;
  margin: 14px auto 54px auto;
`;

const AuthSplashButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: center;
`;

const AuthSplashTopButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const AuthSplashVideoButtonWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 86px;
`;

const AuthSplashButton = styled(Button)`
  width: min(200px, 82%);
  padding: 14px 18px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 16px;
  border: 2px solid #9ebe21;
  background: #ffffff;
  color: #9ebe21;

  &:hover {
    background: #ffffff;
    opacity: 0.95;
  }
`;

const AuthSplashPrimaryButton = styled(AuthSplashButton)`
  border: none;
  background: #9ebe21;
  color: #ffffff;
`;

const AuthSplashFooter = styled.div`
  width: min(520px, 100%);
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  line-height: 1.4;
  margin-top: 18px;
`;

const PermissionIcon = styled.div`
  font-size: 48px;
  color: #f44336;
  margin-bottom: 1.5rem;
`;

const PermissionText = styled.p`
  font-size: 1.1rem;
  color: #666;
  margin: 1rem 0;
  text-align: center;
  line-height: 1.6;
`;

const RequiredText = styled.div`
  color: #f44336;
  font-size: 12px;
  margin-top: 4px;
  display: none;
`;

const QUESTION_TYPES = {
  1: 'Select one',
  2: 'Select multiple',
  3: 'Slider',
  4: 'Likert Scale',
  5: 'Short Text Answer',
  6: 'Long Text Answer',
  7: 'Single 7 Point Scale',
  8: 'Image Upload',
  9: 'Screener Type',
  10: 'Recording',
  11: 'Numeric Value Input',
  12: 'Audio Upload',
  13: 'Video Upload',
  14: 'Ranking',
  15: 'Video Response Upload',
  16: 'Net Promoter Score (NPS)'
};
const MEDIA_QUESTION_TYPES = [8, 12, 13, 15];
const REQUIRED_QUESTION_ERROR_TEXT = 'This is a required question';
const LIKERT_SHUFFLE_ORDER_KEY = 'likert_shuffle_order';

const readJsonStorage = key => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const orderItemsByIds = (items, savedIds, idKey) => {
  if (!Array.isArray(items)) return items;
  if (!Array.isArray(savedIds) || savedIds.length === 0) return null;
  const byId = new Map(items.map(item => [String(item?.[idKey]), item]));
  const used = new Set();
  const ordered = [];
  savedIds.forEach(id => {
    const key = String(id);
    const item = byId.get(key);
    if (!item || used.has(key)) return;
    ordered.push(item);
    used.add(key);
  });
  items.forEach(item => {
    const key = String(item?.[idKey]);
    if (!used.has(key)) ordered.push(item);
  });
  return ordered;
};

const clearAnswerStorageFromLocalStorage = () => {
  localStorage.removeItem('form_answers');
  localStorage.removeItem('text_input_answers');
  localStorage.removeItem(LIKERT_SHUFFLE_ORDER_KEY);
};

const scrollToTopImmediate = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
};

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.9);
  z-index: 1000;
`;

const Loader = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #9cc31c;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoaderMessage = styled.div`
  font-size: 16px;
  color: #333;
  font-weight: 500;
`;

const LoadingOverlay = ({ message = 'Loading...' }) => (
  <LoaderWrapper>
    <Loader />
    <LoaderMessage>{message}</LoaderMessage>
  </LoaderWrapper>
);

const SkeletonCard = styled.div`
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
`;

const WeblinkSkeletonScreen = () => (
  <SkeletonTheme baseColor="#f0f0f0" highlightColor="#f7f7f7">
    <div>
      <Skeleton width={180} height={22} style={{ marginBottom: 8 }} />
      <Skeleton width="100%" height={8} borderRadius={4} style={{ marginBottom: 20 }} />

      {[1, 2, 3].map((id) => (
        <SkeletonCard key={id}>
          <Skeleton width="65%" height={18} style={{ marginBottom: 14 }} />
          <Skeleton width="100%" height={46} style={{ marginBottom: 10 }} />
          <Skeleton width="92%" height={46} />
        </SkeletonCard>
      ))}

      <Skeleton width={140} height={38} borderRadius={6} />
    </div>
  </SkeletonTheme>
);



const ProgressBarContainer = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

const ProgressBarTrack = styled.div`
  width: 100%;
  height: 8px;
  background: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
`;

const ProgressBarFill = styled.div`
  height: 100%;
  background: #9ebe21;
  width: ${props => props.percent}%;
  transition: width 0.3s;
`;

const ProgressBarText = styled.div`
  margin-bottom: 8px;
  font-weight: bold;
  color: #333;
  font-size: 1.1rem;
  span {
    color: #9ebe21;
    font-size: 15px;
  }
`;


const RespondentFormRootContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;

function RespondentFormDashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  mixPanel.init();
  const projectSlug = searchParams.get('projectSlug');
  const qRProject = searchParams.get('qRProject'); 
  
  // Extract identificationID and projectIdentity from the first parameter after ? mark (dynamic project name)
  const getIdentificationID = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const firstParam = urlParams.keys().next().value;
    return firstParam ? urlParams.get(firstParam) : null;
  };
  
  const getProjectIdentity = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const firstParam = urlParams.keys().next().value;
    return firstParam || null;
  };
  
  const identificationID = getIdentificationID();
  const projectIdentity = getProjectIdentity();
  const [showAuthPopup, setShowAuthPopup] = useState(false);
  const [showProjectClosedScreen, setShowProjectClosedScreen] = useState(false);
  const [showInvalidProjectScreen, setShowInvalidProjectScreen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isValidatingWeblink, setIsValidatingWeblink] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  /** Which API failed — drives copy in FetchErrorScreen */
  const [fetchErrorKind, setFetchErrorKind] = useState(null);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [answers, setAnswers] = useState(() => {
    const saved = localStorage.getItem('form_answers');
    return saved ? JSON.parse(saved) : {};
  });
  const [recordingStates, setRecordingStates] = useState({});
  const [sectionHistory, setSectionHistory] = useState([]);
  const [mediaUrls, setMediaUrls] = useState({});
  const [projectId, setProjectId] = useState('');
  const [token1, setToken1] = useState('');
  const [perProject_ID, setperProject_ID1] = useState('');
  const [respondentDetails, setRespondentDetails] = useState(null);
  const [screenerSubmitted, setScreenerSubmitted] = useState(false);
  const [projectTask_ID, setProjectTask_ID] = useState(null);
  const [screenerReject, setScreenerReject] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const [responseType, setResponseType] = useState('');
  const [showWelcomeScreen, setShowWelcomeScreen] = useState(false);
  const [deviceReady, setDeviceReady] = useState(false);
  const [internetReady, setInternetReady] = useState(false);
  const [projectName, setProjectName] = useState('');
  const [showPermissionDenied, setShowPermissionDenied] = useState(false);
  const [deniedPermissions, setDeniedPermissions] = useState([]);
  const [mediaUploading, setMediaUploading] = useState(false);
  const [videoUploadProgress, setVideoUploadProgress] = useState({});
  const [videoUploadMeta, setVideoUploadMeta] = useState({});
  const [videoUploadActionError, setVideoUploadActionError] = useState({});
  const videoUploadActionErrorTimeoutsRef = useRef({});
  // 1 | 2 | 3 while showing connection-drop messages before Retry/Delete
  const [videoConnectionMessageStage, setVideoConnectionMessageStage] = useState({});
  const [videoResumeOffer, setVideoResumeOffer] = useState(null);
  const uploadVideoRef = useRef(null);
  const videoResumeStartedRef = useRef(false);

  const clearVideoUploadActionErrorFor = useCallback(questionId => {
    const key = String(questionId);
    if (videoUploadActionErrorTimeoutsRef.current[key]) {
      clearTimeout(videoUploadActionErrorTimeoutsRef.current[key]);
      delete videoUploadActionErrorTimeoutsRef.current[key];
    }
    setVideoUploadActionError(prev => {
      const next = { ...prev };
      delete next[key];
      delete next[questionId];
      return next;
    });
  }, []);

  const showVideoUploadActionError = useCallback((questionId, message) => {
    const key = String(questionId);
    if (videoUploadActionErrorTimeoutsRef.current[key]) {
      clearTimeout(videoUploadActionErrorTimeoutsRef.current[key]);
    }
    setVideoUploadActionError(prev => ({
      ...prev,
      [key]: message,
    }));
    videoUploadActionErrorTimeoutsRef.current[key] = setTimeout(() => {
      setVideoUploadActionError(prev => {
        const next = { ...prev };
        delete next[key];
        delete next[questionId];
        return next;
      });
      delete videoUploadActionErrorTimeoutsRef.current[key];
    }, 5000);
  }, []);
  // For questionType_ID === 15, VideoResponseUpload expects a boolean:
  // it checks `if (videoUploadScreenSuccess || submitting)` to show the spinner.
  const [videoUploadScreenSuccess, setVideoUploadScreenSuccess] = useState(false);
  const [videoBlobs, setVideoBlobs] = useState({});
  const [audioBlobs, setAudioBlobs] = useState({});
  /** MP3: block another record/upload while one question is in record UI or uploading */
  const activeMp3RecordingQuestionIdRef = useRef(null);
  const activeMp3UploadingQuestionIdRef = useRef(null);
  const activeMediaUploadingQuestionIdRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [videoSuccess, setVideoSuccess] = useState({});
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [profileFilled,setProfileFilled]= useState(false);
  const [profileAllow,setProfileAllow]= useState(false);
  const [timer, setTimer] = useState(0);
  const [isPickerOpen, setIsPickerOpen] = useState(false);
 const [selectedDate, setSelectedDate] = useState(new Date());
  const [openMultiLikertMenu, setOpenMultiLikertMenu] = useState({});
  const [showAuthHelpVideo, setShowAuthHelpVideo] = useState(false);
  const serializeFormData = useCallback((formData) => {
    if (!formData || typeof formData.forEach !== 'function') return formData;
    const serialized = {};
    const appendValue = (key, value) => {
      if (key in serialized) {
        if (Array.isArray(serialized[key])) {
          serialized[key].push(value);
        } else {
          serialized[key] = [serialized[key], value];
        }
      } else {
        serialized[key] = value;
      }
    };
    formData.forEach((value, key) => {
      if (value instanceof File) {
        appendValue(key, {
          name: value.name,
          type: value.type,
          size: value.size,
          lastModified: value.lastModified,
        });
      } else if (value instanceof Blob) {
        appendValue(key, {
          type: value.type,
          size: value.size,
        });
      } else {
        appendValue(key, value);
      }
    });
    return serialized;
  }, []);

  const getResponseSummary = useCallback((resp) => {
    if (!resp) return null;
    const source = resp.response ?? resp;
    if (!source || typeof source !== 'object') return null;
    const { config, data, status } = source;
    const summary = {};
    if (typeof config !== 'undefined') summary.config = config;
    if (typeof data !== 'undefined') summary.data = data;
    if (typeof status !== 'undefined') summary.status = status;
    return Object.keys(summary).length ? summary : null;
  }, []);

  // Add this near the top of the component with other state declarations
  const [localInputValues, setLocalInputValues] = useState({});
  // Add this near the top of the component with other state declarations
  const [textInputState, setTextInputState] = useState(() => {
    // Initialize from localStorage if available
    const savedTextInputs = localStorage.getItem('text_input_answers');
    return savedTextInputs ? JSON.parse(savedTextInputs) : {};
  });
  // Add this near other state declarations at the top of RespondentFormDashboard
  const [activeInputId, setActiveInputId] = useState(null);
  const [showCreateAccount, setShowCreateAccount] = useState(() => {
    const currentUrl = window.location.href;
    // const equalsCount = (currentUrl.match(/=/g) || []).length;
    // return equalsCount === 1;
    return !currentUrl.includes('&');
  });
  const [showNoconnectionPopup, setShowNoConnectionPopup] = useState(false);
  const [isCheckingConnection, setIsCheckingConnection] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [connectionType, setConnectionType] = useState(null);
  const [endSurveyTriggered, setEndSurveyTriggered] = useState(false);
  
  // Timer ref for form data clearing
  const formClearTimerRef = useRef(null);
  const mediaErrorDismissTimeoutsRef = useRef(new Map());

  useEffect(() => {
    return () => {
      mediaErrorDismissTimeoutsRef.current.forEach(tid => clearTimeout(tid));
      mediaErrorDismissTimeoutsRef.current.clear();
    };
  }, []);

  // Tab inactivity timer ref and state
  const tabInactivityTimerRef = useRef(null);
  const [isTabActive, setIsTabActive] = useState(true);
  
  // Ref to track weblink validation status
  const weblinkValidationRef = useRef({ validated: false, projectClosed: false, invalidProject: false });

  // Add event listeners for online/offline events and connection changes
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    const handleConnectionChange = () => {
      if (navigator.connection) {
        setConnectionType(navigator.connection.effectiveType);
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Add connection change listener if supported
    if (navigator.connection) {
      navigator.connection.addEventListener('change', handleConnectionChange);
      setConnectionType(navigator.connection.effectiveType);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      if (navigator.connection) {
        navigator.connection.removeEventListener('change', handleConnectionChange);
      }
    };
  }, []);

  // Clear all data, wipe localStorage, then send user to login
  const clearAllDataAndShowAuth = () => {
    // Capture login URL from the current weblink before clearing storage
    const currentUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    const projectIdParam = urlParams.get('Project_ID') || projectId;
    const tokenParam = urlParams.get('Token') || token1;
    const projectNameFromUrl = currentUrl.split('?')[1]?.split('=')[0] || '';
    const token5 = currentUrl.split('=')[1] || '';
    const loginPath = projectIdParam && tokenParam
      ? `/login-Resp?Project_ID=${projectIdParam}&Token=${tokenParam}`
      : `/login-Resp?${projectNameFromUrl}=${token5}`;

    // Clear all form data
    setAnswers({});
    setTextInputState({});
    setMediaUrls({});
    setVideoBlobs({});
    setAudioBlobs({});
    setSelectedFiles({});
    setVideoSuccess({});
    setVideoUploadScreenSuccess(false);
    setVideoUploading({});
    setCurrentSectionIndex(0);
    setScreenerSubmitted(false);
    setResponseType('');
    setResponseMessage('');

    localStorage.clear();
    clearAllVideoUploadSessions().catch(() => {});

    setShowAuthPopup(false);
    setIsAuthenticated(false);
    navigate(loginPath, { replace: true });
  };

  // Cleanup timer on component unmount
  useEffect(() => {
    return () => {
      if (formClearTimerRef.current) {
        clearTimeout(formClearTimerRef.current);
      }
      if (tabInactivityTimerRef.current) {
        clearTimeout(tabInactivityTimerRef.current);
      }
    };
  }, []);

  // Page Visibility API to detect tab inactivity
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Tab became inactive - start 5-minute timer
        setIsTabActive(false);
        
        tabInactivityTimerRef.current = setTimeout(() => {
          clearAllDataAndShowAuth();
        }, 300000); // 5 minutes (300 seconds)
      } else {
        // Tab became active - clear the timer
        setIsTabActive(true);
        
        if (tabInactivityTimerRef.current) {
          clearTimeout(tabInactivityTimerRef.current);
          tabInactivityTimerRef.current = null;
        }
      }
    };

    // Listen for visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    const currentUrl = window.location.href;
    const personalizedToken = currentUrl.split('=')[1] || '';
    setShowCreateAccount(!currentUrl.includes('&'));
  }, []);

  // Add this useEffect to save text input state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('text_input_answers', JSON.stringify(textInputState));
  }, [textInputState]);

  useEffect(() => {
    const mediaQuestionIds = new Set();
    sections.forEach(section => {
      section.questionName_array?.forEach(q => {
        if (MEDIA_QUESTION_TYPES.includes(q.questionType_ID)) {
          mediaQuestionIds.add(String(q.question_ID));
        }
      });
    });

    const filterMediaAnswers = (obj) => {
      if (!obj || typeof obj !== 'object') return obj;
      const filtered = {};
      Object.entries(obj).forEach(([key, value]) => {
        const questionId = key.includes('_') ? key.split('_')[0] : key;
        if (!mediaQuestionIds.has(questionId)) {
          filtered[key] = value;
        }
      });
      return filtered;
    };

    const toSave = mediaQuestionIds.size > 0 ? filterMediaAnswers(answers) : answers;
    localStorage.setItem('form_answers', JSON.stringify(toSave));
  }, [answers, sections]);

  // Add state for tracking video upload success
  const [videoUploadSuccess, setVideoUploadSuccess] = useState({});

  // Add state for storing preAssignedImageUrls
  const [preAssignedImageUrls, setPreAssignedImageUrls] = useState({});
  const [audioUploadSuccess, setAudioUploadSuccess] = useState({});
  const [imageUploadSuccess, setImageUploadSuccess] = useState({});
  const [isReferral, setIsReferral] = useState(false);
  // Add this with other state declarations at the top
  const [videoStates, setVideoStates] = useState({});
  const [preProfileData, setPreProfileData] = useState(null);
  useEffect(() => {
    if (isAuthenticated && profileAllow && !profileFilled && !preProfileData) {
      fetchProfile();
    }
  }, [isAuthenticated, profileAllow, profileFilled]);
  useEffect(() => {
    const projectId2 = searchParams.get('Project_ID');
    const token2 = searchParams.get('Token');
    
    // Get current URL to determine if it's generalized or personalized
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split('?')[1];
    
    let currentProjectIdentifier = '';
    let currentToken = '';
    
    if (projectId2 && token2) {
      // Personalized URL format: ?Project_ID=123&Token=abc
      currentProjectIdentifier = `project_${projectId2}`;
      currentToken = token2;
    } else if (urlParts && urlParts.includes('=')) {
      // Generalized URL format: ?projectName=tokenValue
      const [projectName, tokenValue] = urlParts.split('=');
      currentProjectIdentifier = `generalized_${projectName}`;
      currentToken = tokenValue;
    }
    
    const storedProjectIdentifier = localStorage.getItem('lastVisitedProject');
    const storedToken = localStorage.getItem('lastVisitedToken');
    
    // Check if project has changed (either different project ID or different generalized project)
    const projectChanged = storedProjectIdentifier && storedProjectIdentifier !== currentProjectIdentifier;
    const tokenChanged = storedToken && storedToken !== currentToken;
    
    // If project or token has changed, clear all data and show auth popup
    if (projectChanged || tokenChanged) {
      // console.log('🔄 New project/link opened - clearing previous data');
      // console.log('Previous project:', storedProjectIdentifier, 'Current project:', currentProjectIdentifier);
      // console.log('Previous token:', storedToken, 'Current token:', currentToken);
      
      // Clear all webLink-related localStorage data
      clearAnswerStorageFromLocalStorage();
      // Note: signupData is excluded to prevent session expired error when navigating back from OTP screen
      const webLinkKeys = [
        'referral_code',
        'viewedMedia',
        'lastVisitedUrl',
        'lastVisitedToken',
        'lastVisitedProject',
        // 'signupData', // Excluded to prevent session expired error on back navigation
        'token',
        'user_id',
        'project_IDper',
        'project_name',
        'gen_ID'
      ];
      
      webLinkKeys.forEach(key => {
        localStorage.removeItem(key);
      });
      clearAllVideoUploadSessions().catch(() => {});
      
      // Reset all component state
      setAnswers({});
      setSections([]);
      setCurrentSectionIndex(0);
      setSectionHistory([]);
      setMediaUrls({});
      setPreAssignedImageUrls({});
      setVideoUploadSuccess({});
      setAudioUploadSuccess({});
      setImageUploadSuccess({});
      setVideoSuccess({});
      setVideoUploadScreenSuccess(false);
      setViewedMedia({});
      setTextInputState({});
      setReferralCodeState('');
      setReferralCode('');
      setScreenerSubmitted(false);
      setScreenerReject(false);
      setResponseType('');
      setResponseMessage('');
      setShowWelcomeScreen(false);
      setProfileFilled(false);
      setProfileAllow(false);
      setProfileStep(1);
      setStaticForm({
        name: '',
        dateOfBirth: '',
        gender_ID: '',
        isMarried: '',
        center_ID: '',
        address: '',
      });
      setStep2Form({
        HomeProduct: [],
        parentEducation_ID: '',
      });
      
      // Show authentication popup
      setShowAuthPopup(true);
      setIsAuthenticated(false);
      
      console.log('✅ Data cleared and auth popup shown for new project/link');
    }
    
    // Store current project identifier and token
    if (currentProjectIdentifier) {
      localStorage.setItem('lastVisitedProject', currentProjectIdentifier);
    }
    if (currentToken) {
      localStorage.setItem('lastVisitedToken', currentToken);
    }
    
    setProjectId(projectId2);
    setToken1(token2); 
  }, [searchParams]);

  useEffect(() => {
    checkAuthentication();
  }, []);

  // Re-check authentication when weblink validation completes
  useEffect(() => {
    if (!isValidatingWeblink) {
      checkAuthentication();
    }
  }, [isValidatingWeblink]);

  // Validate URL format on component mount
  useEffect(() => {
    const urlValidation = validateWebLinkUrl();
    if (!urlValidation.isValid) {
      console.error('URL validation failed on mount:', urlValidation.error);
      setShowInvalidProjectScreen(true);
      setShowAuthPopup(false);
      setShowProjectClosedScreen(false);
      setIsAuthenticated(false);
      setShowWelcomeScreen(false);
      setIsValidatingWeblink(false);
      return;
    }
  }, []);

  // Validate weblink on component mount 
  useEffect(() => {
    console.log('ssssssssssss')
    validateWeblink();
  }, []);

  // Ensure auth popup is hidden when project is closed or invalid
  useEffect(() => {
    if (showProjectClosedScreen || showInvalidProjectScreen) {
      setShowAuthPopup(false);
      setIsAuthenticated(false);
    }
  }, [showProjectClosedScreen, showInvalidProjectScreen]);

  // Re-check authentication when token changes
  useEffect(() => {
    const handleStorageChange = () => {
      const currentToken = localStorage.getItem('token');
      setToken(currentToken);
      checkAuthentication();
    };

    // Listen for storage events (from other tabs/windows)
    window.addEventListener('storage', handleStorageChange);

    // Also check for token changes in the same tab
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem('token');
      if (currentToken !== token) {
        setToken(currentToken);
        checkAuthentication();
      }
    }, 100); // Check every 100ms

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [token]);

  useEffect(() => {
    const fetchRespondentDetails = async () => {
      // Check if project or token has changed - if so, don't fetch data
      const currentUrl = window.location.href;
      const urlParams = new URLSearchParams(window.location.search);
      const projectId2 = urlParams.get('Project_ID');
      const token2 = urlParams.get('Token');
      const urlParts = currentUrl.split('?')[1];
      
      let currentProjectIdentifier = '';
      let currentToken = '';
      
      if (projectId2 && token2) {
        // Personalized URL format: ?Project_ID=123&Token=abc
        currentProjectIdentifier = `project_${projectId2}`;
        currentToken = token2;
      } else if (urlParts && urlParts.includes('=')) {
        // Generalized URL format: ?projectName=tokenValue
        const [projectName, tokenValue] = urlParts.split('=');
        currentProjectIdentifier = `generalized_${projectName}`;
        currentToken = tokenValue;
      }
      
      const storedProjectIdentifier = localStorage.getItem('lastVisitedProject');
      const storedToken = localStorage.getItem('lastVisitedToken');
      
      // Check if project has changed (either different project ID or different generalized project)
      const projectChanged = storedProjectIdentifier && storedProjectIdentifier !== currentProjectIdentifier;
      const tokenChanged = storedToken && storedToken !== currentToken;
      
      if (projectChanged || tokenChanged) {
        return;
      }
      
      const user_Id = localStorage.getItem('user_id');
      const perProject_ID = localStorage.getItem('project_IDper');
      const gen_ID = localStorage.getItem('gen_ID');
      
      // Generalized create-account flow may only have user_id + gen_ID (no Project_ID /
      // project_IDper). Still fetch respondent details whenever both are present.
      if (user_Id && gen_ID) {
        setLoading(true);
        maverickPortalhttp
          .makeRequest(
            `${maverickPortalApiEndPoint.getWeblinkRespondentDetails.url}/${user_Id}/${gen_ID}`,
            maverickPortalApiEndPoint.getWeblinkRespondentDetails.methodType,
            { user_ID: user_Id, alphaNumericLink: gen_ID }
          )
          .then(response => {
            let deferLoadingClearToFormQuestionsFetch = false;
            // Check if statusCode is -1 and log to Mixpanel
            if (response.data?.Status?.StatusCode === '-1') {
               setFetchErrorKind('respondentDetails');
            setLoading(false);
            const user_ID = localStorage.getItem('user_id');
            const gen_ID = localStorage.getItem('gen_ID');
            mixPanel.track('Fetch Respondent Details', {
              error: response?.data?.Status?.StatusDesc || 'Fetch respondent details failed with status -1',
              userId: user_ID || 'unknown',
              genId: gen_ID || 'unknown',
              projectId: projectId || 'unknown',
              token: token1 || 'unknown',
              perProjectId: perProject_ID || 'unknown',
              errorCode: 444,
              errorDetails: getResponseSummary(response),
              endpoint: `${maverickPortalApiEndPoint.getWeblinkRespondentDetails.url}/${user_Id}/${gen_ID}`,
              timestamp: new Date().toISOString(),
              request: { user_ID: user_Id, alphaNumericLink: gen_ID }
            });
            }else{
              setIsReferral(response.data?.Response?.referralCode);
              // Extract project name from the nested response structure
              const projectNameArray = response.data?.Response?.projectName || [];
              const projectName = projectNameArray[0]?.projectIdentity || 'Project';
              setProjectName(projectNameArray);
              setProfileAllow(response.data?.Response?.isProfileBuilderAllow);
              setProfileFilled(response.data?.Response?.profileStatus);
              const tasks = Array.isArray(response.data?.Response?.Tasks)
                ? response.data.Response.Tasks
                : [];
              const allFormTasksPending =
                tasks.length > 0 &&
                tasks.every(task => Number(task?.selectRespondentFormTask) === 0);
              const anyFormTaskCompleted = tasks.some(
                task => Number(task?.selectRespondentFormTask) === 1
              );
              if (
                response.data?.Response.selectRespondentDetails == null ||
                response.data?.Response.selectRespondentDetails == 0
              ) {
                setShowWelcomeScreen(true);
                //screener text will visble on progresbar
              } else if (
                response.data?.Response.selectRespondentDetails == 1 &&
                response.data?.Response.isConfirmed == 1 &&
                allFormTasksPending
              ) {
                setScreenerSubmitted(true);
                //form text will visible in progress bar
                deferLoadingClearToFormQuestionsFetch = true;
                fetchFormQuestions();
              } else if (
                response.data?.Response.selectRespondentDetails == 1 &&
                response.data?.Response.isConfirmed == 0
              ) {
                setResponseType('reject');
                setResponseMessage('Sorry unable to sign you up');
                setScreenerReject(true);
              } else if (
                response.data?.Response.selectRespondentDetails == 1 &&
                response.data?.Response.isConfirmed == null
              ) {
                setResponseType('complete');
                setResponseMessage('Thank you! We will notify you on your apllication status');
                // setScreenerReject(true);
              } else if (
                response.data?.Response.selectRespondentDetails == 1 &&
                response.data?.Response.isConfirmed == 1 &&
                anyFormTaskCompleted
              ) {
                // Set timer to clear data and go to login after 60 seconds
                formClearTimerRef.current = setTimeout(() => {
                  clearAllDataAndShowAuth();
                }, 60000); // 60 seconds

                setResponseType('complete');
                setResponseMessage('Thank you! Your form has been submitted successfully.');
              }
              
            }
            if (!deferLoadingClearToFormQuestionsFetch) {
              setLoading(false);
            }
           
          })
          .catch(err => {
            console.error('Questions API error:', err);
            const errorReason = err.response?.data?.Status?.StatusDesc || err.response?.data?.message || err.message || 'Unknown error';
            const user_ID = localStorage.getItem('user_id');
            const gen_ID = localStorage.getItem('gen_ID');
            mixPanel.track('Fetch Respondent Details', {
              error: `error from fetcing respondent details: ${errorReason}`,
              userId: user_ID || 'unknown',
              genId: gen_ID || 'unknown',
              projectId: projectId || 'unknown',
              token: token1 || 'unknown',
              perProjectId: perProject_ID || 'unknown',
              errorCode: 444,
              errorDetails: getResponseSummary(err),
              endpoint: `${maverickPortalApiEndPoint.getWeblinkRespondentDetails.url}/${user_Id}/${gen_ID}`,
              timestamp: new Date().toISOString(),
              request: { user_ID: user_Id, alphaNumericLink: gen_ID }
            });
            setFetchErrorKind('respondentDetails');
            setLoading(false);
          });
      }
    };

    if (isAuthenticated) {
      fetchRespondentDetails();
    }
  }, [projectId, token1, isAuthenticated]);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [projectClosedVariant, setProjectClosedVariant] = useState('ended');

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Weblink validation function
  const validateWeblink = async () => {
    // First validate URL format
    const urlValidation = validateWebLinkUrl();
    if (!urlValidation.isValid) {
      console.error('URL validation failed:', urlValidation.error);
      setShowInvalidProjectScreen(true);
      setShowAuthPopup(false);
      setShowProjectClosedScreen(false);
      setIsAuthenticated(false);
      setShowWelcomeScreen(false);
      setIsValidatingWeblink(false);
      return;
    }

    // Use validated identificationID from URL validation
    const validatedIdentificationID = urlValidation.identificationID;
    const validatedProjectIdentity = urlValidation.projectname || urlValidation.projectId;
    
    if (!validatedIdentificationID) {
      console.error('No URL parameter found after ? mark');
      setIsValidatingWeblink(false);
      return;
    }

    try {
      setIsValidatingWeblink(true);
      const payload = {
        identificationID: validatedIdentificationID,
        projectIdentity: validatedProjectIdentity
      };

      const response = await maverickPortalhttp.makeRequest(
        maverickPortalApiEndPoint.weblinkValidation.url,
        maverickPortalApiEndPoint.weblinkValidation.methodType,
        payload
      );
      console.log("heyy",response)
      if (response && response.data.Status && response.data.Status.StatusCode === "-1") {
        if (response.data.Response) {
          console.log("heyy2",response.Response)
          const projectStatusText = String(response.data.Response.projectStatus ?? '').toLowerCase();
          const projectEndVal = response.data.Response.projectEnd;
          const isProjectEndZero = projectEndVal === 0 || projectEndVal === '0';
          const isProjectFull =
            projectStatusText.includes('full');
          const accessLoginVal = response.data.Response.accessLogin;
          const isAccessLoginBlocked = accessLoginVal === 0 || accessLoginVal === '0';
          if (isProjectEndZero || isProjectFull || isAccessLoginBlocked) {
            // Update ref to track validation status
            weblinkValidationRef.current = { validated: true, projectClosed: true, invalidProject: false };
            // Set project closed screen to true and disable all other states
            setProjectClosedVariant(isProjectFull || isAccessLoginBlocked ? 'full' : 'ended');
            setShowProjectClosedScreen(true);
            setShowAuthPopup(false);
            setShowInvalidProjectScreen(false);
            setIsAuthenticated(false);
            setShowWelcomeScreen(false);
            setLoading(false);
            setResponseType('');
            setResponseMessage('');
            setIsValidatingWeblink(false);
            return;
          }
          
          // Check for invalid project link
          if (response.data.Response.isAvaliableProjectFlag === 0) {
            // Update ref to track validation status
            weblinkValidationRef.current = { validated: true, projectClosed: false, invalidProject: true };
            // Set invalid project screen to true and disable all other states
            setShowInvalidProjectScreen(true);
            setShowAuthPopup(false);
            setShowProjectClosedScreen(false);
            setIsAuthenticated(false);
            setShowWelcomeScreen(false);
            setLoading(false);
            setResponseType('');
            setResponseMessage('');
            setIsValidatingWeblink(false);
            return;
          }
        }
      }
      
      // Mark validation as complete if we reach here (project is valid)
      weblinkValidationRef.current = { validated: true, projectClosed: false, invalidProject: false };
      setIsValidatingWeblink(false);
    } catch (error) {
      console.error('Error validating weblink:', error);
      setIsValidatingWeblink(false);
      // Handle error - could show a generic error screen
    }
  };

  const checkAuthentication = () => {
    // Don't show auth popup if project is closed or invalid (check ref for immediate status)
    if (weblinkValidationRef.current.projectClosed || weblinkValidationRef.current.invalidProject) {
      setShowAuthPopup(false);
      setIsAuthenticated(false);
      return;
    }
    
    // Check if project or token has changed - if so, show auth popup
    const currentUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    const projectId2 = urlParams.get('Project_ID');
    const token2 = urlParams.get('Token');
    const urlParts = currentUrl.split('?')[1];
    
    let currentProjectIdentifier = '';
    let currentToken = '';
    
    if (projectId2 && token2) {
      // Personalized URL format: ?Project_ID=123&Token=abc
      currentProjectIdentifier = `project_${projectId2}`;
      currentToken = token2;
    } else if (urlParts && urlParts.includes('=')) {
      // Generalized URL format: ?projectName=tokenValue
      const [projectName, tokenValue] = urlParts.split('=');
      currentProjectIdentifier = `generalized_${projectName}`;
      currentToken = tokenValue;
    }
    
    const storedProjectIdentifier = localStorage.getItem('lastVisitedProject');
    const storedToken = localStorage.getItem('lastVisitedToken');
    
    // Check if project has changed (either different project ID or different generalized project)
    const projectChanged = storedProjectIdentifier && storedProjectIdentifier !== currentProjectIdentifier;
    const tokenChanged = storedToken && storedToken !== currentToken;
    
    if (projectChanged || tokenChanged) {
      console.log('🔄 Project/token changed detected in checkAuthentication - showing auth popup');
      setShowAuthPopup(true);
      setIsAuthenticated(false);
      return;
    }
    
    const token = localStorage.getItem('token');
    const isLoggedIn = token && token !== 'null' && token !== '';
    setIsAuthenticated(isLoggedIn);

    if (!isLoggedIn) {
      setShowAuthPopup(true);
    }
  };

  const LikertScaleContainer = styled.div`
    width: 100%;
  `;

  const ScaleLabels = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 0 5px;
  `;

  const ScaleLabel = styled.div`
    font-size: 11px;
    color: #666;
  `;

  const BoxContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 5px;
  `;

  const BoxButton = styled.button`
    flex: 1;
    height: 35px;
    margin: 0 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    border: 1px solid;
    background-color: ${props => (props.isSelected ? props.color : '#f5f5f5')};
    color: ${props => (props.isSelected ? '#FFFFFF' : props.color)};
    cursor: pointer;
    font-weight: bold;
    font-size: 14px;
    transition: all 0.2s ease;

    &:hover {
      opacity: 0.9;
    }
  `;

  const shuffleArray = (items) => {
    const shuffled = [...items];
    for (let i = shuffled.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  // Shuffle only items whose flag is 1; every other item stays in place.
  const shuffleFlaggedBy = (items, isFlagged) => {
    const shuffleIndices = items.reduce((acc, item, index) => {
      if (isFlagged(item)) acc.push(index);
      return acc;
    }, []);

    if (shuffleIndices.length <= 1) {
      return items;
    }

    const shuffledFlagged = shuffleArray(shuffleIndices.map(index => items[index]));
    const result = [...items];
    shuffleIndices.forEach((originalIndex, i) => {
      result[originalIndex] = shuffledFlagged[i];
    });
    return result;
  };

  const shuffleFlaggedChoices = choices =>
    shuffleFlaggedBy(choices, choice => Number(choice?.toShuffleChoice) === 1);

  const shuffleFlaggedScales = scales =>
    shuffleFlaggedBy(scales, scale => Number(scale?.shuffleScale) === 1);
 
  const isRankingAnswerSubmitted = questionId => {
    const answer = answers?.[questionId];
    return (
      Array.isArray(answer?.questionChoice_ID) &&
      answer.questionChoice_ID.length > 0 &&
      Array.isArray(answer?.questionRankScale_ID) &&
      answer.questionRankScale_ID.length > 0
    );
  };
 
  const isChoiceAnswerSubmitted = questionId => {
    const answer = answers?.[questionId];
    if (Array.isArray(answer)) {
      return answer.length > 0;
    }
    return answer !== undefined && answer !== null && answer !== '';
  };
 
  const applyRankingShuffleFromApi = sectionList => {
    const storedAnswers = readJsonStorage('form_answers');
    const answerMap = { ...storedAnswers, ...(answers || {}) };
    const savedOrders = readJsonStorage(LIKERT_SHUFFLE_ORDER_KEY);
    let ordersChanged = false;

    const nextSections = (sectionList || []).map(section => {
      const questions = Array.isArray(section.questionName_array) ? section.questionName_array : [];
      const orderedQuestions =
        Number(section.shuffleQuestion) === 1 && questions.length > 1
          ? shuffleArray(questions)
          : questions;

      return {
      ...section,
      questionName_array: orderedQuestions.map(question => {
        const questionTypeId = Number(question?.questionType_ID);
        const canShuffleInner = Number(question.toShuffle) === 1;

        // Likert: inner shuffles run only when toShuffle is 1.
        // toShuffleChoice shuffles those choice rows; shuffleScale shuffles dropdown options.
        // Scales are one shared list, and flagged choices shuffle as one group, so the
        // order is saved and restored once any choice is answered.
        if (questionTypeId === 4 && canShuffleInner) {
          const likertAnswered = (question.choiceName_array || []).some(choice =>
            isLikertChoiceAnswered(answerMap[`${question.question_ID}_${choice.choiceName_ID}`])
          );
          const saved = savedOrders[String(question.question_ID)];

          if (likertAnswered && saved) {
            const restoredChoices = orderItemsByIds(
              question.choiceName_array,
              saved.choiceIds,
              'choiceName_ID'
            );
            const restoredScales = orderItemsByIds(
              question.likertScaleName_array,
              saved.scaleIds,
              'questionLikertScale_ID'
            );
            return {
              ...question,
              choiceName_array: restoredChoices || question.choiceName_array,
              likertScaleName_array: restoredScales || question.likertScaleName_array,
            };
          }

          if (likertAnswered) {
            savedOrders[String(question.question_ID)] = {
              choiceIds: (question.choiceName_array || []).map(choice => choice.choiceName_ID),
              scaleIds: (question.likertScaleName_array || []).map(scale => scale.questionLikertScale_ID),
            };
            ordersChanged = true;
            return question;
          }

          const nextChoices = Array.isArray(question.choiceName_array)
            ? shuffleFlaggedChoices(question.choiceName_array)
            : question.choiceName_array;
          const nextScales = Array.isArray(question.likertScaleName_array)
            ? shuffleFlaggedScales(question.likertScaleName_array)
            : question.likertScaleName_array;
          savedOrders[String(question.question_ID)] = {
            choiceIds: (nextChoices || []).map(choice => choice.choiceName_ID),
            scaleIds: (nextScales || []).map(scale => scale.questionLikertScale_ID),
          };
          ordersChanged = true;

          return {
            ...question,
            choiceName_array: nextChoices,
            likertScaleName_array: nextScales,
          };
        }

        const isShuffleSupportedType = [1, 2, 7, 14].includes(questionTypeId) && canShuffleInner;
        if (!isShuffleSupportedType || !Array.isArray(question?.choiceName_array)) {
          return question;
        }
 
        const isAlreadyAnswered =
          questionTypeId === 14
            ? isRankingAnswerSubmitted(question.question_ID)
            : isChoiceAnswerSubmitted(question.question_ID);
 
        // Once answered/submitted, keep stable order (no reshuffle on refresh).
        if (isAlreadyAnswered) {
          return question;
        }
 
        return {
          ...question,
          choiceName_array: shuffleFlaggedChoices(question.choiceName_array),
        };
      }),
    };
    });

    if (ordersChanged) {
      try {
        localStorage.setItem(LIKERT_SHUFFLE_ORDER_KEY, JSON.stringify(savedOrders));
      } catch {
        // Ignore storage failures; shuffle still applies for this load.
      }
    }

    return nextSections;
  };

  const fetchQuestions = () => {//screener question
    setLoading(true);
    setFetchErrorKind(null);
    const user_Id = localStorage.getItem('user_id');
    const gen_ID = localStorage.getItem('gen_ID');
    
    // Use gen_ID from localStorage for API calls
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.getWeblinkScreenerQuestions.url,
        maverickPortalApiEndPoint.getWeblinkScreenerQuestions.methodType,
        { user_ID: user_Id, alphaNumericLink: gen_ID }
      )
      .then(response => {
        if (
          response.data?.Status?.StatusCode === '1' &&
          Array.isArray(response.data?.Response?.GetProjectTaskQuestions)
        ) {
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }, 100);
          const screenerSections = applyRankingShuffleFromApi(
            response.data.Response.GetProjectTaskQuestions
          );
          setSections(screenerSections);
        } else {
        const user_ID = localStorage.getItem('user_id');
        const gen_ID = localStorage.getItem('gen_ID');
        const perProject_ID = localStorage.getItem('project_IDper');
        mixPanel.track('Screener Questions fetch Falied', {
          error: response?.data?.Status?.StatusDesc || 'Failed to fetch screener questions',
          userId: user_ID || 'unknown',
          genId: gen_ID || 'unknown',
          perProjectId: perProject_ID || 'unknown',
          projectId: projectId || 'unknown',
          errorCode: 445,
          errorDetails: getResponseSummary(response),
          endpoint: maverickPortalApiEndPoint.getWeblinkScreenerQuestions.url,
          timestamp: new Date().toISOString(),
          request: { user_ID: user_Id, alphaNumericLink: gen_ID }
        });
        setFetchErrorKind('screener');
        setLoading(false);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Questions API error:', err);
        const errorReason = err.response?.data?.Status?.StatusDesc || err.response?.data?.message || err.message || 'Unknown error';
        const user_ID = localStorage.getItem('user_id');
        const gen_ID = localStorage.getItem('gen_ID');
        const perProject_ID = localStorage.getItem('project_IDper');
        mixPanel.track('Screener Questions fetch Falied', {
          error: `error from screener data: ${errorReason}`,
          userId: user_ID || 'unknown',
          genId: gen_ID || 'unknown',
          perProjectId: perProject_ID || 'unknown',
          projectId: projectId || 'unknown',
          errorCode: 445,
          errorDetails: getResponseSummary(err),
          endpoint: maverickPortalApiEndPoint.getWeblinkScreenerQuestions.url,
          timestamp: new Date().toISOString(),
          request: { user_ID: user_Id, alphaNumericLink: gen_ID }
        });
        setFetchErrorKind('screener');
        setLoading(false);
      });
  };

  const handleCreateAccount = () => {
    const currentUrl = window.location.href;
    const projectName = currentUrl.split('?')[1]?.split('=')[0] || '';
    const token5 = currentUrl.split('=')[1] || '';
    if (!projectId) {
      navigate(`/sign-up?${projectName}=${token5}`);
    } else {
      navigate(`/sign-up?Project_ID=${projectId}&Token=${token1}`);
    }
  };

  const handleSignIn = () => {
    const currentUrl = window.location.href;
    const projectName = currentUrl.split('?')[1]?.split('=')[0] || '';
    const token5 = currentUrl.split('=')[1] || '';
    if (!projectId) {
      navigate(`/login-Resp?${projectName}=${token5}`);
    } else {
      navigate(`/login-Resp?Project_ID=${projectId}&Token=${token1}`);
    }
  };

  // Utility: compare operations for type 3, 11
  const compareValue = (operation, userValue, endValue) => {
  const user = Number(userValue);
  const end = Number(endValue);
  switch (operation) {
    case 'IsEqualTo':
      return user === end;
    case 'IsLessThan':
      return user < end;
    case 'IsMoreThan':
      return user > end;
    case 'IsEqualToOrLessThan':
      return user <= end;
    case 'IsEqualToOrMoreThan':
      return user >= end;
    default:
      return false;
  }
};


  // End Survey skip logic
  const checkEndSurveyCondition = (question, answer, allAnswers) => {
    if (!question) return false;
    const qType = question.questionType_ID;
    // 1,2,7: choice-based
    if ([1, 2, 7].includes(qType)) {
      if (Array.isArray(question.choiceName_array)) {
        for (const choice of question.choiceName_array) {
          if (choice.EndSurvey) {
            if (Array.isArray(answer) && answer.includes(choice.choiceName_ID)) return true;
            if (answer === choice.choiceName_ID) return true;
          }
        }
      }
    }
    // 3, 11: slider/numeric (CompareValueArray is object)
    if ([3, 11].includes(qType)) {
      if (question?.CompareValueArray && typeof question.CompareValueArray === 'object') {
        for (const key of Object.keys(question.CompareValueArray)) {
          const arr = question.CompareValueArray[key];
          if (Array.isArray(arr) && arr[0] && arr[0].EndSurvey != null) {
            const op = question.MSTCompatibility_IDs?.[parseInt(key, 10)-1]?.Operations
            if (op && compareValue(op, answer, arr[0].EndSurvey)) return true;
          }
        }
      }
    }
    // 4: Likert
    if (qType === 4) {
      if (Array.isArray(question.choiceName_array) && Array.isArray(question.likertScaleName_array)) {
        for (const choice of question.choiceName_array) {
          if (choice.EndSurvey) {
            const idx = question.likertScaleName_array.findIndex(
              scale => scale.questionLikertScale_ID === choice.EndSurvey
            );
            const compositeKey = `${question.question_ID}_${choice.choiceName_ID}`;
            const expectedScaleId = question.likertScaleName_array[idx]?.questionLikertScale_ID;
            if (idx !== -1 && likertAnswerIncludesScale(allAnswers[compositeKey], expectedScaleId)) {
              return true;
            }
          }
        }
      }
    }
    // 5, 6: text
    if ([5, 6].includes(qType)) {
      if (typeof question.EndSurvey === 'string') {
        if (typeof answer === 'string' && answer.toLowerCase().includes(question.EndSurvey.toLowerCase())) {
          return true;
        }
      }
    }
    if (qType === 16) {
      if (Array.isArray(question.choiceName_array) && Array.isArray(question.likertScaleName_array)) {
        for (const choice of question.choiceName_array) {
          if (choice.EndSurvey) {
            const idx = question.likertScaleName_array.findIndex(
              scale => scale.questionLikertScale_ID === choice.EndSurvey
            );
            if (answer === idx) return true;
          }
        }
      }
    }

    if (qType === 14){
      if (question?.CompareValueArray && typeof question.CompareValueArray === 'object') {
        for (const key of Object.keys(question.CompareValueArray)) {
          const arr = question.CompareValueArray[key];
          if (
            Array.isArray(arr) &&
            arr[0] &&
            arr[0].EndSurvey &&
            typeof arr[0].EndSurvey === 'object' &&
            answer &&
            Array.isArray(answer.questionChoice_ID)
          ) {
            const choiceId = Object.keys(arr[0].EndSurvey)[0];
            const likertId = arr[0].EndSurvey[choiceId];
            // Find the index of choiceId in the user's ranking array
            const userRankIndex = answer.questionChoice_ID.findIndex(
              id => String(id) === String(choiceId)
            );
            // Get the operation for this key
            const op = question.MSTCompatibility_IDs?.[parseInt(key, 10) - 1]?.Operations;
            // Compare the user's rank index with the likertId using the operation
            if (
              op &&
              userRankIndex !== -1 &&
              compareValue(op, userRankIndex, likertId)
            ) {
              return true;
            }
          }
        }
      }
      // Fallback: legacy logic
      if (Array.isArray(question.choiceName_array) && Array.isArray(question.likertScaleName_array)) {
        for (const choice of question.choiceName_array) {
          if (choice.EndSurvey) {
            const idx = question.likertScaleName_array.findIndex(
              scale => scale.questionLikertScale_ID === choice.EndSurvey
            );
            if (answer === idx) return true;
          }
        }
      }
    }
    return false;
  };

  const checkAnyEndSurvey = (answersObj) => {
    for (const section of sections) {
      for (const question of section.questionName_array) {
        const answer = answersObj[question.question_ID];
        if (checkEndSurveyCondition(question, answer, answersObj)) {
          return true;
        }
      }
    }
    return false;
  };

  const updateRespondentTaskStatusOnceInFlightRef = useRef(false);
  const ensureRespondentTaskStatusUpdatedOnce = useCallback(
    async questionId => {
      const userId = localStorage.getItem('user_id') || 'unknown';
      const perProjectId = localStorage.getItem('project_IDper') || 'unknown';
      const genId = localStorage.getItem('gen_ID') || 'unknown';
      const storageKey = `weblink:updateRespondentTaskStatus:once:${perProjectId}:${genId}:${userId}`;
      try {
        if (localStorage.getItem(storageKey) === '1') return;
        if (updateRespondentTaskStatusOnceInFlightRef.current) return;
        if (!questionId) return;

        updateRespondentTaskStatusOnceInFlightRef.current = true;
        localStorage.setItem(storageKey, '1');
        localStorage.setItem(`${storageKey}:ts`, new Date().toISOString());
        localStorage.setItem(`${storageKey}:qid`, String(questionId));

        const resp = await maverickPortalhttp.makeRequest(
          maverickPortalApiEndPoint.updateRespondentTaskStatus.url,
          maverickPortalApiEndPoint.updateRespondentTaskStatus.methodType,
          { question_ID: questionId }
        );

        void resp;
      } catch (e) {
        
      } finally {
        updateRespondentTaskStatusOnceInFlightRef.current = false;
      }
    },
    []
  );

  const getNextUnansweredLikertIndex = (question, startIndex, answerMap) => {
    const choices = question?.choiceName_array || [];
    for (let i = startIndex; i < choices.length; i += 1) {
      const compositeKey = `${question.question_ID}_${choices[i].choiceName_ID}`;
      const val = answerMap[compositeKey];
      if (!isLikertChoiceAnswered(val)) {
        return i;
      }
    }
    return -1;
  };

  const getNextLikertIndexAfterAnswer = (question, choiceIndex, answerMap) => {
    const fromNext = getNextUnansweredLikertIndex(question, choiceIndex + 1, answerMap);
    if (fromNext >= 0) return fromNext;
    return getNextUnansweredLikertIndex(question, 0, answerMap);
  };

  const handleAnswerChange = (questionId, value, isMultiple = false, options = {}) => {
    if (!options?.skipTaskStatusUpdate && screenerSubmitted) {
      ensureRespondentTaskStatusUpdatedOnce(questionId);
    }
    // Store current scroll position
    const scrollPosition = window.scrollY;
    // Likert uses composite questionId "123_456"; resolve parent id for DOM / media state
    const qidStr = String(questionId);
    const underscore = qidStr.indexOf('_');
    const baseQuestionId = underscore === -1 ? questionId : qidStr.slice(0, underscore);
    const currentQuestion = sections[currentSectionIndex]?.questionName_array.find(
      q => String(q.question_ID) === String(baseQuestionId)
    );

    // If this is a video question and it has been uploaded, don't modify its state
    if (
      currentQuestion?.questionType_ID === 13 &&
      (mediaUrls[baseQuestionId] || preAssignedImageUrls[baseQuestionId])
    ) {
      return;
    }

    setAnswers(prev => {
      const newAnswers = isMultiple
        ? {
            ...prev,
            [questionId]: prev[questionId]?.includes(value)
              ? prev[questionId].filter(v => v !== value)
              : [...(prev[questionId] || []), value]
          }
        : {
            ...prev,
            [questionId]: value
          };

      // Clear required-field UI when answered (same rules as validateCurrentSection)
      const questionElement = document.getElementById(`question-${baseQuestionId}`);
      if (questionElement) {
        const question = sections[currentSectionIndex]?.questionName_array.find(
          q => String(q.question_ID) === String(baseQuestionId)
        );

        if (question?.isRequired === 1) {
          const qParentId = question.question_ID;
          let isAnswered = false;
          if (question.questionType_ID === 4) {
            isAnswered = question.choiceName_array.every(choice => {
              const compositeKey = `${qParentId}_${choice.choiceName_ID}`;
              return isLikertChoiceAnswered(newAnswers[compositeKey]);
            });
          } else if (question.questionType_ID === 2) {
            isAnswered =
              Array.isArray(newAnswers[qParentId]) && newAnswers[qParentId].length > 0;
          } else if (MEDIA_QUESTION_TYPES.includes(question.questionType_ID)) {
            isAnswered =
              (newAnswers[qParentId] !== undefined &&
                newAnswers[qParentId] !== null &&
                newAnswers[qParentId] !== '') ||
              (mediaUrls[qParentId] !== undefined && mediaUrls[qParentId] !== null) ||
              (preAssignedImageUrls[qParentId] !== undefined &&
                preAssignedImageUrls[qParentId] !== null);
          } else if ([5, 6, 11].includes(question.questionType_ID)) {
            const val = newAnswers[qParentId];
            isAnswered =
              val !== undefined && val !== null && (typeof val !== 'string' || val.trim() !== '');
          } else {
            isAnswered =
              newAnswers[qParentId] !== undefined &&
              newAnswers[qParentId] !== null &&
              newAnswers[qParentId] !== '';
          }

          if (isAnswered) {
            questionElement.classList.remove('has-error');
            const errorMessage = questionElement.querySelector('.error-message');
            if (errorMessage && errorMessage.textContent.trim() === REQUIRED_QUESTION_ERROR_TEXT) {
              errorMessage.remove();
            }
          }
        }
      }
      // Restore scroll position after state update
      requestAnimationFrame(() => {
        window.scrollTo(0, scrollPosition);
      });
      // Check for End Survey in all answers
      if (checkAnyEndSurvey(newAnswers)) {
        // console.log("ffffffff")
        setEndSurveyTriggered(true);
      } else {
        setEndSurveyTriggered(false);
      }

      return newAnswers;
    });
  };

  useEffect(() => {
    const currentSection = sections[currentSectionIndex];
    if (!currentSection?.questionName_array?.length) return;

    const savedFormAnswers = JSON.parse(localStorage.getItem('form_answers') || '{}');
    const savedTextInputs = JSON.parse(localStorage.getItem('text_input_answers') || '{}');
    const mergedAnswers = { ...savedFormAnswers, ...savedTextInputs, ...answers };

    currentSection.questionName_array.forEach(question => {
      if (question.isRequired !== 1) return;
      if (!MEDIA_QUESTION_TYPES.includes(question.questionType_ID)) return;

      const qid = question.question_ID;
      const isAnswered =
        (mergedAnswers[qid] !== undefined &&
          mergedAnswers[qid] !== null &&
          mergedAnswers[qid] !== '') ||
        (mediaUrls[qid] !== undefined && mediaUrls[qid] !== null) ||
        (preAssignedImageUrls[qid] !== undefined && preAssignedImageUrls[qid] !== null);

      if (!isAnswered) return;

      const questionElement = document.getElementById(`question-${qid}`);
      if (!questionElement) return;
      const errorMessage = questionElement.querySelector('.error-message');
      if (errorMessage && errorMessage.textContent.trim() === REQUIRED_QUESTION_ERROR_TEXT) {
        questionElement.classList.remove('has-error');
        errorMessage.remove();
      }
    });
  }, [answers, mediaUrls, preAssignedImageUrls, currentSectionIndex, sections]);

const validateCurrentSection = () => {
  const currentSection = sections[currentSectionIndex];
  if (!currentSection?.questionName_array) return true;
 
  const savedFormAnswers = JSON.parse(localStorage.getItem('form_answers') || '{}');
  const savedTextInputs = JSON.parse(localStorage.getItem('text_input_answers') || '{}');
  const mergedAnswers = { ...savedFormAnswers, ...savedTextInputs, ...answers };
 
  let firstUnansweredQuestion = null;
  let hasUnansweredQuestions = false;
 
  // First pass: Check all questions and show error messages
  currentSection.questionName_array.forEach(question => {
    if (question.isRequired !== 1) return;
   
    let isAnswered = false;
   
    // For Likert scale questions (type 4)
    if (question.questionType_ID === 4) {
      isAnswered = question.choiceName_array.every(choice => {
        const compositeKey = `${question.question_ID}_${choice.choiceName_ID}`;
        return isLikertChoiceAnswered(mergedAnswers[compositeKey]);
      });
    }
    // For multiple choice questions (type 2)
    else if (question.questionType_ID === 2) {
      isAnswered = Array.isArray(mergedAnswers[question.question_ID]) &&
                  mergedAnswers[question.question_ID].length > 0;
    }
    // For media upload questions (8, 12, 13, 15) - not persisted to localStorage
    else if (MEDIA_QUESTION_TYPES.includes(question.questionType_ID)) {
      isAnswered = (mediaUrls[question.question_ID] !== undefined &&
                   mediaUrls[question.question_ID] !== null) ||
                  (preAssignedImageUrls[question.question_ID] !== undefined &&
                   preAssignedImageUrls[question.question_ID] !== null);
    }
    // For text questions (5: short text, 6: long text)
    else if ([5, 6, 11].includes(question.questionType_ID)) {
      const val = mergedAnswers[question.question_ID];
      isAnswered = val !== undefined && val !== null && (typeof val !== 'string' || val.trim() !== '');
    }
    // For all other question types (1, 3, 7, 14, 16 - single, slider, NPS, ranking)
    else {
      isAnswered = mergedAnswers[question.question_ID] !== undefined &&
                  mergedAnswers[question.question_ID] !== null &&
                  mergedAnswers[question.question_ID] !== '';
    }
 
    // Update error state for each question
    const questionElement = document.getElementById(`question-${question.question_ID}`);
    if (questionElement) {
      if (!isAnswered) {
        hasUnansweredQuestions = true;
        questionElement.classList.add('has-error');
       
        // Add or update the error message
        let errorMessage = questionElement.querySelector('.error-message');
        if (!errorMessage) {
          errorMessage = document.createElement('div');
          errorMessage.className = 'error-message';
          errorMessage.style.color = '#f44336';
          errorMessage.style.fontSize = '12px';
          errorMessage.style.marginTop = '4px';
          errorMessage.style.display = 'block';
          questionElement.appendChild(errorMessage);
        }
        errorMessage.textContent = REQUIRED_QUESTION_ERROR_TEXT;
       
        if (!firstUnansweredQuestion) {
          firstUnansweredQuestion = question;
        }
      } else {
        questionElement.classList.remove('has-error');
        // Remove error message if it exists
        const errorMessage = questionElement.querySelector('.error-message');
        if (errorMessage) {
          errorMessage.remove();
        }
      }
    }
  });
 
  if (firstUnansweredQuestion) {
    // Scroll to the first unanswered question
    const questionElement = document.getElementById(`question-${firstUnansweredQuestion.question_ID}`);
    if (questionElement) {
      const headerOffset = 100;
      const elementPosition = questionElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
 
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
 
      // Add a highlight effect
      questionElement.style.transition = 'background-color 0.3s ease';
      questionElement.style.backgroundColor = 'rgba(244, 67, 54, 0.1)';
      setTimeout(() => {
        questionElement.style.backgroundColor = '';
      }, 1000);
    }
  }
 
  return !hasUnansweredQuestions;
};
 

  const validateAllSections = () => {
    const currentSection = sections[currentSectionIndex];
    if (!currentSection?.questionName_array) return true;

    const savedFormAnswers = JSON.parse(localStorage.getItem('form_answers') || '{}');
    const savedTextInputs = JSON.parse(localStorage.getItem('text_input_answers') || '{}');
    const mergedAnswers = { ...savedFormAnswers, ...savedTextInputs, ...answers };

    let firstUnansweredQuestion = null;
    let hasUnansweredQuestions = false;

    // First pass: Check all questions and show error messages
    currentSection.questionName_array.forEach(question => {
      if (question.isRequired !== 1) return;

      let isAnswered = false;

      // For Likert scale questions (type 4)
      if (question.questionType_ID === 4) {
        isAnswered = question.choiceName_array.every(choice => {
          const compositeKey = `${question.question_ID}_${choice.choiceName_ID}`;
          return isLikertChoiceAnswered(mergedAnswers[compositeKey]);
        });
      }
      // For multiple choice questions (type 2)
      else if (question.questionType_ID === 2) {
        isAnswered = Array.isArray(mergedAnswers[question.question_ID]) && mergedAnswers[question.question_ID].length > 0;
      }
      // For media upload questions (8, 12, 13, 15) - not persisted to localStorage
      else if (MEDIA_QUESTION_TYPES.includes(question.questionType_ID)) {
        isAnswered =
          (mediaUrls[question.question_ID] !== undefined && mediaUrls[question.question_ID] !== null) ||
          (preAssignedImageUrls[question.question_ID] !== undefined &&
            preAssignedImageUrls[question.question_ID] !== null);
      }
      // For text questions (5: short text, 6: long text)
      else if ([5, 6, 11].includes(question.questionType_ID)) {
        const val = mergedAnswers[question.question_ID];
        isAnswered = val !== undefined && val !== null && (typeof val !== 'string' || val.trim() !== '');
      }
      // For all other question types (1, 3, 7, 14, 16)
      else {
        isAnswered =
          mergedAnswers[question.question_ID] !== undefined &&
          mergedAnswers[question.question_ID] !== null &&
          mergedAnswers[question.question_ID] !== '';
      }

      // Update error state for each question
      const questionElement = document.getElementById(`question-${question.question_ID}`);
      if (questionElement) {
        if (!isAnswered) {
          hasUnansweredQuestions = true;
          questionElement.classList.add('has-error');

          // Add or update the error message
          let errorMessage = questionElement.querySelector('.error-message');
          if (!errorMessage) {
            errorMessage = document.createElement('div');
            errorMessage.className = 'error-message';
            errorMessage.style.color = '#f44336';
            errorMessage.style.fontSize = '12px';
            errorMessage.style.marginTop = '4px';
            errorMessage.style.display = 'block';
            questionElement.appendChild(errorMessage);
          }
          errorMessage.textContent = REQUIRED_QUESTION_ERROR_TEXT;

          if (!firstUnansweredQuestion) {
            firstUnansweredQuestion = question;
          }
        } else {
          questionElement.classList.remove('has-error');
          // Remove error message if it exists
          const errorMessage = questionElement.querySelector('.error-message');
          if (errorMessage) {
            errorMessage.remove();
          }
        }
      }
    });

    if (firstUnansweredQuestion) {
      // Scroll to the first unanswered question
      const questionElement = document.getElementById(`question-${firstUnansweredQuestion.question_ID}`);
      if (questionElement) {
        const headerOffset = 100;
        const elementPosition = questionElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });

        // Add a highlight effect
        questionElement.style.transition = 'background-color 0.3s ease';
        questionElement.style.backgroundColor = 'rgba(244, 67, 54, 0.1)';
        setTimeout(() => {
          questionElement.style.backgroundColor = '';
        }, 1000);
      }
    }

    return !hasUnansweredQuestions;
  };

  // Helper function to check if required video questions that have been saved are uploaded
  // Only disables button if a video has been saved but not yet uploaded
  const checkRequiredVideoUploaded = () => {
    // If sections are not loaded yet, don't disable button
    if (!sections || sections.length === 0) return true;
    
    const currentSection = sections[currentSectionIndex];
    if (!currentSection?.questionName_array) return true;
    
    // If allQuestions is not populated yet, don't disable button
    if (!allQuestions || Object.keys(allQuestions).length === 0) return true;
    
    try {
      const visibleQuestions = getVisibleQuestions(currentSection, allQuestions);
      // If no visible questions or getVisibleQuestions fails, don't disable button
      if (!visibleQuestions || visibleQuestions.length === 0) return true;
      
      for (const question of visibleQuestions) {
        // Check for type 13 (video recording) and type 15 (video file upload)
        if ((question.questionType_ID === 13 || question.questionType_ID === 15) && question.isRequired === 1) {
          const questionId = question.question_ID;
          
          // Check if video has been saved
          // For type 13: videoBlobs or mediaUrls indicates video is saved
          // For type 15: mediaUrls indicates file is selected/compressed
          const videoSaved = 
            (question.questionType_ID === 13 && (videoBlobs[questionId] || mediaUrls[questionId])) ||
            (question.questionType_ID === 15 && mediaUrls[questionId]);
          
          // Only check upload status if video has been saved
          if (videoSaved) {
            // Check if video is uploaded (either pre-assigned or in success states)
            const hasVideoUploaded = preAssignedImageUrls[questionId] || 
                            videoUploadSuccess[questionId] ||
                            videoSuccess[questionId];
            // If video is saved but not uploaded, disable button
            if (!hasVideoUploaded) {
              return false;
            }
          }
          // If video hasn't been saved yet, don't disable button (user hasn't started)
        }
      }
    } catch (error) {
      // If there's any error, don't disable button (fail open)
      console.error('Error checking required video uploads:', error);
      return true;
    }
    
    return true;
  };

  // If user tries to start recording another video while one is saved but not yet submitted,
  // scroll to the pending question and show a dedicated error.
  const getPendingVideoQuestionId = (exceptQuestionId) => {
    const currentSection = sections[currentSectionIndex];
    if (!currentSection?.questionName_array) return null;

    // Only scan within currentSection; we also verify the element exists in the DOM
    // before returning so scroll target is valid.
    for (const q of currentSection.questionName_array) {
      if (!(q.questionType_ID === 13 || q.questionType_ID === 15)) continue;

      const qid = q.question_ID;
      if (qid === exceptQuestionId) continue;

      // "Record Again / Preview" state means user has a local recording/file selected,
      // but hasn't submitted/uploaded it to backend yet.
      const localRecordingExists =
        q.questionType_ID === 13
          ? Boolean(mediaUrls[qid] || videoBlobs[qid])
          : Boolean(selectedFiles[qid] || mediaUrls[qid] || videoBlobs[qid]);

      // Successful uploads are reflected by a backend URL.
      const backendUploadedUrl = Boolean(preAssignedImageUrls[qid]);

      if (localRecordingExists && !backendUploadedUrl) {
        const el = document.getElementById(`question-${qid}`);
        if (!el) continue;
        return qid;
      }
    }

    return null;
  };

  /** MP3: local preview / blob in mediaUrls but no backend URL yet (edge case); refs handle most cases */
  const getPendingAudioQuestionId = exceptQuestionId => {
    const currentSection = sections[currentSectionIndex];
    if (!currentSection?.questionName_array) return null;

    for (const q of currentSection.questionName_array) {
      if (q.questionType_ID !== 12) continue;
      const qid = q.question_ID;
      if (exceptQuestionId != null && String(qid) === String(exceptQuestionId)) continue;

      const backendUploadedUrl = Boolean(preAssignedImageUrls[qid]);
      const localBlobOrPreview = Boolean(mediaUrls[qid]);
      if (localBlobOrPreview && !backendUploadedUrl) {
        const el = document.getElementById(`question-${qid}`);
        if (!el) continue;
        return qid;
      }
    }
    return null;
  };

  const getUploadingQuestionId = () => {
    // Prefer explicit question id tracked when upload starts.
    if (activeMediaUploadingQuestionIdRef.current != null) {
      return activeMediaUploadingQuestionIdRef.current;
    }

    if (activeMp3UploadingQuestionIdRef.current != null) {
      return activeMp3UploadingQuestionIdRef.current;
    }

    // MP4 recorder upload fallback.
    const uploadingVideoQuestionId = Object.keys(videoUploading || {}).find(
      qid => videoUploading[qid]
    );
    if (uploadingVideoQuestionId != null) {
      return uploadingVideoQuestionId;
    }

    return null;
  };

  const MEDIA_FLOW_AUTO_DISMISS_MS = 5000;
  const MEDIA_FLOW_AUTO_DISMISS_MESSAGES = [
    'submit already recorded media',
    'media upload in progress. Please wait.',
  ];

  const showVideoSubmitFirstError = (questionId, customMessage = 'submit already recorded media') => {
    const questionElement = document.getElementById(`question-${questionId}`);
    if (!questionElement) return false;

    const key = String(questionId);
    const prevTimeout = mediaErrorDismissTimeoutsRef.current.get(key);
    if (prevTimeout != null) {
      clearTimeout(prevTimeout);
      mediaErrorDismissTimeoutsRef.current.delete(key);
    }

    questionElement.classList.add('has-error');

    let errorMessage = questionElement.querySelector('.error-message');
    if (!errorMessage) {
      errorMessage = document.createElement('div');
      errorMessage.className = 'error-message';
      errorMessage.style.color = '#f44336';
      errorMessage.style.fontSize = '12px';
      errorMessage.style.marginTop = '4px';
      errorMessage.style.display = 'block';
      questionElement.appendChild(errorMessage);
    }

    errorMessage.textContent = customMessage;

    // Scroll + highlight the pending question
    // NOTE: This page uses an inner scroll container (`RespondentFormRootContainer`),
    // so `window.scrollTo` may not make the message visible on mobile.
    try {
      questionElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      const headerOffset = 100;
      const elementPosition = questionElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }

    questionElement.style.transition = 'background-color 0.3s ease';
    questionElement.style.backgroundColor = 'rgba(244, 67, 54, 0.1)';
    setTimeout(() => {
      questionElement.style.backgroundColor = '';
    }, 1000);

    if (MEDIA_FLOW_AUTO_DISMISS_MESSAGES.includes(String(customMessage).trim())) {
      const timeoutId = setTimeout(() => {
        mediaErrorDismissTimeoutsRef.current.delete(key);
        const el = document.getElementById(`question-${questionId}`);
        if (!el) return;
        const msgEl = el.querySelector('.error-message');
        if (!msgEl) return;
        const t = (msgEl.textContent || '').trim();
        if (MEDIA_FLOW_AUTO_DISMISS_MESSAGES.includes(t)) {
          msgEl.textContent = '';
          msgEl.style.display = 'none';
          el.classList.remove('has-error');
        }
      }, MEDIA_FLOW_AUTO_DISMISS_MS);
      mediaErrorDismissTimeoutsRef.current.set(key, timeoutId);
    }

    return true;
  };

  const handleRequestStartAudioRecording = attemptQuestionId => {
    const pendingVideoQuestionId = getPendingVideoQuestionId(null);
    if (pendingVideoQuestionId != null) {
      showVideoSubmitFirstError(pendingVideoQuestionId);
      return false;
    }

    const pendingAudioFromState = getPendingAudioQuestionId(attemptQuestionId);
    if (pendingAudioFromState != null) {
      showVideoSubmitFirstError(pendingAudioFromState, 'submit already recorded media');
      return false;
    }

    const recordingId = activeMp3RecordingQuestionIdRef.current;
    const uploadingId = activeMp3UploadingQuestionIdRef.current;
    const blockId = recordingId != null ? recordingId : uploadingId;
    if (blockId == null) return true;

    if (String(blockId) !== String(attemptQuestionId)) {
      showVideoSubmitFirstError(blockId, 'submit already recorded media');
      return false;
    }

    return true;
  };

  const handleAudioRecordingStarted = qid => {
    activeMp3RecordingQuestionIdRef.current = qid;
  };

  const handleAudioRecordingStopped = qid => {
    if (String(activeMp3RecordingQuestionIdRef.current) === String(qid)) {
      activeMp3RecordingQuestionIdRef.current = null;
    }
  };

  const handleAudioUploadStart = qid => {
    activeMp3UploadingQuestionIdRef.current = qid;
  };

  const handleAudioUploadEnd = qid => {
    if (String(activeMp3UploadingQuestionIdRef.current) === String(qid)) {
      activeMp3UploadingQuestionIdRef.current = null;
    }
    if (String(activeMp3RecordingQuestionIdRef.current) === String(qid)) {
      activeMp3RecordingQuestionIdRef.current = null;
    }
  };

  const handleRequestStartRecording = attemptQuestionId => {
    const activeMp3Id = activeMp3RecordingQuestionIdRef.current ?? activeMp3UploadingQuestionIdRef.current;
    if (activeMp3Id != null && String(activeMp3Id) !== String(attemptQuestionId)) {
      showVideoSubmitFirstError(activeMp3Id, 'submit already recorded media');
      return false;
    }

    const pendingAudioId = getPendingAudioQuestionId(attemptQuestionId);
    if (pendingAudioId != null) {
      showVideoSubmitFirstError(pendingAudioId, 'submit already recorded media');
      return false;
    }

    const pendingQuestionId = getPendingVideoQuestionId(attemptQuestionId);
    if (!pendingQuestionId) return true;
    const shown = showVideoSubmitFirstError(pendingQuestionId);
    return !shown;
  };

 const handleNextClick = async () => {
  if (mediaUploading) {
    const uploadingQuestionId = getUploadingQuestionId();
    if (uploadingQuestionId != null) {
      showVideoSubmitFirstError(
        uploadingQuestionId,
        'media upload in progress. Please wait.'
      );
    }
    return;
  }

  const activeMp3Id = activeMp3RecordingQuestionIdRef.current ?? activeMp3UploadingQuestionIdRef.current;
  if (activeMp3Id != null) {
    showVideoSubmitFirstError(activeMp3Id, 'submit already recorded media');
    return;
  }

  const pendingAudioId = getPendingAudioQuestionId(null);
  if (pendingAudioId != null) {
    showVideoSubmitFirstError(pendingAudioId, 'submit already recorded media');
    return;
  }

   // If any visible required video is in "record again / preview but not submitted" state,
   // allow click but redirect user to submit that recording first.
   const pendingVideoQuestionId = getPendingVideoQuestionId(null);
   if (pendingVideoQuestionId) {
     showVideoSubmitFirstError(pendingVideoQuestionId);
     return;
   }

  const currentSection = sections[currentSectionIndex];
const savedFormAnswers = JSON.parse(localStorage.getItem('form_answers') || '{}');
const savedTextInputs = JSON.parse(localStorage.getItem('text_input_answers') || '{}');
const combinedAnswers = { ...savedFormAnswers, ...savedTextInputs, ...answers };

  const likertAnswerLog = (currentSection?.questionName_array || [])
    .filter(question => question.questionType_ID === 4)
    .map(question => {
      const storedByChoice = (question.choiceName_array || []).map(choice => {
        const compositeKey = `${question.question_ID}_${choice.choiceName_ID}`;
        return {
          choiceName: choice.choiceName,
          choiceName_ID: choice.choiceName_ID,
          compositeKey,
          storedValue: combinedAnswers[compositeKey] ?? null
        };
      });
      const questionChoice_ID = [];
      const questionLikertScale_ID = [];
      storedByChoice.forEach(choice => {
        const scaleSelections = Array.isArray(choice.storedValue)
          ? choice.storedValue
          : choice.storedValue
            ? [choice.storedValue]
            : [];
        scaleSelections.forEach(scaleId => {
          if (scaleId === undefined || scaleId === null || scaleId === '') return;
          questionChoice_ID.push(choice.choiceName_ID);
          questionLikertScale_ID.push(scaleId);
        });
      });
      return {
        question_ID: String(question.question_ID),
        questionType_ID: '4',
        LikertScaleType: question.LikertScaleType || question.scaleType || null,
        storedByChoice,
        payload: {
          question_ID: String(question.question_ID),
          questionType_ID: '4',
          questionChoice_ID,
          questionLikertScale_ID
        }
      };
    });
  // console.log('Likert answers on Next', likertAnswerLog);

   if (!validateCurrentSection()) return;

  let jumpSectionId = null;

  for (const question of currentSection.questionName_array) {
    const selectedAnswer = combinedAnswers[question.question_ID];

    // 1. Single choice (type 1, 7)
    if ([1, 7].includes(question.questionType_ID)) {
      const selectedChoice = question.choiceName_array.find(
        (c) => c.choiceName_ID === selectedAnswer
      );
      if (
        selectedChoice?.sectionAttached &&
        selectedChoice.sectionAttached.length > 0
      ) {
        jumpSectionId = Number(selectedChoice.sectionAttached[0]);
        break;
      }

    // 2. Multiple choice (type 2)
    } else if (question.questionType_ID === 2) {
      const selectedArray = selectedAnswer || [];
      for (const choiceId of selectedArray) {
        const selectedChoice = question.choiceName_array.find(
          (c) => c.choiceName_ID === choiceId
        );
        if (
          selectedChoice?.sectionAttached &&
          selectedChoice.sectionAttached.length > 0
        ) {
          jumpSectionId = Number(selectedChoice.sectionAttached[0]);
          break;
        }
      }
      if (jumpSectionId) break;

    // 3. Slider (type 3)
    } else if (
      question.questionType_ID === 3 &&
      question.CompareValueArray &&
      question.MSTCompatibility_IDs
    ) {
      const selectedValue = Number(selectedAnswer);
      for (const [opID, items] of Object.entries(question.CompareValueArray)) {
        const operation = question.MSTCompatibility_IDs.find(
          (op) => String(op.id) === opID
        )?.Operations;
        if (!operation) continue;

        for (const item of items) {
          const sectionAttached = item.sectionAttached || {};
          for (const [sectionId, compareValue] of Object.entries(sectionAttached)) {
            const compare = Number(compareValue);
            let match = false;
            switch (operation) {
              case "IsEqualTo": match = selectedValue === compare; break;
              case "IsLessThan": match = selectedValue < compare; break;
              case "IsMoreThan": match = selectedValue > compare; break;
              case "IsEqualToOrLessThan": match = selectedValue <= compare; break;
              case "IsEqualToOrMoreThan": match = selectedValue >= compare; break;
            }
            if (match) {
              jumpSectionId = Number(sectionId);
              break;
            }
          }
          if (jumpSectionId) break;
        }
        if (jumpSectionId) break;
      }

    // 4. NPS (type 16)
    } else if (
      question.questionType_ID === 16 &&
      question.choiceName_array?.length > 0
    ) {
      const selectedIndex = selectedAnswer;
      if (
        typeof selectedIndex === "number" &&
        question.likertScaleName_array?.[selectedIndex]
      ) {
        const selectedLikertId =
          question.likertScaleName_array[selectedIndex].questionLikertScale_ID;

        const choice = question.choiceName_array[0];
        if (choice?.sectionAttached) {
          for (const [sectionId, expectedLikertId] of Object.entries(choice.sectionAttached)) {
            if (Number(expectedLikertId) === Number(selectedLikertId)) {
              jumpSectionId = Number(sectionId);
              break;
            }
          }
        }
      }

    // 5. Likert scale (type 4)
    } else if (
      question.questionType_ID === 4 &&
      question.choiceName_array?.length > 0 &&
      question.likertScaleName_array?.length > 0
    ) {
      for (const choice of question.choiceName_array) {
        const compositeKey = `${question.question_ID}_${choice.choiceName_ID}`;
        const rawValue = combinedAnswers[compositeKey];
        const rawValues = Array.isArray(rawValue) ? rawValue : [rawValue];
        const storedAsScaleList = Array.isArray(rawValue);

        for (const candidate of rawValues) {
          let selectedLikertID = null;

          if (
            !storedAsScaleList &&
            typeof candidate === "number" &&
            question.likertScaleName_array[candidate]
          ) {
            selectedLikertID = question.likertScaleName_array[candidate].questionLikertScale_ID;
          } else if (
            question.likertScaleName_array.some(
              l => l.questionLikertScale_ID === candidate || String(l.questionLikertScale_ID) === String(candidate)
            )
          ) {
            selectedLikertID = candidate;
          }

          if (!selectedLikertID) continue;

          if (choice.sectionAttached) {
            for (const [sectionId, expectedLikertId] of Object.entries(choice.sectionAttached)) {
              if (Number(expectedLikertId) === Number(selectedLikertID)) {
                jumpSectionId = Number(sectionId);
                break;
              }
            }
          }
          if (jumpSectionId) break;
        }
        if (jumpSectionId) break;
      }

    // 6. Short/Long Text (type 5, 6)
    } else if (
      (question.questionType_ID === 5 || question.questionType_ID === 6) &&
      question.sectionAttached &&
      typeof selectedAnswer === "string"
    ) {
      for (const [sectionId, keyword] of Object.entries(question.sectionAttached)) {
        if (selectedAnswer.toLowerCase().includes(String(keyword).toLowerCase())) {
          jumpSectionId = Number(sectionId);
          break;
        }
      }
      if (jumpSectionId) break;

    }
        // 8. Ranking (type 14)
    else if (
      question.questionType_ID === 14 &&
      question.CompareValueArray &&
      question.MSTCompatibility_IDs &&
      combinedAnswers[question.question_ID]?.questionChoice_ID &&
      combinedAnswers[question.question_ID]?.questionRankScale_ID
    ) {
      const choiceIds = combinedAnswers[question.question_ID].questionChoice_ID;
      const rankIds = combinedAnswers[question.question_ID].questionRankScale_ID;

      // Map: { choiceID => rankNumber }
      const rankMap = {};
      choiceIds.forEach((choiceId, index) => {
        const rankScaleId = rankIds[index];
        const rankObj = question.RankScaleName_array.find(r => r.questionRankScale_ID === rankScaleId);
        if (rankObj) {
          rankMap[choiceId] = rankObj.questionRankScale;
        }
      });

      for (const [opID, items] of Object.entries(question.CompareValueArray)) {
        const operation = question.MSTCompatibility_IDs.find(op => String(op.id) === opID)?.Operations;
        if (!operation) continue;

        for (const item of items) {
          const sectionAttached = item.sectionAttached || {};
          for (const [sectionId, conditionMap] of Object.entries(sectionAttached)) {
            for (const [choiceId, expectedRank] of Object.entries(conditionMap)) {
              const actualRank = rankMap[choiceId];
              if (actualRank === undefined) continue;

              let match = false;
              switch (operation) {
                case "IsEqualTo": match = actualRank === expectedRank; break;
                case "IsLessThan": match = actualRank < expectedRank; break;
                case "IsMoreThan": match = actualRank > expectedRank; break;
                case "IsEqualToOrLessThan": match = actualRank <= expectedRank; break;
                case "IsEqualToOrMoreThan": match = actualRank >= expectedRank; break;
              }

              if (match) {
                jumpSectionId = Number(sectionId);
                break;
              }
            }
            if (jumpSectionId) break;
          }
          if (jumpSectionId) break;
        }
        if (jumpSectionId) break;
      }
    }

    // 7. Value type (type 11)
 else if (
      question.questionType_ID === 11 &&
      question.CompareValueArray &&
      question.MSTCompatibility_IDs
    ) {
      const selectedValue = Number(selectedAnswer);
      for (const [opID, items] of Object.entries(question.CompareValueArray)) {
        const operation = question.MSTCompatibility_IDs.find(
          (op) => String(op.id) === opID
        )?.Operations;
        if (!operation) continue;

        for (const item of items) {
          const section_ID = item?.section_ID || {};

          for (const [sectionId, compareValue] of Object.entries(section_ID)) {
            const compare = Number(compareValue);
            let match = false;

            switch (operation) {
              case "IsEqualTo": match = selectedValue === compare; break;
              case "IsLessThan": match = selectedValue < compare; break;
              case "IsMoreThan": match = selectedValue > compare; break;
              case "IsEqualToOrLessThan": match = selectedValue <= compare; break;
              case "IsEqualToOrMoreThan": match = selectedValue >= compare; break;
            }

            if (match) {
              jumpSectionId = Number(sectionId);
              break;
            }
          }
          if (jumpSectionId) break;
        }
        if (jumpSectionId) break;
      }
    }
  }

  // 🧠 If logic-based jump
  if (jumpSectionId) {
    const nextIdx = sections.findIndex(
      (section) => section.questionPaperSection_ID === jumpSectionId
    );
    if (nextIdx !== -1) {
      setSectionHistory(prev => [...prev, currentSectionIndex]); // ⬅️ Push current to history
      setCurrentSectionIndex(nextIdx);
      setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
      if (endSurveyTriggered) handleSubmit();
      return;
    }
  }

  // 🔁 Regular next
  setSectionHistory(prev => [...prev, currentSectionIndex]); // ⬅️ Push current to history
  setCurrentSectionIndex((prev) => prev + 1);
  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, 100);
  if (endSurveyTriggered) {
    // console.log("hiiiii0",endSurveyTriggered);
    handleSubmit();
  }
};

const handleBackClick = () => {
 if (mediaUploading) {
    const uploadingQuestionId = getUploadingQuestionId();
    if (uploadingQuestionId != null) {
      showVideoSubmitFirstError(
        uploadingQuestionId,
        'media upload in progress. Please wait.'
      );
    }
    return;
  }

  const activeMp3IdBack = activeMp3RecordingQuestionIdRef.current ?? activeMp3UploadingQuestionIdRef.current;
  if (activeMp3IdBack != null) {
    showVideoSubmitFirstError(activeMp3IdBack, 'submit already recorded media');
    return;
  }

  const pendingAudioIdBack = getPendingAudioQuestionId(null);
  if (pendingAudioIdBack != null) {
    showVideoSubmitFirstError(pendingAudioIdBack, 'submit already recorded media');
    return;
  }

   // If any visible required video is in "record again / preview but not submitted" state,
   // allow click but redirect user to submit that recording first.
   const pendingVideoQuestionId = getPendingVideoQuestionId(null);
   if (pendingVideoQuestionId) {
     showVideoSubmitFirstError(pendingVideoQuestionId);
     return;
   }


  if (sectionHistory.length > 0) {
    const lastIndex = sectionHistory[sectionHistory.length - 1];
    setSectionHistory((prev) => prev.slice(0, -1)); // ⬅️ Pop
    setCurrentSectionIndex(lastIndex);
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
  } else if (currentSectionIndex > 0) {
    setCurrentSectionIndex(prev => prev - 1);
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
  }
};

  const uploadAudio = async (audioBlob, questionId, questionTypeId, setUploadProgress, onMp3RetryAttempt) => {
    if (!navigator.onLine) {
      throw new Error('No internet connection');
    }
    setMediaUploading(true);
    activeMediaUploadingQuestionIdRef.current = questionId;
    const user_ID = localStorage.getItem('user_id');
    const formData = new FormData();
    
    // Convert blob to File with proper .mp3 extension
    // The backend expects .mp3 extension, so we use that regardless of actual audio format
    const blobType = audioBlob.type || 'audio/webm';
    const audioFile = new File([audioBlob], `audio_${questionId}.mp3`, {
      type: blobType, // Keep original mimeType for proper content-type header
      lastModified: Date.now()
    });
    
    formData.append('questionMP3', audioFile, `audio_${questionId}.mp3`);
    formData.append('user_ID', user_ID);
    formData.append('question_ID', questionId);
    formData.append('questionType_ID', questionTypeId);

    const retryCount = 3;
    let isUploading = false;

    const checkConnection = async () => {
      // Check if we're online
      if (!navigator.onLine) {
        return false;
      }

      // Check connection type if available
      if (navigator.connection) {
        const connection = navigator.connection;
        // Consider metered connections as potentially unreliable
        // if (connection.metered) {
        //   return false;
        // }
        // Consider slow connections as potentially unreliable
        // if (connection.downlink < 1) {
        //   return false;
        // }
      }

      return true;
    };

    const attemptUpload = async () => {
      if (isUploading) return; // Prevent multiple simultaneous uploads
      isUploading = true;

      try {
        const isConnected = await checkConnection();
        if (!isConnected) {
          const err = new Error('No internet connection');
          err.isMinusOne = false;
          throw err;
        }

        const response = await maverickPortalhttp.makeRequest(
          maverickPortalApiEndPoint.uploadQuestionMP3.url,
          maverickPortalApiEndPoint.uploadQuestionMP3.methodType,
          formData,
          {
            onUploadProgress: progressEvent => {
              const progress = progressEvent.loaded / progressEvent.total;
              setUploadProgress(progress);
            }
          }
        );
        if (response?.data?.Response?.preAssingedImageUrl || response?.data?.Response?.AWSAudioFilePath) {
          const audioUrl = response?.data?.Response?.preAssingedImageUrl || response?.data?.Response?.AWSAudioFilePath;
          
          // Update the preAssignedImageUrls state for the AudioRecorder component
          setPreAssignedImageUrls(prev => ({
            ...prev,
            [questionId]: audioUrl
          }));
          
          // Update audio upload success state
          setAudioUploadSuccess(prev => ({
            ...prev,
            [questionId]: true
          }));
          
          // Save the answer
          handleAnswerChange(questionId, audioUrl);
          
          // Set media uploading to false on success
          setMediaUploading(false);
          if (String(activeMediaUploadingQuestionIdRef.current) === String(questionId)) {
            activeMediaUploadingQuestionIdRef.current = null;
          }

          return response;
        } else {
          const statusCode = response?.data?.Status?.StatusCode;
          const isMinusOne = statusCode === '-1' || statusCode === -1;
          const err = new Error(response?.data?.Status?.StatusDesc || 'Audio upload failed');
          err.isMinusOne = isMinusOne;
          err.statusCode = statusCode;
          throw err;
        }
      } catch (error) {
        console.error('Audio upload error:', error);
        if (error.isMinusOne === undefined) {
          error.isMinusOne = false;
        }
        throw error;
      } finally {
        isUploading = false;
      }
    };

    try {
      await attemptUpload();
      return;
    } catch (error) {
      if (typeof onMp3RetryAttempt === 'function') {
        for (let attempt = 1; attempt <= retryCount; attempt += 1) {
          onMp3RetryAttempt({ attempt, isMinusOne: Boolean(error.isMinusOne) });
          if (attempt < retryCount) {
            await new Promise(resolve => setTimeout(resolve, 5000));
          }
        }
      }

      const user_ID = parseInt(localStorage.getItem('user_id'));
      const perProject_ID = localStorage.getItem('project_IDper');
      const projectsTask_ID = projectTask_ID;
      mixPanel.track('audio upload Failed', {
        userId: user_ID,
        perProjectId: perProject_ID,
        projectTaskId: projectsTask_ID,
        error: error?.message || 'Audio upload failed',
        projectName: projectName,
        ErrorCode: 423,
        errorDetails: getResponseSummary(error),
        timestamp: new Date().toISOString(),
        request: serializeFormData(formData),
      });

      if (String(activeMediaUploadingQuestionIdRef.current) === String(questionId)) {
        activeMediaUploadingQuestionIdRef.current = null;
      }

      setMediaUploading(false);

      setPreAssignedImageUrls(prev => {
        const next = { ...prev };
        delete next[questionId];
        return next;
      });

      setAudioUploadSuccess(prev => ({
        ...prev,
        [questionId]: false
      }));

      handleAnswerChange(questionId, null);

      setMediaUrls(prev => {
        const newUrls = { ...prev };
        delete newUrls[questionId];
        return newUrls;
      });
      setAudioBlobs(prev => {
        const newBlobs = { ...prev };
        delete newBlobs[questionId];
        return newBlobs;
      });
      setUploadProgress(0);
      const finalErr = new Error(
        error?.message || 'Upload failed after attempts. Please check your connection and try again.'
      );
      finalErr.mp3AllRetriesFailed = true;
      finalErr.mp3AllThreeAttemptsWereMinusOne = Boolean(error.isMinusOne);
      finalErr.mp3FinalAttempt = 3;
      throw finalErr;
    }
  };

  // Audio delete/reset handler used by AudioRecorder component
  const deleteAudio = async (questionId) => {
    try {
      if (!navigator.onLine) {
        alert('Network is down. Please try connecting to another network');
        return;
      }
      const user_ID = localStorage.getItem('user_id');
      const payload = { user_ID, question_ID: questionId };
      await maverickPortalhttp.makeRequest(
        maverickPortalApiEndPoint.deleteMedia.url,
        maverickPortalApiEndPoint.deleteMedia.methodType,
        payload
      );
      setMediaUrls(prev => {
        const newUrls = { ...prev };
        delete newUrls[questionId];
        return newUrls;
      });
      setAudioBlobs(prev => {
        const newBlobs = { ...prev };
        delete newBlobs[questionId];
        return newBlobs;
      });
      setRecordingStates(prev => {
        const newStates = { ...prev };
        delete newStates[questionId];
        return newStates;
      });
      setPreAssignedImageUrls(prev => {
        const newUrls = { ...prev };
        delete newUrls[questionId];
        return newUrls;
      });
      setAudioUploadSuccess(prev => {
        const newSuccess = { ...prev };
        delete newSuccess[questionId];
        return newSuccess;
      });
      handleAnswerChange(questionId, null);
    } catch (error) {
      console.error('Error deleting audio:', error);
      alert('Failed to delete the recording. Please try again.');
      throw error;
    }
  };

  const checkInternetConnection = () => {
    return new Promise(resolve => {
      // Check if we're offline
      if (!navigator.onLine) {
        resolve(false);
        return;
      }

      // If we have connection info, check the connection type
      if (navigator.connection) {
        const connection = navigator.connection;
        // Check if we have a valid connection type
        if (connection.effectiveType && connection.effectiveType !== 'unknown') {
          resolve(true);
          return;
        }
      }

      // If we can't determine connection type, fall back to navigator.onLine
      resolve(navigator.onLine);
    });
  };
  const createPayload = () => {
    const user_ID = parseInt(localStorage.getItem('user_id'));
    const perProject_ID = localStorage.getItem('project_IDper');
    const projectsTask_ID = projectTask_ID;
    const project_ID = perProject_ID;
    // const referralCode = "";
    const questionsPayload = [];
    const otherResponse = {};

    const savedFormAnswers = JSON.parse(localStorage.getItem('form_answers') || '{}');
    const savedTextInputs = JSON.parse(localStorage.getItem('text_input_answers') || '{}');
    const mergedAnswers = { ...savedFormAnswers, ...savedTextInputs, ...answers };

    sections.forEach(section => {
      section.questionName_array.forEach(question => {
        const qType = question.questionType_ID;
        const qID = String(question.question_ID);
        if (MEDIA_QUESTION_TYPES.includes(qType)) return; // Skip media - handled separately
        const answer = mergedAnswers[qID];

        let questionData = {
          question_ID: qID,
          questionType_ID: String(qType)
        };

        if (qType === 3) {
          // Slider type
          if (answer !== undefined && answer !== null) {
            questionData.choiceName = answer;
            questionsPayload.push(questionData);
          }
        } else if (qType === 14) {
          // Ranking type
          if (answer) {
            // Ensure we have both arrays for ranking
            if (Array.isArray(answer.questionChoice_ID) && Array.isArray(answer.questionRankScale_ID)) {
              questionData.questionChoice_ID = answer.questionChoice_ID;
              questionData.questionRankScale_ID = answer.questionRankScale_ID;
              questionsPayload.push(questionData);
            } else {
              console.warn('Invalid ranking answer format:', answer); // Debug log
            }
          } else {
            console.warn('No answer found for ranking question:', qID); // Debug log
          }
        } else if ([5, 6, 11].includes(qType)) {
          const textAnswer = answer && (typeof answer !== 'string' || answer.trim() !== '') ? answer : null;
          if (textAnswer) {
            if (qType === 11) {
              questionData.value = textAnswer;
            } else {
              questionData.answerText = textAnswer;
            }
            questionsPayload.push(questionData);
          }
        } else if (qType === 1 || qType === 2 || qType === 7) {
          if (answer !== undefined && answer !== null && (qType === 2 ? answer.length > 0 : true)) {
            questionData.questionChoice_ID = Array.isArray(answer) ? answer : [answer];
            questionsPayload.push(questionData);
          }
        } else if (qType === 4 || qType === 16) {
          // Handle both Likert and NPS
          const choiceIds = [];
          const scaleIds = [];

          // For NPS, we only have one choice
          if (qType === 16) {
            if (answer !== undefined && answer !== null) {
              // Use the first choice ID from the question's choice array
              const choiceId = question.choiceName_array[0]?.choiceName_ID;
              const scaleId = question.likertScaleName_array[answer]?.questionLikertScale_ID;

              if (choiceId && scaleId) {
                choiceIds.push(choiceId);
                scaleIds.push(scaleId);
              }
            }
          } else {
            // Likert: one scale id per choice, except Custom Likert which can select several.
            // Each selected scale repeats that choice id so the two arrays stay paired.
            question.choiceName_array.forEach(choice => {
              const compositeKey = `${qID}_${choice.choiceName_ID}`;
              const selectedScaleId = mergedAnswers[compositeKey];
              const scaleSelections = Array.isArray(selectedScaleId)
                ? selectedScaleId
                : selectedScaleId
                  ? [selectedScaleId]
                  : [];
              scaleSelections.forEach(scaleId => {
                if (scaleId === undefined || scaleId === null || scaleId === '') return;
                choiceIds.push(choice.choiceName_ID);
                scaleIds.push(scaleId);
              });
            });
          }

          if (choiceIds.length > 0 && scaleIds.length > 0) {
            questionData.questionChoice_ID = choiceIds;
            questionData.questionLikertScale_ID = scaleIds;
            questionsPayload.push(questionData);
          }
        }
      });
    });

    // Filter out any null values
    const filteredQuestionsPayload = questionsPayload.filter(question => question !== null);

    const finalPayload = {
      user_ID,
      projectsTask_ID,
      project_ID,
      referralCode: referralCodeState || '',
      otherResponse,
      questions: filteredQuestionsPayload
    };

    return finalPayload;
  };

 const handleSubmit = async () => {
    if (isCheckingConnection) return;

    if (mediaUploading) {
      const uploadingQuestionId = getUploadingQuestionId();
      if (uploadingQuestionId != null) {
        showVideoSubmitFirstError(
          uploadingQuestionId,
          'media upload in progress. Please wait.'
        );
      }
      return;
    }

    const activeMp3IdSubmit = activeMp3RecordingQuestionIdRef.current ?? activeMp3UploadingQuestionIdRef.current;
    if (activeMp3IdSubmit != null) {
      showVideoSubmitFirstError(activeMp3IdSubmit, 'submit already recorded media');
      return;
    }

    const pendingAudioIdSubmit = getPendingAudioQuestionId(null);
    if (pendingAudioIdSubmit != null) {
      showVideoSubmitFirstError(pendingAudioIdSubmit, 'submit already recorded media');
      return;
    }

    // Block submit until pending recording(s) are submitted
    const pendingVideoQuestionId = getPendingVideoQuestionId(null);
    if (pendingVideoQuestionId) {
      showVideoSubmitFirstError(pendingVideoQuestionId);
      return;
    }

    // window.scrollTo({ top: 0, behavior: 'smooth' });
    if (!validateAllSections()) return;
    setIsCheckingConnection(true)
    // Validate all sections before submitting
    const isConnected = await checkInternetConnection();
    if (!isConnected) {
      setIsCheckingConnection(false);
      // alert("No connection,. Please connect to internet and try again")
      setShowNoConnectionPopup(true);
      return;
    }
    const payload = createPayload();

    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.automatedWeblinkAnswer.url,
        maverickPortalApiEndPoint.automatedWeblinkAnswer.methodType,
        payload
      )
      .then(response => {
        const responseMessage = response.data?.Status?.StatusDesc || '';
        setIsCheckingConnection(false);
        // Check if response indicates successful screener submission
        if (
          (responseMessage.includes('no group matched') && responseMessage.includes('RESPONSE 69')) ||
          (responseMessage.includes('no profile builder matched') && responseMessage.includes('RESPONSE 71')) ||
          (responseMessage.includes('no profile or choices matched for any group') && responseMessage.includes('RESPONSE 70'))
        ) {
         setResponseType('complete');
            setResponseMessage('Thank you! We will notify you on your apllication status');
            clearAnswerStorageFromLocalStorage();
        } else if (responseMessage.includes('Screener Submitted Successfully.RESPONSE')) {
          const responseCode = responseMessage.split('RESPONSE ')[1];
          if (['1', '2', '22','10'].includes(responseCode)) {
            // Clear response UI so skeleton shows while form questions load (ResponseScreen has no "success" view)
            setResponseType('');
            setResponseMessage('');
            // Scroll while skeleton is visible (avoid visible jump after questions paint).
            scrollToTopImmediate();
            // Immediately fetch form questions and update states
            setLoading(true);
            setScreenerSubmitted(true);
            setCurrentSectionIndex(0); // Reset section index
            setAnswers({});
            setTextInputState({});
            clearAnswerStorageFromLocalStorage();
            fetchFormQuestions();
            // localStorage.clear();
          } else if (['66', '4','15'].includes(responseCode)) {
            setResponseType('reject');
            setResponseMessage('Sorry unable to sign you up');
            setScreenerReject(true);
            clearAnswerStorageFromLocalStorage();
            // localStorage.clear();

          } else if (response.data?.Response === 'Referral Code not matched please try again.') {
            setReferralCodeError(true);
            fetchQuestions();
            setCurrentSectionIndex(sections.length - 1);
            // localStorage.clear();
          } else if (responseMessage === 'Screener Submitted Successfully.') {
            setResponseType('complete');
            setResponseMessage('Thank you! We will notify you on your apllication status');
            clearAnswerStorageFromLocalStorage();

          } else {
            setResponseType('complete');
            setResponseMessage('Thank you! Your form has been submitted successfully.');
            clearAnswerStorageFromLocalStorage();

            // Set timer to clear data and go to login after 60 seconds
            formClearTimerRef.current = setTimeout(() => {
              clearAllDataAndShowAuth();
            }, 60000); // 60 seconds
          }
        } else if (
          response.data?.Status?.StatusCode === '-1' && 
          (responseMessage === 'Referral Code not matched please try again.' ||responseMessage === 'Referral Code not matched please try again.RESPONSE 12')
        ) {
          // Handle StatusCode "-1" with referral code error (without RESPONSE) - stay on same page, show error
          setReferralCodeError('Referral Code not matched please try again.');
          // Clear responseType to keep form visible
          setResponseType('');
          setResponseMessage('');
          fetchQuestions();
          setCurrentSectionIndex(sections.length - 1);
          // localStorage.clear();
        }else if( response.data?.Status?.StatusCode === '-1' && 
          (responseMessage === 'Your application is under review.RESPONSE 4' )){
              setResponseType('reject');
            setResponseMessage('Sorry unable to sign you up');
            setScreenerReject(true);
            clearAnswerStorageFromLocalStorage();
        } else if (
          response.data?.Status?.StatusCode === '-1' && 
          responseMessage.includes('Thanks for applying! Your application is under review.RESPONSE')
        ) {
          // Handle StatusCode "-1" with "Thanks for applying! Your application is under review.RESPONSE X" - applied status
          const responseCode = responseMessage.split('RESPONSE ')[1];
            if (['3'].includes(responseCode)) {
            setResponseType('reject');
            setResponseMessage('Sorry unable to sign you up');
            setScreenerReject(true);
            clearAnswerStorageFromLocalStorage();
            }else if(['11'].includes(responseCode)){
               setResponseType('complete');
          setResponseMessage('Thank you! We will notify you on your apllication status');
            clearAnswerStorageFromLocalStorage();
            }
        } else if (
          response.data?.Status?.StatusCode === '-1' && 
          responseMessage.includes('Referral Code not matched please try again.RESPONSE')
        ) {
          // Handle StatusCode "-1" with "Referral Code not matched please try again.RESPONSE X" format
          const responseCode = responseMessage.split('RESPONSE ')[1];
          if (responseCode === '12') {
            setReferralCodeError('Referral Code not matched please try again.');
            // Clear responseType to keep form visible
            setResponseType('');
            setResponseMessage('');
            fetchQuestions();
            setCurrentSectionIndex(sections.length - 1);
            // localStorage.clear();
          }
        } else if (response.data?.Status?.StatusCode === '-1') {
            const user_ID = parseInt(localStorage.getItem('user_id'));
        const perProject_ID = localStorage.getItem('project_IDper');
        const projectsTask_ID = projectTask_ID;
        mixPanel.track(projectsTask_ID == null ? 'Screener submission failed' : 'Form Submission Failed', {
          userId: user_ID,
          perProjectId: perProject_ID,
          projectTaskId: projectsTask_ID,
          error: response.data?.Status?.StatusDesc || 'Submission failed with status -1',
          projectName: projectName,
          ErrorCode: projectsTask_ID == null ? 420 : 421,
          errorDetails: getResponseSummary(response),
          timestamp: new Date().toISOString(),
          request:payload,
        });
          setLoading(false);
          setResponseType('');
          setResponseMessage('');
          toast.error('Submit failed', { containerId: WEBLINK_DASHBOARD_SUBMIT_TOAST_ID });

        } else if (responseMessage === 'Screener Submitted Successfully.') {
          setResponseType('complete');
          setResponseMessage('Thank you! We will notify you on your apllication status');
          clearAnswerStorageFromLocalStorage();

        } else {
          setResponseType('complete');
          setResponseMessage('Thank you! Your form has been submitted successfully.');
          clearAnswerStorageFromLocalStorage();

          // Set timer to clear data and go to login after 60 seconds
          formClearTimerRef.current = setTimeout(() => {
            clearAllDataAndShowAuth();
          }, 60000); // 60 seconds
        }
      })
      .catch(err => {
        setIsCheckingConnection(false);
        const user_ID = parseInt(localStorage.getItem('user_id'));
        const perProject_ID = localStorage.getItem('project_IDper');
        const projectsTask_ID = projectTask_ID;
        mixPanel.track(projectsTask_ID == null ? 'Screener submission failed' : 'Form Submission Failed', {
          userId: user_ID,
          perProjectId: perProject_ID,
          projectTaskId: projectsTask_ID,
          error: err?.message || 'Unknown error',
          projectName: projectName,
          ErrorCode: projectsTask_ID == null ? 420 : 421,
          errorDetails: getResponseSummary(err),
          timestamp: new Date().toISOString(),
          request:payload
        });
        console.error('Submission Failed:', err);
        setResponseType('');
        setResponseMessage('');
        toast.error('Submit failed', { containerId: WEBLINK_DASHBOARD_SUBMIT_TOAST_ID });
      });
    // Note: Answer storage is cleared only on success (in the formClearTimerRef callback via localStorage.clear())
    // Do NOT clear here - would wipe user data before we know if submit succeeded
  };


  const fetchFormQuestions = () => {
    // Keep viewport reset before data swap so users don't see a late scroll jump.
    scrollToTopImmediate();
    setLoading(true);
    setFetchErrorKind(null);
    const user_Id = localStorage.getItem('user_id');
    const gen_ID = localStorage.getItem('gen_ID');
    
    // Use gen_ID from localStorage for API calls
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.getWeblinkDesignQuestions.url,
        maverickPortalApiEndPoint.getWeblinkDesignQuestions.methodType,
        { user_ID: user_Id, alphaNumericLink: gen_ID }
      )
      .then(response => {
        if (
          response.data?.Status?.StatusCode === '1' &&
          Array.isArray(response.data?.Response?.ProjectTasks)
        ) {
          const projectTasks = response.data.Response.ProjectTasks;
          const firstTask = projectTasks[0];
          const formSections = (firstTask.questionPaperSections || []).map(section => ({
            ...section,
            projectsTask_ID: firstTask.projectsTask_ID,
            taskName: firstTask.taskName,
            taskDescription: firstTask.taskDescription,
            isTaskVisited: firstTask.isTaskVisited
          }));

           const shuffledFormSections = applyRankingShuffleFromApi(formSections);
          setSections(shuffledFormSections);
          if (formSections.length > 0) {
            setProjectTask_ID(formSections[0].projectsTask_ID);
          }
          setCurrentSectionIndex(0); // Reset to first section
          setResponseType(''); // Clear any previous response type
          setLoading(false);
        } else {
          const user_ID = localStorage.getItem('user_id');
          const gen_ID = localStorage.getItem('gen_ID');
          const perProject_ID = localStorage.getItem('project_IDper');
          mixPanel.track('Form Questions Fetch Failed', {
            error: response?.data?.Status?.StatusDesc || 'Failed to fetch form questions',
            userId: user_ID || 'unknown',
            genId: gen_ID || 'unknown',
            perProjectId: perProject_ID || 'unknown',
            projectId: projectId || 'unknown',
            errorCode: 446,
            errorDetails: getResponseSummary(response) ,
            endpoint: maverickPortalApiEndPoint.getWeblinkDesignQuestions.url,
            timestamp: new Date().toISOString(),
            request: { user_ID: user_Id, alphaNumericLink: gen_ID }
          });
          console.error('Invalid form questions response:', response);
          setFetchErrorKind('design');
          setLoading(false);
        }
      })
      .catch(err => {
        console.error('Form Questions API error:', err);
        const errorReason = err.response?.data?.Status?.StatusDesc || err.response?.data?.message || err.message || 'Unknown error';
        const user_ID = localStorage.getItem('user_id');
        const gen_ID = localStorage.getItem('gen_ID');
        const perProject_ID = localStorage.getItem('project_IDper');
        mixPanel.track('Form Questions Fetch Failed', {
          error: `error from form data: ${errorReason}`,
          userId: user_ID || 'unknown',
          genId: gen_ID || 'unknown',
          perProjectId: perProject_ID || 'unknown',
          projectId: projectId || 'unknown',
          projectTaskId: projectTask_ID || 'unknown',
          errorCode: 446,
          errorDetails: getResponseSummary(err),
          endpoint: maverickPortalApiEndPoint.getWeblinkDesignQuestions.url,
          timestamp: new Date().toISOString(),
          request: { user_ID: user_Id, alphaNumericLink: gen_ID }
        });
        setFetchErrorKind('design');
        setLoading(false);
      });
  };
  const TextInputWrapper = ({ question, value, onSave, disabled = false}) => {
    const [localValue, setLocalValue] = useState(() => {
      return textInputState[question.question_ID] || value || '';
    });
    const inputRef = useRef(null);

    // Update local value when textInputState changes
    useEffect(() => {
      if (textInputState[question.question_ID] !== undefined) {
        setLocalValue(textInputState[question.question_ID]);
      }
    }, [textInputState, question.question_ID]);

    // Handle focus changes
    useEffect(() => {
      if (activeInputId !== question.question_ID && inputRef.current === document.activeElement) {
        inputRef.current.blur();
      }
    }, [activeInputId, question.question_ID]);

    const handleChange = e => {
      e.stopPropagation();
      let newValue = e.target.value;

      // Only apply uppercase and filtering for referral code
      if (question.question_ID === 'referral_code') {
        newValue = newValue.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
      }
      // For value type questions, only allow numbers
      else if (question.questionType_ID === 11) {
        newValue = newValue.replace(/[^0-9]/g, '');
      }

      setLocalValue(newValue);
    };

    const handleFocus = () => {
      setActiveInputId(question.question_ID);
    };

    const handleBlur = () => {
      setActiveInputId(null);
      let finalValue = localValue;

      // Only apply uppercase and filtering for referral code
      if (question.question_ID === 'referral_code') {
        finalValue = localValue.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
      }
      // For value type questions, only allow numbers
      else if (question.questionType_ID === 11) {
        finalValue = localValue.replace(/[^0-9]/g, '');
      }

      if (!finalValue || finalValue.trim() === '') {
        setTextInputState(prev => {
          const newState = { ...prev };
          delete newState[question.question_ID];
          localStorage.setItem('text_input_answers', JSON.stringify(newState));
          return newState;
        });
        onSave('');
      } else {
        setTextInputState(prev => {
          const newState = {
            ...prev,
            [question.question_ID]: finalValue
          };
          localStorage.setItem('text_input_answers', JSON.stringify(newState));
          return newState;
        });
        onSave(finalValue);
      }
    };

    // Determine if this is a referral code input
    const isReferralCode = question.question_ID === 'referral_code';
    // Determine if this is a value type input
    const isValueType = question.questionType_ID === 11;
    const isPincode = /pin[\s]?code/.test(question.questionName?.toLowerCase() || '');
    const isNameField = /name/i.test(question.questionName || '');

    return (
      <InputText
        ref={inputRef}
        showCharacters={false}
        fontSize="14px"
        value={localValue}
        width="390px"
        style={{
          color: disabled ? '#aaa' : (isPincode|| isNameField) ?'black':'var(--greyBlue)',
          fontWeight: '700',
          fontSize: '16px',
          width: '100%',
          textTransform: isReferralCode ? 'uppercase' : 'none',
          backgroundColor: disabled ? '#f5f5f5' : '#fff',
          cursor: disabled ? 'not-allowed' : 'text'
        }}
        placeholder={isReferralCode ? 'Enter 6 digit code'  : (isValueType && isPincode)?'Enter Pincode': isValueType ? 'Enter your value':'Add your answer'}
        multiline={!isReferralCode && !isValueType && question.questionType_ID === 6}
        rows={question.questionType_ID === 6 ? 4 : 1}
        onChange={handleChange}
        // onFocus={handleFocus}
        onBlur={handleBlur}
        isValueType={isValueType ? true : false}
        maxLength={isReferralCode || isPincode ? 6 : undefined}
        disabled={disabled}
      />
    );
  };

    const uploadVideo = async (
      questionId,
      questionTypeId,
      file,
      onCheckFileInS3RetryAttempt,
      onUploadProgress,
      options
    ) => {
      setMediaUploading(true);
      activeMediaUploadingQuestionIdRef.current = questionId;

      if (questionTypeId === 15) {
        setVideoUploadScreenSuccess(true);
      }

      if (questionTypeId === 13) {
        setVideoUploading(prev => ({
          ...prev,
          [questionId]: true
        }));
      }

      let fileToUpload = null;

      try {
        let videoBlob = null;

        if (questionTypeId === 13) {
          videoBlob = file || videoBlobs[questionId];
          if (!videoBlob) {
            console.error('No video blob found for question:', questionId);
            setMediaUploading(false);
            if (String(activeMediaUploadingQuestionIdRef.current) === String(questionId)) {
              activeMediaUploadingQuestionIdRef.current = null;
            }
            setVideoUploading(prev => ({
              ...prev,
              [questionId]: false
            }));
            return;
          }
        }

        if (questionTypeId === 15 && !file && !options?.resumeSession?.blob) {
          console.error('No file provided for question:', questionId);
          setMediaUploading(false);
          setVideoUploadScreenSuccess(false);
          if (String(activeMediaUploadingQuestionIdRef.current) === String(questionId)) {
            activeMediaUploadingQuestionIdRef.current = null;
          }
          return;
        }

        const resumeSession = options?.resumeSession || null;
        const rawMedia = questionTypeId === 13 ? videoBlob : file || resumeSession?.blob;
        const extension = 'mp4';
        // check_pending = completeMultipart already done; only CheckFileInS3 remains.
        const isCheckPendingResume = resumeSession?.status === 'check_pending' && Boolean(resumeSession?.blob);
        const canResumeSameUpload = Boolean(
          resumeSession?.blob &&
            resumeSession.status !== 'aborted' &&
            resumeSession.status !== 'done' &&
            (isCheckPendingResume || resumeSession?.uploadId)
        );
        // Only reuse the old name when continuing the same multipart upload.
        // A new selection / abort retry must get a fresh file_name + file_size.
        const fileName = canResumeSameUpload
          ? resumeSession.fileName
          : `${questionId}_${Date.now()}.${extension}`;
        const fileType = 'video/mp4';
        fileToUpload = rawMedia
          ? new File([rawMedia], fileName, {
              type: rawMedia.type || fileType,
              lastModified: rawMedia.lastModified || Date.now(),
            })
          : null;
        // Never reuse aborted/stale multipart metadata for a new selection.
        const activeResumeSession = canResumeSameUpload ? resumeSession : null;

        const progressKey = String(questionId);
        const reportProgress = (fraction, meta) => {
          const safeFraction = Math.min(1, Math.max(0, Number(fraction) || 0));
          setVideoUploadProgress(prev => ({
            ...prev,
            [progressKey]: safeFraction,
          }));
          setVideoUploadMeta(prev => {
            const prevMeta = prev[progressKey] || {};
            const nextStage = meta?.stage || prevMeta.stage || 'preparing';
            const nextRemaining =
              nextStage === 'uploading' && Number.isFinite(meta?.remainingSeconds)
                ? meta.remainingSeconds
                : nextStage === 'uploading'
                  ? prevMeta.remainingSeconds ?? null
                  : null;
            return {
              ...prev,
              [progressKey]: {
                stage: nextStage,
                remainingSeconds: nextRemaining,
              },
            };
          });
          if (typeof onUploadProgress === 'function') onUploadProgress(safeFraction, meta);
        };

        setVideoResumeOffer(null);
        // Fresh uploads must start at 0% so a previous pause/success never sticks at 100%.
        const startingProgress = isCheckPendingResume
          ? 1
          : activeResumeSession?.fileSize
            ? (activeResumeSession.bytesUploaded || 0) / activeResumeSession.fileSize
            : 0;
        reportProgress(startingProgress, {
          stage: isCheckPendingResume
            ? 'confirming'
            : activeResumeSession?.uploadId
              ? 'uploading'
              : 'preparing',
          remainingSeconds: null,
        });

        // Preserve check_pending + completeBody so resume does not re-run multipart.
        await saveVideoUploadSession({
          replace: !activeResumeSession,
          questionId: progressKey,
          questionTypeId,
          sectionIndex: activeResumeSession?.sectionIndex ?? currentSectionIndex,
          fileName,
          fileSize: fileToUpload.size,
          blob: fileToUpload,
          uploadId: activeResumeSession?.uploadId || null,
          s3Key: activeResumeSession?.s3Key || null,
          partSize: activeResumeSession?.partSize || null,
          parts: activeResumeSession?.parts || [],
          completedParts: activeResumeSession?.completedParts || [],
          bytesUploaded: isCheckPendingResume
            ? fileToUpload.size
            : activeResumeSession?.bytesUploaded || 0,
          status: isCheckPendingResume ? 'check_pending' : 'uploading',
          completeBody: isCheckPendingResume ? activeResumeSession?.completeBody || null : null,
        });

        await uploadVideoInChunks({
          file: fileToUpload,
          fileName,
          resumeSession: activeResumeSession,
          onProgress: reportProgress,
          onSessionUpdate: patch =>
            saveVideoUploadSession({
              questionId: progressKey,
              questionTypeId,
              sectionIndex: currentSectionIndex,
              fileName,
              fileSize: fileToUpload.size,
              ...patch,
            }),
        });

        reportProgress(1, {
          stage: 'confirming',
          remainingSeconds: null,
        });

        const user_ID = localStorage.getItem('user_id');
        const buildCheckFileFormData = () => {
          const fd = new FormData();
          // if (fileToUpload) {
          //   fd.append('questionMP4', fileToUpload, fileName);
          // }
          fd.append('user_ID', user_ID);
          fd.append('question_ID', questionId);
          fd.append('questionType_ID', questionTypeId);
          fd.append('fileName', fileName);
          return fd;
        };

        const checkRetryCount = 3;
        const formData = buildCheckFileFormData();
        const response = await maverickPortalhttp.makeRequest(
          maverickPortalApiEndPoint.CheckFileInS3.url,
          maverickPortalApiEndPoint.CheckFileInS3.methodType,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        const checkStatusCode = response?.data?.Status?.StatusCode;
        if (checkStatusCode === '-1' || checkStatusCode === -1) {
          const statusDesc =
            response?.data?.Status?.StatusDesc ||
            response?.data?.StatusDesc ||
            'CheckFileInS3 failed';

          if (typeof onCheckFileInS3RetryAttempt === 'function') {
            for (let attempt = 1; attempt <= checkRetryCount; attempt += 1) {
              onCheckFileInS3RetryAttempt({ attempt, isMinusOne: true });
              if (attempt < checkRetryCount) {
                await new Promise(resolve => setTimeout(resolve, 5000));
              }
            }
          }

          const user_ID_mix = parseInt(localStorage.getItem('user_id'));
          const perProject_ID = localStorage.getItem('project_IDper');
          const projectsTask_ID = projectTask_ID;
          mixPanel.track('Video upload Failed', {
            userId: user_ID_mix,
            perProjectId: perProject_ID,
            projectTaskId: projectsTask_ID,
            error: statusDesc,
            projectName: projectName,
            ErrorCode: 422,
            errorDetails: getResponseSummary(response),
            timestamp: new Date().toISOString(),
            request: serializeFormData(formData),
          });

          setVideoUploadSuccess(prev => ({
            ...prev,
            [questionId]: false,
          }));

          setVideoUploading(prev => ({
            ...prev,
            [questionId]: false,
          }));

          if (questionTypeId === 15) {
            setVideoUploadScreenSuccess(false);
          }

          setMediaUploading(false);
          if (String(activeMediaUploadingQuestionIdRef.current) === String(questionId)) {
            activeMediaUploadingQuestionIdRef.current = null;
          }

          const finalErr = new Error(statusDesc);
          finalErr.videoAllRetriesFailed = true;
          finalErr.videoCheckAllThreeAttemptsWereMinusOne = true;
          finalErr.videoCheckCleanupDone = true;
          throw finalErr;
        }

        const responsePayload = response?.data?.Response || {};
        const returnedUrl =
          responsePayload.preSignedUrl ||
          responsePayload.preAssingedImageUrl ||
          responsePayload.AWSVideoFilePath ||
          responsePayload.thumbnailnailUrl ||
          responsePayload.mp4ThumbnailFilePath ||
          responsePayload.filePath;

        if (!returnedUrl) {
          throw new Error('Video upload response missing URL.');
        }

        // Mark success UI immediately so resume/retry UI cannot win the race.
        setVideoResumeOffer(null);
        clearVideoUploadActionErrorFor(String(questionId));
        setVideoConnectionMessageStage(prev => {
          const next = { ...prev };
          delete next[String(questionId)];
          delete next[questionId];
          return next;
        });

        if (questionTypeId === 15) {
          setVideoUploadScreenSuccess(false);
          setVideoSuccess(prev => ({
            ...prev,
            [questionId]: true,
          }));
          // Drop local file so Upload Again/Submit preview cannot replace success.
          setSelectedFiles(prev => {
            if (!prev?.[questionId]) return prev;
            const next = { ...prev };
            delete next[questionId];
            return next;
          });
        }

        if (questionTypeId === 13) {
          setVideoUploadSuccess(prev => ({
            ...prev,
            [questionId]: true
          }));
        }

        setPreAssignedImageUrls(prev => ({
          ...prev,
          [questionId]: returnedUrl
        }));

        setVideoStates(prev => ({
          ...prev,
          [questionId]:
            responsePayload.preAssingedImageUrl ||
            responsePayload.AWSVideoFilePath ||
            returnedUrl
        }));

        if (typeof handleAnswerChange === 'function') {
          handleAnswerChange(questionId, returnedUrl, false, { skipTaskStatusUpdate: true });
        }

        try {
          await clearVideoUploadSession(questionId);
        } catch (clearError) {
          // Upload already confirmed in S3 — don't fail the UI for session cleanup.
          console.warn('Failed to clear video upload session after success:', clearError);
        }
        setVideoUploadProgress(prev => ({
          ...prev,
          [String(questionId)]: 1,
        }));

        setTimeout(() => {
          fetchAnswers();
        }, 1000);

        // setTimeout(() => {
          setVideoUploading(prev => ({
            ...prev,
            [questionId]: false
          }));
          setMediaUploading(false);
          if (String(activeMediaUploadingQuestionIdRef.current) === String(questionId)) {
            activeMediaUploadingQuestionIdRef.current = null;
          }
        // }, 3000);
      } catch (error) {
        if (!error.videoCheckCleanupDone) {
          const progressKey = String(questionId);

          // Always show the 3 staged messages before Retry/Delete so connection
          // drops are visible even when the child callback is missing (resume).
          // Keep uploading flags true for the whole sequence.
          for (let attempt = 1; attempt <= 3; attempt += 1) {
            setVideoConnectionMessageStage(prev => ({
              ...prev,
              [progressKey]: attempt,
            }));
            if (typeof onCheckFileInS3RetryAttempt === 'function') {
              onCheckFileInS3RetryAttempt({
                attempt,
                isMinusOne: Boolean(error?.isMinusOne || error?.isNetworkError),
              });
            }
            if (attempt < 3) {
              await new Promise(resolve => setTimeout(resolve, 5000));
            } else {
              // Brief hold on "Video upload failed" before switching UI
              await new Promise(resolve => setTimeout(resolve, 2500));
            }
          }

          const user_ID = parseInt(localStorage.getItem('user_id'));
          const perProject_ID = localStorage.getItem('project_IDper');
          const projectsTask_ID = projectTask_ID;

          mixPanel.track('Video upload Failed', {
            userId: user_ID,
            perProjectId: perProject_ID,
            projectTaskId: projectsTask_ID,
            error: error?.message || 'Unknown error',
            projectName: projectName,
            ErrorCode: 422
          });

          console.error('Error uploading video:', error);

          setVideoUploadSuccess(prev => ({
            ...prev,
            [questionId]: false
          }));

          const previewBlob = fileToUpload || options?.resumeSession?.blob || videoBlobs[questionId] || file;
          if (previewBlob) {
            if (Number(questionTypeId) === 15) {
              setSelectedFiles(prev => ({ ...prev, [questionId]: previewBlob }));
            } else {
              const previewUrl = URL.createObjectURL(previewBlob);
              setMediaUrls(prev => ({ ...prev, [questionId]: previewUrl }));
              setVideoBlobs(prev => ({ ...prev, [questionId]: previewBlob }));
            }
          }
          // Use IndexedDB bytes for paused %. Prefer session bytes; if abort wiped
          // bytesUploaded to 0, keep the last in-memory fraction from this attempt
          // (not a stale 100% from an older upload — that is cleared on delete).
          let progressFromSession = 0;
          const lastKnownFraction = Number(videoUploadProgress[String(questionId)]);
          try {
            const pausedSession = await getVideoUploadSession(questionId);
            const size = Number(pausedSession?.fileSize || fileToUpload?.size || 0);
            const uploaded = Number(pausedSession?.bytesUploaded || 0);
            if (size > 0 && uploaded > 0) {
              progressFromSession = Math.min(1, Math.max(0, uploaded / size));
            } else if (size > 0 && uploaded === 0 && pausedSession?.status === 'aborted') {
              progressFromSession = 0;
            } else if (Number.isFinite(lastKnownFraction) && lastKnownFraction < 1) {
              // Avoid locking resume UI at 100% when confirming was emitted but
              // parts/session were not actually complete for a fresh attempt.
              progressFromSession = Math.min(1, Math.max(0, lastKnownFraction));
            } else if (Number.isFinite(lastKnownFraction)) {
              progressFromSession = Math.min(1, Math.max(0, lastKnownFraction));
            }
          } catch (sessionError) {
            progressFromSession =
              Number.isFinite(lastKnownFraction) && lastKnownFraction < 1
                ? lastKnownFraction
                : 0;
          }
          setVideoUploadProgress(prev => ({
            ...prev,
            [String(questionId)]: progressFromSession,
          }));

          // Resume UI only after the 3 messages finished — clear stage + uploading together.
          setVideoResumeOffer({
            questionId,
            questionTypeId,
          });
          showVideoUploadActionError(progressKey, 'Video upload failed');
          setVideoConnectionMessageStage(prev => {
            const next = { ...prev };
            delete next[progressKey];
            delete next[questionId];
            return next;
          });
          setVideoUploading(prev => ({
            ...prev,
            [questionId]: false
          }));

          if (questionTypeId === 15) {
            setVideoUploadScreenSuccess(false);
          }

          setMediaUploading(false);
          if (String(activeMediaUploadingQuestionIdRef.current) === String(questionId)) {
            activeMediaUploadingQuestionIdRef.current = null;
          }

          const finalErr = new Error(
            error?.message ||
              (error?.isNetworkError
                ? 'Network error. Please check your connection and try again.'
                : 'Video upload failed. Please try again.')
          );
          finalErr.videoAllRetriesFailed = true;
          finalErr.shouldRetryUpload = Boolean(error?.shouldRetryUpload);
          finalErr.isNetworkError = Boolean(error?.isNetworkError);
          finalErr.connectionMessagesShown = true;
          throw finalErr;
        } else {
          console.error('Error uploading video:', error);
          const progressKey = String(questionId);
          if (!error.connectionMessagesShown) {
            for (let attempt = 1; attempt <= 3; attempt += 1) {
              setVideoConnectionMessageStage(prev => ({
                ...prev,
                [progressKey]: attempt,
              }));
              if (typeof onCheckFileInS3RetryAttempt === 'function') {
                onCheckFileInS3RetryAttempt({
                  attempt,
                  isMinusOne: Boolean(error?.isMinusOne || error?.isNetworkError),
                });
              }
              if (attempt < 3) {
                await new Promise(resolve => setTimeout(resolve, 5000));
              } else {
                await new Promise(resolve => setTimeout(resolve, 2500));
              }
            }
            setVideoConnectionMessageStage(prev => {
              const next = { ...prev };
              delete next[progressKey];
              delete next[questionId];
              return next;
            });
            error.connectionMessagesShown = true;
          }
          setVideoResumeOffer({
            questionId,
            questionTypeId,
          });
          showVideoUploadActionError(progressKey, 'Video upload failed');
          setVideoUploading(prev => ({
            ...prev,
            [questionId]: false
          }));
          if (questionTypeId === 15) {
            setVideoUploadScreenSuccess(false);
          }
          setMediaUploading(false);
          if (String(activeMediaUploadingQuestionIdRef.current) === String(questionId)) {
            activeMediaUploadingQuestionIdRef.current = null;
          }
          if (!error.videoAllRetriesFailed) {
            error.videoAllRetriesFailed = true;
          }
        }
        throw error;
      }
    };

    uploadVideoRef.current = uploadVideo;

    const hasNetworkConnection = () => {
      if (!navigator.onLine) return false;
      // if (navigator.connection) {
      //   const connection = navigator.connection;
      //   if (connection.metered) {
      //     return false;
      //   }
      //   if (typeof connection.downlink === 'number' && connection.downlink < 1) {
      //     return false;
      //   }
      // }
      return true;
    };

    const resumeSavedVideoUpload = async offer => {
      const target = offer || videoResumeOffer;
      if (!target?.questionId) return;
      const progressKey = String(target.questionId);
      if (!hasNetworkConnection()) {
        showVideoUploadActionError(
          progressKey,
          'No connection. Please connect to the internet and try again.'
        );
        return;
      }
      const session = (await listVideoUploadSessions()).find(
        item => String(item.questionId) === String(target.questionId)
      );
      if (!session?.blob) {
        setVideoResumeOffer(null);
        return;
      }

      const sectionIndex = sections.findIndex(section =>
        (section.questionName_array || []).some(
          question => String(question.question_ID) === String(session.questionId)
        )
      );
      if (sectionIndex >= 0) setCurrentSectionIndex(sectionIndex);

      const progress = session.fileSize ? (session.bytesUploaded || 0) / session.fileSize : 0;
      setVideoUploadProgress(prev => ({ ...prev, [progressKey]: progress }));
      clearVideoUploadActionErrorFor(progressKey);
      setVideoResumeOffer(null);
      activeMediaUploadingQuestionIdRef.current = session.questionId;
      setMediaUploading(true);
      if (Number(session.questionTypeId) === 15) {
        setVideoUploadScreenSuccess(true);
      } else {
        setVideoUploading(prev => ({ ...prev, [session.questionId]: true }));
      }

      try {
        await uploadVideo(
          session.questionId,
          Number(session.questionTypeId),
          session.blob,
          undefined,
          (fraction, meta) => {
            // Always follow current resume fraction — never keep a prior 100%.
            const safeFraction = Math.min(1, Math.max(0, Number(fraction) || 0));
            setVideoUploadProgress(prev => ({
              ...prev,
              [progressKey]: safeFraction,
            }));
            if (meta) {
              setVideoUploadMeta(prev => {
                const prevMeta = prev[progressKey] || {};
                const nextStage = meta?.stage || prevMeta.stage || 'uploading';
                const nextRemaining =
                  nextStage === 'uploading' && Number.isFinite(meta?.remainingSeconds)
                    ? meta.remainingSeconds
                    : nextStage === 'uploading'
                      ? prevMeta.remainingSeconds ?? null
                      : null;
                return {
                  ...prev,
                  [progressKey]: {
                    stage: nextStage,
                    remainingSeconds: nextRemaining,
                  },
                };
              });
            }
          },
          { resumeSession: session }
        );
      } catch (error) {
        // If CheckFileInS3 already succeeded, session is cleared — keep success UI.
        let alreadyUploaded = false;
        try {
          const sessionAfter = await getVideoUploadSession(session.questionId);
          alreadyUploaded = !sessionAfter;
        } catch (sessionReadError) {
          alreadyUploaded = false;
        }
        if (alreadyUploaded) {
          setVideoResumeOffer(null);
          if (Number(session.questionTypeId) === 15) {
            setVideoUploadScreenSuccess(false);
          }
          setVideoUploading(prev => ({
            ...prev,
            [session.questionId]: false,
          }));
          setMediaUploading(false);
          return;
        }
        showVideoUploadActionError(
          progressKey,
          error?.message ||
            (error?.isNetworkError
              ? 'Network error. Please check your connection and try again.'
              : 'Video upload failed. Please try again.')
        );
        setVideoResumeOffer({
          questionId: session.questionId,
          questionTypeId: Number(session.questionTypeId),
        });
      }
    };

    const clearIncompleteVideoUpload = async questionId => {
      const progressKey = String(questionId);
      if (!hasNetworkConnection()) {
        showVideoUploadActionError(
          progressKey,
          'No connection. Please connect to the internet and try again.'
        );
        return;
      }
      try {
        const session = await getVideoUploadSession(questionId);
        if (session?.uploadId && session?.s3Key) {
          const apiBase = String(maverickPortalconfig.env[0].DEV.hostname || '').replace(/\/$/, '');
          await fetch(`${apiBase}/abortMultipartUpload`, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              upload_id: session.uploadId,
              s3_key: session.s3Key,
            }),
          }).catch(() => null);
        }
      } catch (error) {
        // Continue clearing local state even if abort fails.
      }
      await clearVideoUploadSession(questionId);
      setVideoResumeOffer(null);
      setVideoUploadProgress(prev => {
        const next = { ...prev };
        delete next[questionId];
        delete next[String(questionId)];
        return next;
      });
      setVideoUploadMeta(prev => {
        const next = { ...prev };
        delete next[questionId];
        delete next[String(questionId)];
        return next;
      });
      clearVideoUploadActionErrorFor(questionId);
      setVideoConnectionMessageStage(prev => {
        const next = { ...prev };
        delete next[questionId];
        delete next[String(questionId)];
        return next;
      });
      setVideoUploading(prev => ({ ...prev, [questionId]: false }));
      setVideoUploadScreenSuccess(false);
      setMediaUploading(false);
      if (String(activeMediaUploadingQuestionIdRef.current) === String(questionId)) {
        activeMediaUploadingQuestionIdRef.current = null;
      }
      setMediaUrls(prev => {
        const next = { ...prev };
        delete next[questionId];
        return next;
      });
      setVideoBlobs(prev => {
        const next = { ...prev };
        delete next[questionId];
        return next;
      });
      setSelectedFiles(prev => {
        const next = { ...prev };
        delete next[questionId];
        return next;
      });
      setPreAssignedImageUrls(prev => {
        const next = { ...prev };
        delete next[questionId];
        return next;
      });
      setVideoUploadSuccess(prev => ({ ...prev, [questionId]: false }));
      setVideoSuccess(prev => {
        const next = { ...prev };
        delete next[questionId];
        return next;
      });
    };

    useEffect(() => {
      if (!sections.length || videoResumeStartedRef.current) return undefined;
      let cancelled = false;

      const restoreUpload = async () => {
        let sessions = [];
        try {
          sessions = await listVideoUploadSessions();
        } catch (error) {
          return;
        }
        if (cancelled || videoResumeStartedRef.current) return;
        const session = sessions
          .filter(
            item =>
              item?.blob &&
              item.status !== 'done' &&
              item.status !== 'aborted' &&
              item.uploadId
          )
          .sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))[0];
        if (!session) return;

        const sectionIndex = sections.findIndex(section =>
          (section.questionName_array || []).some(
            question => String(question.question_ID) === String(session.questionId)
          )
        );
        if (sectionIndex < 0) return;

        videoResumeStartedRef.current = true;
        if (cancelled) {
          videoResumeStartedRef.current = false;
          return;
        }

        setCurrentSectionIndex(sectionIndex);
        const progress = session.fileSize ? (session.bytesUploaded || 0) / session.fileSize : 0;
        setVideoUploadProgress(prev => ({ ...prev, [session.questionId]: progress }));
        activeMediaUploadingQuestionIdRef.current = session.questionId;
        setMediaUploading(true);
        if (Number(session.questionTypeId) === 15) {
          setVideoUploadScreenSuccess(true);
        } else {
          setVideoUploading(prev => ({ ...prev, [session.questionId]: true }));
        }

        try {
          await uploadVideoRef.current(
            session.questionId,
            Number(session.questionTypeId),
            session.blob,
            undefined,
            undefined,
            { resumeSession: session }
          );
        } catch (error) {
          setVideoResumeOffer({
            questionId: session.questionId,
            questionTypeId: Number(session.questionTypeId),
          });
        }
      };

      restoreUpload();
      return () => {
        cancelled = true;
      };
    }, [sections]);

  const stopVideoRecording = questionId => {
    const recordingState = recordingStates[questionId];
    if (recordingState?.recorder) {
      recordingState.recorder.stop();
      recordingState.stream.getTracks().forEach(track => track.stop());

      setRecordingStates(prev => {
        const newState = { ...prev };
        delete newState[questionId];
        return newState;
      });
    }
  };

  const uploadImage = async (file, questionId, questionTypeId, setUploadProgress, onImageRetryAttempt) => {
    const user_ID = localStorage.getItem('user_id');
    const buildFormData = () => {
      const fd = new FormData();
      fd.append('QuestionImage', file);
      fd.append('user_ID', user_ID);
      fd.append('question_ID', questionId);
      fd.append('questionType_ID', questionTypeId);
      return fd;
    };

    const retryCount = 3;

    const attemptUpload = async () => {
      const formData = buildFormData();
      try {
        if (!navigator.onLine) {
          const offlineErr = new Error('No internet connection');
          offlineErr.isMinusOne = false;
          throw offlineErr;
        }
        const response = await maverickPortalhttp.makeRequest(
          maverickPortalApiEndPoint.uploadWebLinkQuestionImage.url,
          maverickPortalApiEndPoint.uploadWebLinkQuestionImage.methodType,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: progressEvent => {
              if (typeof setUploadProgress === 'function') {
                const progress = progressEvent.loaded / progressEvent.total;
                setUploadProgress(progress);
              }
            }
          }
        );

        const statusCode = response?.data?.Status?.StatusCode;
        const isMinusOne = statusCode === '-1' || statusCode === -1;
        if (isMinusOne) {
          const err = new Error(response?.data?.Status?.StatusDesc || 'Image upload failed with status -1');
          err.isMinusOne = true;
          throw err;
        }

        const imageUrl =
          response?.data?.ResizedpreAssingedImageUrl ||
          response?.data?.Response?.preAssingedImageUrl ||
          response?.data?.Response?.AWSImageFilePath;
        if (!imageUrl) {
          const err = new Error('Image upload response missing URL.');
          err.isMinusOne = false;
          throw err;
        }

        setPreAssignedImageUrls(prev => ({
          ...prev,
          [questionId]: imageUrl
        }));
        setImageUploadSuccess(prev => ({
          ...prev,
          [questionId]: true
        }));
        handleAnswerChange(questionId, imageUrl);
        return;
      } catch (error) {
        console.error('Image upload failed:', error);
        if (error.isMinusOne === undefined) {
          error.isMinusOne = false;
        }
        throw error;
      }
    };

    try {
      await attemptUpload();
      return;
    } catch (error) {
      if (typeof onImageRetryAttempt === 'function') {
        for (let attempt = 1; attempt <= retryCount; attempt += 1) {
          onImageRetryAttempt({
            attempt,
            isMinusOne: Boolean(error.isMinusOne),
          });
          if (attempt < retryCount) {
            await new Promise(resolve => setTimeout(resolve, 5000));
          }
        }
      }

      const user_ID_mix = parseInt(localStorage.getItem('user_id'));
      const perProject_ID = localStorage.getItem('project_IDper');
      const projectsTask_ID = projectTask_ID;
      const finalFormData = buildFormData();
      mixPanel.track('Image Upload Failed', {
        userId: user_ID_mix,
        perProjectId: perProject_ID,
        projectTaskId: projectsTask_ID,
        error: error?.message || 'Image upload failed',
        questionId: questionId,
        questionTypeId: questionTypeId,
        projectName: projectName,
        ErrorCode: 424,
        errorDetails: getResponseSummary(error),
        timestamp: new Date().toISOString(),
        request: serializeFormData(finalFormData),
      });

      // Clear all image-related states to show "Choose Image" UI again
      setPreAssignedImageUrls(prev => {
        const newUrls = { ...prev };
        delete newUrls[questionId];
        return newUrls;
      });
      setImageUploadSuccess(prev => ({
        ...prev,
        [questionId]: false
      }));
      setMediaUrls(prev => {
        const newUrls = { ...prev };
        delete newUrls[questionId];
        return newUrls;
      });
      setSelectedFiles(prev => {
        const newFiles = { ...prev };
        delete newFiles[questionId];
        return newFiles;
      });
      handleAnswerChange(questionId, null);

      const finalErr = new Error(error?.message || 'Image upload failed');
      finalErr.imageAllRetriesFailed = true;
      finalErr.imageAllThreeAttemptsWereMinusOne = Boolean(error.isMinusOne);
      throw finalErr;
    }
  };
  const handleSubmit1 = (questionId, questionTypeId) => {
    const file = selectedFiles[questionId];
    if (!file) {
      alert('No file selected.');
      return;
    }

    uploadImage(file, questionId, questionTypeId);

    // Optional: Reset file state after upload
    setSelectedFiles(prev => {
      const newState = { ...prev };
      delete newState[questionId];
      return newState;
    });
  };

  const AuthenticationPopup = () => (
    <AuthSplash>
      <div style={{ width: 'min(520px, 100%)' }}>
        <AuthSplashCard>
          <AuthSplashLogo src={`${process.env.PUBLIC_URL}/logo.png`} alt="Maverick" />
          <AuthSplashTitle>
            Share your experiences
            <br />
            with world&apos;s best brands
          </AuthSplashTitle>
          <AuthSplashButtons>
            <AuthSplashTopButtons>
              <AuthSplashPrimaryButton onClick={handleSignIn}>Sign In</AuthSplashPrimaryButton>
              {/* {showCreateAccount && (
                <AuthSplashButton onClick={handleCreateAccount}>Create an account</AuthSplashButton>
              )} */}
            </AuthSplashTopButtons>
            <AuthSplashVideoButtonWrap>
              <AuthSplashButton onClick={() => setShowAuthHelpVideo(true)}>Watch a video</AuthSplashButton>
            </AuthSplashVideoButtonWrap>
          </AuthSplashButtons>
        </AuthSplashCard>
      </div>

      {/* <AuthSplashFooter>Authentication is required to continue this weblink.</AuthSplashFooter> */}

      {showAuthHelpVideo && (
        <PopupOverlay>
          <PopupContent>
            <div style={{ width: '100%', marginTop: '1rem', background: '#fff' }}>
              <video
                src={explorastoryPromoVideo}
                playsInline
                autoPlay
                onEnded={() => setShowAuthHelpVideo(false)}
                style={{
                  width: '100%',
                  maxHeight: '60vh',
                  borderRadius: '8px',
                  background: '#fff',
                  display: 'block',
                  objectFit: 'contain',
                }}
              >
                Your browser does not support the video tag.
              </video>
            </div>
            <ButtonContainer style={{ marginTop: '1rem' }}>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <StyledButton
                  onClick={() => setShowAuthHelpVideo(false)}
                  style={{ width: 'min(160px, 70%)', margin: 0 }}
                >
                  Skip demo
                </StyledButton>
              </div>
            </ButtonContainer>
          </PopupContent>
        </PopupOverlay>
      )}
    </AuthSplash>
  );

  const handleRankingChange = (questionId, payload) => {
    // Remove focus from any active text input
    setActiveInputId(null);

    if (!payload.questionChoice_ID || !payload.questionRankScale_ID) {
      console.error('Invalid ranking payload structure:', payload);
      return;
    }

    if (!Array.isArray(payload.questionChoice_ID) || !Array.isArray(payload.questionRankScale_ID)) {
      console.error('Invalid array types in ranking payload:', payload);
      return;
    }

    handleAnswerChange(questionId, payload);
  };

  const handlePermissionBack = () => {
    // Close the popup immediately when back is clicked
    setShowPermissionDenied(false);
    setDeniedPermissions([]);
  };

 const fetchProfile = async () => {
    try {
      const user_ID = localStorage.getItem('user_id');
      if (!user_ID) {
        console.error('No user_id found in localStorage');
        return;
      }
      // Call the preProfileData API
      const response = await maverickPortalhttp.makeRequest(
        maverickPortalApiEndPoint.preProfileData.url,
        maverickPortalApiEndPoint.preProfileData.methodType,
        { user_ID }
      );

      const statusCode = response?.data?.Status?.StatusCode;
      if (statusCode === '-1' || statusCode === -1) {
        setFetchErrorKind('preProfile');
        const user_ID = localStorage.getItem('user_id');
        const perProject_ID = localStorage.getItem('project_IDper');
        mixPanel.track('Profile Fetch Failed', {
          error: response?.data?.Status?.StatusDesc || 'Profile fetch failed with status -1',
          userId: user_ID || 'unknown',
          perProjectId: perProject_ID || 'unknown',
          projectId: projectId || 'unknown',
          profileAllow: profileAllow,
          profileFilled: profileFilled,
          errorCode: 447,
          errorDetails: getResponseSummary(response),
          endpoint: maverickPortalApiEndPoint.preProfileData.url,
          timestamp: new Date().toISOString(),
          request: { user_ID }
        });
      }else{
        setPreProfileData(response.data.Response);
        setTimeout(() => {
       window.scrollTo({ top: 0, behavior: 'smooth' });
     }, 100);
      }
    } catch (error) {
      console.error('Error fetching preProfileData:', error);
      const errorReason = error.response?.data?.Status?.StatusDesc || error.response?.data?.message || error.message || 'Unknown error';
      const user_ID = localStorage.getItem('user_id');
      const perProject_ID = localStorage.getItem('project_IDper');
      mixPanel.track('Profile Fetch Failed', {
        error: `error from profile builder data: ${errorReason}`,
        userId: user_ID || 'unknown',
        perProjectId: perProject_ID || 'unknown',
        projectId: projectId || 'unknown',
        errorCode: 447,
        errorDetails: getResponseSummary(error),
        endpoint: maverickPortalApiEndPoint.preProfileData.url,
        timestamp: new Date().toISOString(),
        request: { user_ID }
      });
      setFetchErrorKind('preProfile');
      setLoading(false);
    }
  };
 
  // Helper to get city/center dropdown options from preProfileData
  const getCenterData = () => {
    if (preProfileData?.center_data?.length) {
      return preProfileData.center_data.map(item => ({
        name: item.centerName,
        id: item.id,
        label: item.centerName,
        value: item.centerName
      }));
    }
    return [];
  };

 
  const handleWelcomeNext = async () => {
    if (deviceReady && internetReady) {
      const hasPermissions = await checkMediaPermissions();
      if (hasPermissions) {
        setShowWelcomeScreen(false);
        // fetchQuestions();
        if(profileAllow && !profileFilled){

           fetchProfile(); // Pass userId as payload
        }else{
          fetchQuestions();
        }
      
      }
    }
  };

  const checkMediaPermissions = async () => {
    try {
      const deniedPerms = [];

      // Check camera permission
      try {
        const cameraStream = await navigator.mediaDevices.getUserMedia({ video: true });
        cameraStream.getTracks().forEach(track => track.stop());
      } catch (err) {
        deniedPerms.push('camera');
      }

      // Check microphone permission
      try {
        const audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        audioStream.getTracks().forEach(track => track.stop());
      } catch (err) {
        deniedPerms.push('microphone');
      }

      if (deniedPerms.length > 0) {
        setDeniedPermissions(deniedPerms);
        setShowPermissionDenied(true);
        return false;
      }

      // If we get here, all permissions are granted
      setShowPermissionDenied(false);
      setDeniedPermissions([]);
      return true;
    } catch (err) {
      console.error('Error checking permissions:', err);
      return false;
    }
  };

  const getProgressBarInfo = () => {
    if (showWelcomeScreen) {
      return { text: 'Welcome', percent: 0 };
    }
    const percent = ((currentSectionIndex + 1) / sections.length) * 100;

    if (!screenerSubmitted) {
      // Screener phase
      return {
        text: (
          <span style={{ fontWeight: 'bold', color: 'black' }}>
            Screener {'>'} Let's finish up{' '}
            <span style={{ color: '#9EBE21' }}>
              {currentSectionIndex + 1}/{sections.length}
            </span>
          </span>
        ),
        percent
      };
    }
    // Form phase
    return {
      text: (
        <span style={{ fontWeight: 'bold', color: 'black' }}>
          Form {'>'} Let's get some details{' '}
          <span style={{ color: '#9EBE21' }}>
            {currentSectionIndex + 1}/{sections.length}
          </span>
        </span>
      ),

      percent
    };
  };

  const { text: progressText, percent: progressPercent } = getProgressBarInfo();

  const PermissionButton = styled(Button)`
    margin-top: 1rem;
    min-width: 120px;
    position: relative;
    z-index: 1102;
    cursor: pointer;
    background-color: #9cc31c;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.3s ease;

    &:hover {
      background-color: #8ab219;
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }
  `;

  // Add this useEffect after the existing useEffects
  useEffect(() => {
    if (sections.length > 0) {
      fetchAnswers();
    }
  }, [sections, screenerSubmitted, projectId]);

  const fetchAnswers = async () => {
    const user_Id = localStorage.getItem('user_id');
    const perProject_ID = localStorage.getItem('project_IDper');
    const gen_ID = localStorage.getItem('gen_ID');
    
    // Use gen_ID from localStorage for API calls
    try {
      let response;
      if (!screenerSubmitted) {
        // Fetch screener answers
        response = await maverickPortalhttp.makeRequest(
          `${maverickPortalApiEndPoint.fetchScreenerAnswers.url}/${user_Id}/${perProject_ID}`,
          maverickPortalApiEndPoint.fetchScreenerAnswers.methodType
        );
      } else {
        // Fetch form answers
        response = await maverickPortalhttp.makeRequest(
          `${maverickPortalApiEndPoint.fetchFormAnswers.url}/${user_Id}/${perProject_ID}`,
          maverickPortalApiEndPoint.fetchFormAnswers.methodType
        );
      }

      if (response?.data?.Response?.RespondentResponses) {
        const newVideoUploadSuccess = {};
        const newAudioUploadSuccess = {};
        const newImageUploadSuccess = {};
        const newPreAssignedImageUrls = {};
        const newVideoScreenUploadSuccess={};

        response.data.Response.RespondentResponses.forEach(section => {
          section.questionName_array.forEach(question => {
            const mediaUrl = question.questionAnswer_array?.[0]?.preAssingedImageUrl;
            if (mediaUrl) {
              switch (question.questionType_ID) {
                case 13: // Video
                  newVideoUploadSuccess[question.question_ID] = true;
                  newPreAssignedImageUrls[question.question_ID] = mediaUrl;
                  break;
                case 12: // Audio
                  newAudioUploadSuccess[question.question_ID] = true;
                  newPreAssignedImageUrls[question.question_ID] = mediaUrl;
                  break;
                case 8: // Image
                  newImageUploadSuccess[question.question_ID] = true;
                  newPreAssignedImageUrls[question.question_ID] = mediaUrl;
                  break;
                case 15: // Image
                  newVideoScreenUploadSuccess[question.question_ID] = true;
                  newPreAssignedImageUrls[question.question_ID] = mediaUrl;
                  break;
              }
              // Set the answer in the answers state
              handleAnswerChange(question.question_ID, mediaUrl, false, { skipTaskStatusUpdate: true });
            }
          });
        });

        setVideoUploadSuccess(prev => ({ ...prev, ...newVideoUploadSuccess }));
        setAudioUploadSuccess(prev => ({ ...prev, ...newAudioUploadSuccess }));
        setImageUploadSuccess(prev => ({ ...prev, ...newImageUploadSuccess }));
        setPreAssignedImageUrls(prev => ({ ...prev, ...newPreAssignedImageUrls }));
        setVideoSuccess(prev => ({ ...prev, ...newVideoScreenUploadSuccess }));

      }
    } catch (error) {
      console.error('Error fetching answers:', error);
    }
  };

  const ReferralCodeContainer = styled.div`
    margin-top: 2rem;
    padding: 1rem;
    border: 1px solid #eee;
    border-radius: 8px;
    width: 100%;
  `;

  const ReferralCodeTitle = styled.div`
    font-weight: bold;
    color: #666;
    margin-bottom: 0.5rem;
    font-size: 15px;
  `;

  const ReferralCodeDescription = styled.div`
    font-size: 13px;
    color: #666;
    margin-bottom: 1rem;
  `;
  const ReferralCodeError = styled.div`
    color: #f44336;
    font-size: 12px;
    margin-top: 0.5rem;
  `;

  // Add this state near other state declarations
  const [referralCode, setReferralCode] = useState('');
  const [videoUploading, setVideoUploading] = useState({});
  const [referralCodeError, setReferralCodeError] = useState('');
  const [referralCodeState, setReferralCodeState] = useState(() => {
    const savedReferralCode = localStorage.getItem('referral_code');
    return savedReferralCode || '';
  });
  const [viewedMedia, setViewedMedia] = useState(() => {
    try {
      const saved = localStorage.getItem('viewedMedia');
      return saved ? JSON.parse(saved) : {};
    } catch (e) {
      console.error('Failed to parse viewed media state', e);
      return {};
    }
    });

// Update your useEffect that depends on sections
useEffect(() => {
  if (sections.length > 0) {
    setViewedMedia(prev => {
      const newState = {...prev};
      
      // Initialize for any new sections
      sections.forEach(section => {
        if (newState[section.questionPaperSection_ID] === undefined) {
          newState[section.questionPaperSection_ID] = 
            section.presignedUrlSectionImage ? false : true;
        }
      });
      
      // Save to localStorage immediately
      try {
        localStorage.setItem('viewedMedia', JSON.stringify(newState));
      } catch (e) {
        console.error('Failed to save viewed media state', e);
      }
      
      return newState;
    });
  }
}, [sections]);

useEffect(() => {
  if (sections.length > 0) {
    setViewedMedia(prev => {
      const newState = {...prev};
      
      // Initialize for any new sections
      sections.forEach(section => {
        if (newState[section.questionPaperSection_ID] === undefined) {
          newState[section.questionPaperSection_ID] = 
            section.presignedUrlSectionImage ? false : true;
        }
      });
      
      return newState;
    });
  }
}, [sections]);
    
   const updateViewedMedia = useCallback((sectionId) => {
  setViewedMedia(prev => {
    const newState = {
      ...prev,
      [sectionId]: true
    };
    
    // Save to localStorage immediately
    try {
      localStorage.setItem('viewedMedia', JSON.stringify(newState));
    } catch (e) {
      console.error('Failed to save viewed media state', e);
    }
    
    return newState;
  });
}, []);

  // Add this useEffect to save referral code to localStorage
  useEffect(() => {
    localStorage.setItem('referral_code', referralCodeState);
  }, [referralCodeState]);

  const NoConnectionPopup = ({ onClose }) => (
      <PopupOverlay>
        <PopupContent>
          <Heading level={2}>No Internet Connection</Heading>
          <Text mt="1rem" mb="2rem">
            Please check your internet connection and try again.
          </Text>
          <ButtonContainer>
            <StyledButton onClick={onClose}>
              OK
            </StyledButton>
          </ButtonContainer>
        </PopupContent>
      </PopupOverlay>
    );
const getVisibleQuestions = (section, allQuestionsMap) => {
  if (!section?.questionName_array) return [];

  const savedFormAnswers = JSON.parse(localStorage.getItem('form_answers') || '{}');
  const savedTextInputs = JSON.parse(localStorage.getItem('text_input_answers') || '{}');
  const answersState = { ...savedFormAnswers, ...savedTextInputs, ...answers }; 
  const questionMap = allQuestionsMap || {};

  function isAttached(questionId) {
    for (const q of Object.values(questionMap)) {
      for (const choice of q.choiceName_array || []) {
        if (Array.isArray(choice.questionAttached) && choice.questionAttached.includes(questionId)) {
          return true;
        }
        if (typeof choice.questionAttached === 'object' && choice.questionAttached !== null) {
          if (Object.keys(choice.questionAttached).some(k => Number(k) === questionId)) {
            return true;
          }
        }
      }

      if (q.CompareValueArray) {
        for (const items of Object.values(q.CompareValueArray)) {
          for (const item of items) {
            let attachments = [];
            if (Array.isArray(item.questionAttached)) attachments = item.questionAttached;
            else if (item.questionAttached && typeof item.questionAttached === 'object') attachments = [item.questionAttached];

            for (const attachedObj of attachments) {
              if (attachedObj && typeof attachedObj === 'object') {
                if (Object.keys(attachedObj).some(k => Number(k) === questionId)) {
                  return true;
                }
              }
            }
          }
        }
      }

      if (q.questionAttached && typeof q.questionAttached === 'object') {
        if (Object.keys(q.questionAttached).some(k => Number(k) === questionId)) {
          return true;
        }
      }
    }
    return false;
  }

  function isVisible(questionId, visited = new Set()) {
    if (visited.has(questionId)) return false;
    visited.add(questionId);

    const question = questionMap[questionId];
    if (!question) return false;

     const andLogic = question?.ParentquestionAttached?.ANDLogic || [];
  const orLogic = question?.ParentquestionAttached?.ORLogic || [];
 
  // console.log(` Checking visibility for Question ID: ${questionId}`);
  // console.log(` ANDLogic Count: ${andLogic.length}, ORLogic Count: ${orLogic.length}`);
 
  const evaluateCondition = (condition, type = 'AND') => {
    const parentAnswer = answersState[condition.parentQuestion_ID];
    const prefix = `🔹 ${type}Logic - QID ${condition.parentQuestion_ID} (Type ${condition.parentQuestionType})`;
 
    if ([1, 7].includes(condition.parentQuestionType)) {
      const match = parentAnswer === condition.choice_ID;
      // console.log(`${prefix} [Single Choice] Answer: ${parentAnswer}, Expected: ${condition.choice_ID} → ${match}`);
      return match;
    }
 
    if (condition.parentQuestionType === 2) {
      const selectedChoices = parentAnswer || [];
      const match = Array.isArray(selectedChoices) && selectedChoices.includes(condition.choice_ID);
      // console.log(`${prefix} [Multiple Choice] Selected: ${selectedChoices}, Expected: ${condition.choice_ID} → ${match}`);
      return match;
    }
 
    if ([3, 11].includes(condition.parentQuestionType)) {
      const value = Number(parentAnswer);
      const expected = Number(condition.comparibility_value);
      const operation = condition.comparibility_ID;
 
      let match = false;
      switch (operation) {
        case 1: match = value === expected; break;
        case 2: match = value < expected; break;
        case 3: match = value > expected; break;
        case 4: match = value <= expected; break;
        case 5: match = value >= expected; break;
      }
      // console.log(`${prefix} [Slider/Value] Value: ${value}, Op: ${operation}, Expected: ${expected} → ${match}`);
      return match;
    }

if (condition.parentQuestionType === 16) {
  let selectedValue = parentAnswer;
  const parentQuestion = questionMap[condition.parentQuestion_ID];

  if (
    parentQuestion?.likertScaleName_array &&
    typeof selectedValue === 'number'
  ) {
    const likertScale = parentQuestion.likertScaleName_array[selectedValue];
    if (likertScale) {
      selectedValue = likertScale.questionLikertScale_ID;
    }
  }

  const match = selectedValue === condition.likert_IDAttached;
  // console.log(`${prefix} [NPS] Selected: ${selectedValue}, Expected: ${condition.likert_IDAttached} → ${match}`);
  return match;
}

 
    if (condition.parentQuestionType === 4) {
      const compositeKey = `${condition.parentQuestion_ID}_${condition.choice_ID}`;
      const expectedValue = Number(condition.likert_IDAttached);
      const match = likertAnswerIncludesScale(answersState[compositeKey], expectedValue);
      // console.log(`${prefix} [Likert] Selected: ${selectedValue}, Expected: ${expectedValue} → ${match}`);
      return match;
    }
 
    if (condition.parentQuestionType === 14) {
      const answer = parentAnswer;
      const choiceIndex = answer?.questionChoice_ID?.findIndex(id => id === condition.choice_ID);
      if (choiceIndex !== -1) {
        const actualRank = answer?.questionRankScale_ID[choiceIndex];
        const match = actualRank === condition.rank_IDAttached;
        // console.log(`${prefix} [Ranking] Choice Index: ${choiceIndex}, Rank: ${actualRank}, Expected: ${condition.rank_IDAttached} → ${match}`);
        return match;
      }
      return false;
    }
 
    if ([5, 6].includes(condition.parentQuestionType)) {
      if (typeof parentAnswer !== 'string') return false;
      const match = parentAnswer.toLowerCase().includes(condition.ifContains.toLowerCase());
      // console.log(`${prefix} [Text Contains] Answer: "${parentAnswer}", Contains: "${condition.ifContains}" → ${match}`);
      return match;
    }
 
    return false;
  };
 
  // Evaluate ANDLogic
  const andLogicPassed = andLogic.length === 0 || andLogic.every(cond => evaluateCondition(cond, 'AND'));
 
  // Evaluate ORLogic
  const orLogicPassed = orLogic.length === 0 || orLogic.some(cond => evaluateCondition(cond, 'OR'));
 
  // Final combined check
  let parentLogicResult = true;
  if (andLogic.length > 0 && orLogic.length > 0) {
    parentLogicResult = andLogicPassed || orLogicPassed;
    // console.log(` Combined AND/OR → Result: ${parentLogicResult}`);
  } else if (andLogic.length > 0) {
    parentLogicResult = andLogicPassed;
    // console.log(` Only ANDLogic → Result: ${parentLogicResult}`);
  } else if (orLogic.length > 0) {
    parentLogicResult = orLogicPassed;
    // console.log(` Only ORLogic → Result: ${parentLogicResult}`);
  }
 
  if (!parentLogicResult) return false;
 
    if (!isAttached(questionId)) return true;

    for (const parent of Object.values(questionMap)) {
      for (const choice of parent.choiceName_array || []) {
        // 1. Direct array
        if (Array.isArray(choice.questionAttached) && choice.questionAttached.includes(questionId)) {
          const parentAnswer = answersState[parent.question_ID];

          // ✅ Handle Multiple type (questionType_ID: 2)
          if (parent.questionType_ID === 2 && Array.isArray(parentAnswer)) {
            if (parentAnswer.includes(choice.choiceName_ID) && isVisible(parent.question_ID, visited)) {
              return true;
            }
          } else {
            if (isVisible(parent.question_ID, visited) && parentAnswer === choice.choiceName_ID) {
              return true;
            }
          }
        }

        // 2. Object mapping (including for Likert/NPS logic)
        if (typeof choice.questionAttached === 'object' && choice.questionAttached !== null) {
          for (const [attachedId, value] of Object.entries(choice.questionAttached)) {
            if (Number(attachedId) === questionId) {
              // ✅ For NPS (Likert), use question_ID key directly and likertScale array
              if (parent.questionType_ID === 16) {
                let selectedValue = answersState[parent.question_ID];

                if (
                  parent.likertScaleName_array &&
                  typeof selectedValue === 'number'
                ) {
                  const likertScale = parent.likertScaleName_array[selectedValue];
                  if (likertScale) {
                    selectedValue = likertScale.questionLikertScale_ID;
                  }
                }

                if (isVisible(parent.question_ID, visited) && Number(value) === Number(selectedValue)) {
                  return true;
                }

              // ✅ For questionType_ID === 4, use original composite key logic
              } else if (parent.questionType_ID === 4) {
                const compositeKey = `${parent.question_ID}_${choice.choiceName_ID}`;
                const selectedValue = answersState[compositeKey];

                if (isVisible(parent.question_ID, visited) && likertAnswerIncludesScale(selectedValue, value)) {
                  return true;
                }

              } else {
                // For other question types
                if (isVisible(parent.question_ID, visited) && answersState[parent.question_ID] === value) {
                  return true;
                }
              }
            }
          }
        }
      }

      // 3. CompareValueArray logic (sliders, numeric compare)
      if (parent.CompareValueArray && parent.MSTCompatibility_IDs) {
  for (const [opID, items] of Object.entries(parent.CompareValueArray)) {
    for (const item of items) {
      let attachments = [];

      if (Array.isArray(item.questionAttached)) attachments = item.questionAttached;
      else if (item.questionAttached && typeof item.questionAttached === 'object') attachments = [item.questionAttached];

      for (const attachedObj of attachments) {
        if (attachedObj && typeof attachedObj === 'object') {
          for (const [attachedQID, valueMap] of Object.entries(attachedObj)) {
            if (Number(attachedQID) === questionId) {
              const operation = parent.MSTCompatibility_IDs.find(op => op.id.toString() === opID)?.Operations;

              // Handle Ranking type (questionType_ID === 14)
              if (parent.questionType_ID === 14 && typeof valueMap === 'object') {
                for (const [choiceIdRaw, expectedRankRaw] of Object.entries(valueMap)) {
                  const choiceId = String(choiceIdRaw);
                  const expectedRank = Number(expectedRankRaw);

                  const choiceArray = answersState[parent.question_ID]?.questionChoice_ID || [];
                  const index = choiceArray.indexOf(Number(choiceId));
                  const selectedRank = index >= 0 ? index + 1 : NaN;

                  let match = false;
                  switch (operation) {
                    case "IsEqualTo": match = selectedRank === expectedRank; break;
                    case "IsLessThan": match = selectedRank < expectedRank; break;
                    case "IsMoreThan": match = selectedRank > expectedRank; break;
                    case "IsEqualToOrLessThan": match = selectedRank <= expectedRank; break;
                    case "IsEqualToOrMoreThan": match = selectedRank >= expectedRank; break;
                  }

                  if (isVisible(parent.question_ID, visited) && match) return true;
                }

              // Handle Slider type (questionType_ID === 3)
              } else if (parent.questionType_ID === 3) {
                const selectedValue = Number(answersState[parent.question_ID]);
                const compare = Number(valueMap);

                let match = false;
                switch (operation) {
                  case "IsEqualTo": match = selectedValue === compare; break;
                  case "IsLessThan": match = selectedValue < compare; break;
                  case "IsMoreThan": match = selectedValue > compare; break;
                  case "IsEqualToOrLessThan": match = selectedValue <= compare; break;
                  case "IsEqualToOrMoreThan": match = selectedValue >= compare; break;
                }

                if (isVisible(parent.question_ID, visited) && match) return true;

              // Handle other question types
              } else {
                const selectedValue = Number(answersState[parent.question_ID]);
                const compare = Number(valueMap);

                let match = false;
                switch (operation) {
                  case "IsEqualTo": match = selectedValue === compare; break;
                  case "IsLessThan": match = selectedValue < compare; break;
                  case "IsMoreThan": match = selectedValue > compare; break;
                  case "IsEqualToOrLessThan": match = selectedValue <= compare; break;
                  case "IsEqualToOrMoreThan": match = selectedValue >= compare; break;
                }

                if (isVisible(parent.question_ID, visited) && match) return true;
              }
            }
          }
        }
      }
    }
  }
}
      // 4. String keyword-based
      if (parent.questionAttached && typeof parent.questionAttached === 'object') {
        for (const [attachedId, value] of Object.entries(parent.questionAttached)) {
          if (Number(attachedId) === questionId) {
            if ((parent.questionType_ID === 5 || parent.questionType_ID === 6) && typeof answersState[parent.question_ID] === 'string') {
              const trimmedAnswer = answersState[parent.question_ID].trim().toLowerCase();
              if (isVisible(parent.question_ID, visited) && typeof value === 'string' && trimmedAnswer.includes(value.toLowerCase())) {
                return true;
              }
            }
          }
        }
      }
    }

    return false;
  }

  const visibleQuestions = section.questionName_array.filter(q => isVisible(q.question_ID));

  // Do NOT call setAnswers here — updating state during render can abort/restart the render and
  // unmount media components (e.g. AudioRecorder), wiping in-progress recording. Pruning runs in useEffect below.

  return visibleQuestions;
};
  // (Place this at the top level of the component, after sections is defined)
  const allQuestions = {};
  (sections || []).forEach(section => {
    (section.questionName_array || []).forEach(q => {
      allQuestions[q.question_ID] = q;
    });
  });
  const PROFILE_ANSWERS_STORAGE_KEY = 'profile_answers';
  const getStoredProfileAnswers = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(PROFILE_ANSWERS_STORAGE_KEY) || '{}');
      return saved && typeof saved === 'object' ? saved : {};
    } catch {
      return {};
    }
  };

  const [staticForm, setStaticForm] = useState(() => {
    const saved = getStoredProfileAnswers();
    const otpUserName = localStorage.getItem('user_name') || '';
    return {
      name: saved.name || otpUserName,
      dateOfBirth: saved.dateOfBirth || '',
      gender_ID: saved.gender_ID ?? '',
      isMarried: saved.isMarried ?? '',
      center_ID: saved.center_ID || '',
      address: saved.address || '',
    };
  });
  const [staticFormErrors, setStaticFormErrors] = useState({
    name: '',
    dateOfBirth: '',
    gender_ID: '',
    isMarried: '',
    center_ID: '',
    address: '',
  });
 
  const genderOptions = [
    { label: 'Male', value: 1 },
    { label: 'Female', value: 2 },
    { label: 'Non-Binary', value: 3 },
  ];
  const yesOrNoOptions = [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 0 },
  ];
 
  const validateStaticForm = () => {
    let isValid = true;
    const savedAnswers = JSON.parse(localStorage.getItem('text_input_answers') || '{}');
  const savedName = savedAnswers['profile_name'];
  const savedPincode = savedAnswers['profile_pincode'];
    const errors = {
      name: '',
      dateOfBirth: '',
      gender_ID: '',
      isMarried: '',
      center_ID: '',
      address: '',
    };

   const rawPincode =
  (typeof staticForm.address === 'string' && staticForm.address.trim().length > 0)
    ? staticForm.address.trim()
    : (typeof savedPincode === 'string' ? savedPincode.trim() : '');


const pincode = rawPincode.trim();
    if (!staticForm.name && !savedName) {
      isValid = false;
      errors.name = 'Name is required';
    }
    if (!staticForm.center_ID) {
      isValid = false;
      errors.center_ID = 'Please select city';
    }
    if (!staticForm.dateOfBirth) {
      isValid = false;
      errors.dateOfBirth = 'Please enter your date of birth';
    }
    if (staticForm.gender_ID === '') {
      isValid = false;
      errors.gender_ID = 'Please select your gender';
    }
    if (staticForm.isMarried === '') {
      isValid = false;
      errors.isMarried = 'Please select any one';
    }
    
   if (!pincode || pincode.length !== 6 || /\D/.test(pincode)) {
  isValid = false;
  errors.address = 'Please enter a valid 6-digit pin code';
}

    setStaticFormErrors(errors);
    return isValid;
  };
 const handleDateChange = (date) => {
  setSelectedDate(date);
  const formatted = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth()+1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  handleStaticFormChange('dateOfBirth', formatted);
  setIsPickerOpen(false);
};
const isToday = (date) => {
    const today = new Date();
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  };
  const handleStaticFormChange = (key, value) => {
    setStaticForm(prev => ({ ...prev, [key]: value }));
    setStaticFormErrors(prev => ({
    ...prev,
    [key]: ''
  }));
  };
 
  const handleStaticFormSubmit = (e) => {
    e.preventDefault();
    if (validateStaticForm()) {
      // Submit or use staticForm data as needed
      setProfileStep(2); // Move to next step
       setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
    }
  };
 
  const [profileStep, setProfileStep] = useState(1); // 1 = static questions, 2 = next step
 
  // Add state for step 2 questions after staticForm state
  const [step2Form, setStep2Form] = useState(() => {
    const saved = getStoredProfileAnswers();
    return {
      HomeProduct: Array.isArray(saved.HomeProduct) ? saved.HomeProduct : [],
      parentEducation_ID: saved.parentEducation_ID || '',
    };
  });
  const [step2Errors, setStep2Errors] = useState({
     HomeProduct: '',
    parentEducation_ID: '',
  });
 
  // Helper to get education options from preProfileData
 const getEducationOptions = () => {
  if (preProfileData?.education_data?.length) {
    return preProfileData.education_data.map(item => ({
      label: item.educationName,
      value: item.id,
    }));
  }
  return [];
};
const educationOptions = getEducationOptions().map(opt => ({
  value: opt.value,
  label: opt.label
}));

  // Helper to get home product options from preProfileData
  const getProductOptions = () => {
    if (preProfileData?.HomeProduct_data?.length) {
      return preProfileData.HomeProduct_data.map(item => ({
        id: item.id,
        label: item.HomeProductName,
        value: item.id,
      }));
    }
    return [];
  };
 
  // Validation for step 2
  const validateStep2Form = () => {
    let isValid = true;
    const errors = {  HomeProduct: '', parentEducation_ID: '' };
    if (!step2Form.HomeProduct.length) {
      isValid = false;
      errors.HomeProduct = 'Select at least one product';
    }
    if (!step2Form.parentEducation_ID) {
      isValid = false;
      errors.parentEducation_ID = 'Please select qualification';
    }
    setStep2Errors(errors);
    return isValid;
  };
 
  const handleStep2Change = (key, value) => {
    setStep2Form(prev => ({ ...prev, [key]: value }));
    setStep2Errors(prev => ({
    ...prev,
    [key]: '' // or just omit the field entirely if you prefer
  }));
  };

  useEffect(() => {
    const profileAnswersToPersist = {
      ...staticForm,
      ...step2Form,
    };
    localStorage.setItem(PROFILE_ANSWERS_STORAGE_KEY, JSON.stringify(profileAnswersToPersist));
  }, [staticForm, step2Form]);
 
 const getProfilePayload = () => {
    const textInputAnswers = JSON.parse(localStorage.getItem('text_input_answers') || '{}');
    const savedProfileAnswers = getStoredProfileAnswers();
    const mergedStaticForm = {
      ...staticForm,
      ...savedProfileAnswers,
    };

    const mergedStep2Form = {
      HomeProduct: Array.isArray(savedProfileAnswers.HomeProduct)
        ? savedProfileAnswers.HomeProduct
        : step2Form.HomeProduct,
      parentEducation_ID: savedProfileAnswers.parentEducation_ID || step2Form.parentEducation_ID,
    };

    let dob = mergedStaticForm.dateOfBirth;
    if (dob && dob.includes('-')) {
      dob = formatDateToDDMMYYYY(dob);
    }
    return {
      ...mergedStaticForm,
      name: textInputAnswers['profile_name'] || mergedStaticForm.name,
      address: textInputAnswers['profile_pincode'] || mergedStaticForm.address,
      HomeProduct: mergedStep2Form.HomeProduct,
      parentEducation_ID: mergedStep2Form.parentEducation_ID,
      parentannualIncome: '',
      dateOfBirth:dob,
      HomeType: '',
      hasPets: null,
      hasMusicalInstruments: null,
      isTraveller: null,
      Interest: [],
      user_ID: localStorage.getItem('user_id') || '',
    };
  };
 
  // Update handleStep2Submit to use the combined payload
 const handleStep2Submit = async (e) => {
  
    e.preventDefault();
    if (validateStep2Form()) {
      setProfileStep(3);
      setLoading(true);
      const payload = getProfilePayload();
      // localStorage.removeItem('text_input_answers');
      // console.log('jjjjjjjjjj',payload);
      try {
        const response = await maverickPortalhttp.makeRequest(
          maverickPortalApiEndPoint.editProfile.url,
          maverickPortalApiEndPoint.editProfile.methodType,
          payload
        );
        const statusCode = response?.data?.Status?.StatusCode;
        if (statusCode === '-1' || statusCode === -1) {
          setLoading(false);
          setProfileStep(2);
          toast.error('Submit failed', { containerId: WEBLINK_PROFILE_SUBMIT_TOAST_ID });
          const user_ID = localStorage.getItem('user_id');
          const perProject_ID = localStorage.getItem('project_IDper');
          mixPanel.track('Profile Submit Failed', {
            error: response?.data?.Status?.StatusDesc || 'Profile submit failed with status -1',
            errorCode: 448,
            statusDesc: response?.data?.Status?.StatusDesc || 'No description',
            userId: user_ID || 'unknown',
            perProjectId: perProject_ID || 'unknown',
            projectId: projectId || 'unknown',
            errorDetails: getResponseSummary(response),
            endpoint: maverickPortalApiEndPoint.editProfile.url,
            timestamp: new Date().toISOString(),
            request: payload
          });
        } else {
            localStorage.removeItem('text_input_answers');
          localStorage.removeItem(PROFILE_ANSWERS_STORAGE_KEY);
          fetchQuestions();
        }

        setLoading(false);
      } catch (error) {
        console.error('Error creating profile:', error);
        const errorReason = error.response?.data?.Status?.StatusDesc || error.response?.data?.message || error.message || 'Unknown error';
        const user_ID = localStorage.getItem('user_id');
        const perProject_ID = localStorage.getItem('project_IDper');
        mixPanel.track('Profile Submit Failed', {
          error: `error from profile submit: ${errorReason}`,
          userId: user_ID || 'unknown',
          perProjectId: perProject_ID || 'unknown',
          projectId: projectId || 'unknown',
          errorCode: 448,
          errorDetails: getResponseSummary(error),
          endpoint: maverickPortalApiEndPoint.editProfile.url,
          timestamp: new Date().toISOString(),
          request: payload
        });
        setLoading(false);
        setProfileStep(2);
        toast.error('Submit failed', { containerId: WEBLINK_PROFILE_SUBMIT_TOAST_ID });
      }
    }
  };

  const centerOptions = getCenterData().map(c => ({
  value: c.id,
  label: c.name
}));

 const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    border: 'none',
    borderBottom: `2px solid ${state.isFocused ? '#9ebe21' : '#ccc'}`,
    borderRadius: 0,
    boxShadow: 'none',
    fontSize: '16px',
    backgroundColor: 'transparent',
    minHeight: '38px',
    cursor: 'pointer',
    '&:hover': {
      borderBottom: '2px solid #9ebe21',
    }
  }),
  singleValue: (base) => ({
    ...base,
    // color: '#9ebe21', // green selected text
    fontWeight: '600',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#888'
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    marginTop: 2
  }),
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isSelected
      ? '#f1f1f1'
      : isFocused
      ? '#f9f9f9'
      : '#fff',
    color: isSelected ? '#9ebe21' : '#000', // green selected item
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: isSelected ? 'bold' : 'normal',
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  dropdownIndicator: base => ({
    ...base,
    color: '#9ebe21'
  }),
};

  const formatDateToDDMMYYYY = (dateStr) => {
    if (!dateStr) return '';
    const [yyyy, mm, dd] = dateStr.split('-');
    if (!yyyy || !mm || !dd) return dateStr;
    return `${dd}/${mm}/${yyyy}`;
  };

  const isIosSafari = () => {
  return /iP(ad|od|hone)/i.test(window.navigator.userAgent);
};

  /** Prune answers for questions that are not visible (deferred from getVisibleQuestions to avoid setState-during-render remounting AudioRecorder / video UI). */
  useEffect(() => {
    if (!sections?.length) return;

    const allQ = {};
    sections.forEach(s => {
      (s.questionName_array || []).forEach(q => {
        allQ[q.question_ID] = q;
      });
    });

    const newAnswers = { ...answers };
    sections.forEach(section => {
      if (!section?.questionName_array) return;
      const visibleQuestions = getVisibleQuestions(section, allQ);
      const visibleIds = new Set(visibleQuestions.map(q => q.question_ID));
      section.questionName_array.forEach(q => {
        if (!visibleIds.has(q.question_ID)) {
          if (!MEDIA_QUESTION_TYPES.includes(q.questionType_ID)) {
            delete newAnswers[q.question_ID];
            if (q.choiceName_array) {
              q.choiceName_array.forEach(choice => {
                const compositeKey = `${q.question_ID}_${choice.choiceName_ID}`;
                delete newAnswers[compositeKey];
              });
            }
          }
        }
      });
    });

    if (JSON.stringify(newAnswers) !== JSON.stringify(answers)) {
      setAnswers(newAnswers);
    }
  }, [answers, sections]);

  return (
    <RespondentFormRootContainer>
      <ProfileScreen
        isAuthenticated={isAuthenticated}
        showWelcomeScreen={showWelcomeScreen}
        profileAllow={profileAllow}
        profileFilled={profileFilled}
        profileStep={profileStep}
        setProfileStep={setProfileStep}
        staticForm={staticForm}
        staticFormErrors={staticFormErrors}
        handleStaticFormChange={handleStaticFormChange}
        handleStaticFormSubmit={handleStaticFormSubmit}
        genderOptions={genderOptions}
        yesOrNoOptions={yesOrNoOptions}
        centerOptions={centerOptions}
        isIosSafari={isIosSafari}
        selectedDate={selectedDate}
        isPickerOpen={isPickerOpen}
        setIsPickerOpen={setIsPickerOpen}
        handleDateChange={handleDateChange}
        TextInputWrapper={TextInputWrapper}
        customSelectStyles={customSelectStyles}
        step2Form={step2Form}
        step2Errors={step2Errors}
        handleStep2Change={handleStep2Change}
        handleStep2Submit={handleStep2Submit}
        getProductOptions={getProductOptions}
        educationOptions={educationOptions}
        profileSubmitToastContainerId={WEBLINK_PROFILE_SUBMIT_TOAST_ID}
      />
 
 
      <DashboardContainer>
        {/* Project Validation Error Screens */}
        {showProjectClosedScreen && (
          <ProjectClosedScreen
            backgroundImageUrl={ErrorScreen1}
            title={projectClosedVariant === 'full' ? 'Project is Full' : undefined}
            description={
              projectClosedVariant === 'full'
                ? 'This project has reached its participant limit and is no longer accepting responses'
                : undefined
            }
          />
        )}
        {showInvalidProjectScreen && (
          <InvalidProjectScreen backgroundImageUrl={ErrorScreen1} />
        )}
        
        {/* Progress Bar */}
        {isAuthenticated && !responseType && !showWelcomeScreen && sections.length > 0 && (
          <>
            <ProgressBarContainer>
              <ProgressBarText>{progressText}</ProgressBarText>
              <ProgressBarTrack>
                <ProgressBarFill percent={progressPercent} />
              </ProgressBarTrack>
            </ProgressBarContainer>
          </>
        )}
        {!isAuthenticated && showAuthPopup && !showProjectClosedScreen && !showInvalidProjectScreen && !isValidatingWeblink && <AuthenticationPopup />}
        {showPermissionDenied && (
          <PermissionDeniedPopup>
            <PermissionContent>
              <PermissionIcon>⚠️</PermissionIcon>
              <Heading level={2}>Access Denied</Heading>
              <PermissionText>
                To continue with the exploratory, we need permission to access your:
                <br />
                {deniedPermissions
                  .map(perm => <strong key={perm}>{perm === 'camera' ? ' Camera' : ' Microphone'}</strong>)
                  .reduce((prev, curr) => [prev, ' and', curr])}
              </PermissionText>
              <PermissionText>Please enable these permissions in your browser settings and try again.</PermissionText>
              <PermissionButton onClick={handlePermissionBack} type="button">
                Back
              </PermissionButton>
            </PermissionContent>
          </PermissionDeniedPopup>
        )}
        {isValidatingWeblink && !showProjectClosedScreen && !showInvalidProjectScreen && (
          <LoadingOverlay message="Loading..." />
        )}
        {loading && !responseType && !showWelcomeScreen && <WeblinkSkeletonScreen />}
        <ResponseScreen responseType={responseType} responseMessage={responseMessage} />
        {isAuthenticated && !responseType && showWelcomeScreen && (
          <WelcomeScreen
            projectName={projectName}
            deviceReady={deviceReady}
            internetReady={internetReady}
            onDeviceReadyChange={setDeviceReady}
            onInternetReadyChange={setInternetReady}
            onNext={handleWelcomeNext}
          />
        )}
        {isAuthenticated && !responseType && !showWelcomeScreen && (
          <DashboardContent>
            <SubmitToastSlot>
              <ToastContainer
                enableMultiContainer
                containerId={WEBLINK_DASHBOARD_SUBMIT_TOAST_ID}
                position="top-center"
                autoClose={4000}
                closeOnClick
                pauseOnHover
                transition={Zoom}
                draggable={false}
                hideProgressBar={true}
              />
            </SubmitToastSlot>
            {fetchErrorKind && (
              <FetchErrorScreen
                backgroundImageUrl={ErrorScreen1}
                variant={fetchErrorKind}
                onRetry={() => window.location.reload()}
              />
            )}
            {!loading && !fetchErrorKind && sections.length > 0 && (
              <div>
                {sections.map((section, sectionIdx) => (
                  <div
                    key={section.questionPaperSection_ID}
                    style={{
                      marginBottom: '2rem',
                      display: sectionIdx === currentSectionIndex ? 'block' : 'none'
                    }}
                  >
                    {section.sectionName && (
                    <div style={{ margin: '0.25rem 0 1rem 0' }}>
                      <div style={{ color: '#000000', marginTop: '0.25rem', fontSize: '14px',fontWeight:'bold' }}>
                          {section.sectionName}
                        </div>
                      {section.sectionDescription && (
                        <div style={{ color: '#000000', marginTop: '0.25rem', fontSize: '14px' }}>
                          {section.sectionDescription}
                        </div>
                        
                      )}
                    </div>
                  )}
                    {section?.presignedUrlSectionImage && (  
                      <ImageQuestionMedia
                        key={`media-${section.questionPaperSection_ID}`} 
                        url={section.presignedUrlSectionImage}
                        isNote={section.questionName_array?.length > 0}
                        mediaTimer={section.timer}
                        sectionDescription={section.sectionDescription}
                        hasViewed={viewedMedia[section.questionPaperSection_ID] || false}
                    onViewComplete={() => updateViewedMedia(section.questionPaperSection_ID)}
                      />
                    )}   

                  

                   {getVisibleQuestions(section,allQuestions).map((question, qIdx) => (
                       <div 
                        key={`q-${String(question.question_ID)}`} 
                        id={`question-${question.question_ID}`}
                        style={{ 
                          marginBottom: '1.5rem', 
                          padding: '1rem', 
                          border: '1px solid #eee', 
                          borderRadius: '8px',
                          transition: 'border 0.2s ease',
                          width: '100%'
                        }}
                      >
                       {question.questionType_ID !== 3 && (
                        <Text as="div" fontWeight="bold" mb="0.5rem" fontSize="15px">
                          {qIdx + 1}. {question.questionName}
                          {question.isRequired === true && <span style={{ color: 'red' }}> *</span>}
                        </Text>
                      )}

                          {question.presignedUrlQuestionImage && (
                            <div style={{ margin: '10px 0' }}>
                              {(() => {
                                const url = question.presignedUrlQuestionImage;

                                const isVideo = /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);

                                if (isVideo) {
                                  return (
                                    <video
                                      src={url}
                                      controls
                                      style={{
                                        maxWidth: '100%',

                                        maxHeight: '250px',

                                        borderRadius: '8px',

                                        border: '1px solid #eee',

                                        display: 'block',

                                        margin: '0 auto',

                                        objectFit: 'contain'
                                      }}
                                    >
                                      Your browser does not support the video tag.
                                    </video>
                                  );
                                } else {
                                  return (
                                    <img
                                      src={url}
                                      alt="Question"
                                      style={{
                                        maxWidth: '100%',

                                        maxHeight: '250px',

                                        borderRadius: '8px',

                                        border: '1px solid #eee',

                                        display: 'block',

                                        margin: '0 auto',

                                        objectFit: 'contain'
                                      }}
                                    />
                                  );
                                }
                              })()}
                            </div>
                          )}

                          {/* Render different question types */}
                          {/* rendering different question types */}
                          {(question.questionType_ID === 1 || question.questionType_ID === 7) &&
                            question.choiceName_array && (
                              <>
                                {question.questionDescription && (
                                  <div style={{color: '#000000', fontWeight: 'normal', marginBottom: '1rem', fontSize: '15px',marginLeft:'25px' }}>
                                    {question.questionDescription}
                                  </div>
                                )}
                                <div
                                  style={{
                                    display: 'grid',
                                    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                                    gap: '0.75rem',
                                    opacity: viewedMedia[section.questionPaperSection_ID] ? 1 : 0.5,
                                    pointerEvents: viewedMedia[section.questionPaperSection_ID] ? 'auto' : 'none'
                                  }}
                                >
                                {question.choiceName_array.map(choice => {
                                  const isSelected = answers[question.question_ID] === choice.choiceName_ID;
                                  return (
                                    <div
                                      key={choice.choiceName_ID}
                                      onClick={() => {
                                      if (viewedMedia[section.questionPaperSection_ID]) {
                                      handleAnswerChange(question.question_ID, choice.choiceName_ID);
                                      }}}
                                      style={{
                                        padding: '0.75rem',
                                        border: isSelected ? '2px solid #9ebe21' : '1px solid #ccc',
                                        borderRadius: '6px',
                                        cursor: viewedMedia[section.questionPaperSection_ID] ? 'pointer' : 'not-allowed',
                                        // textAlign: 'center',
                                        backgroundColor: isSelected ? '#fff' : '#EFEFEF',
                                        transition: 'background-color 0.2s ease'
                                      }}
                                    >
                                      {choice.choiceName}
                                    </div>
                                  );
                                })}
                                </div>
                              </>
                            )}

                          {question.questionType_ID === 2 && question.choiceName_array && (
                            <>
                              {question.questionDescription && (
                                  <div style={{color: '#000000', fontWeight: 'normal', marginBottom: '1rem', fontSize: '15px',marginLeft:'25px' }}>
                                    {question.questionDescription}
                                  </div>
                                )}
                              <div
                                style={{
                                  display: 'grid',
                                  gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                                  gap: '0.75rem',
                                  opacity: viewedMedia[section.questionPaperSection_ID] ? 1 : 0.5,
                                  pointerEvents: viewedMedia[section.questionPaperSection_ID] ? 'auto' : 'none'
                                }}
                              >
                              {question.choiceName_array.map(choice => {
                                const isSelected = answers[question.question_ID]?.includes(choice.choiceName_ID);
                                return (
                                  <div
                                    key={choice.choiceName_ID}
                                    onClick={() => {
                                      if (viewedMedia[section.questionPaperSection_ID]) {
                                      handleAnswerChange(question.question_ID, choice.choiceName_ID, true)
                                      }}}
                                    style={{
                                      padding: '0.75rem',
                                      border: isSelected ? '2px solid #9ebe21' : '1px solid #ccc',
                                      borderRadius: '6px',
                                      cursor: viewedMedia[section.questionPaperSection_ID] ? 'pointer' : 'not-allowed',
                                      // textAlign: 'center',
                                      backgroundColor: isSelected ? '#fff' : '#EFEFEF',
                                      transition: 'background-color 0.2s ease'
                                    }}
                                  >
                                    {choice.choiceName}
                                  </div>
                                );
                              })}
                              </div>
                            </>
                          )}
                           {question.questionType_ID === 4 && (
                            <>
                              {question.questionDescription && (
                                  <div style={{color: '#000000', fontWeight: 'normal', marginBottom: '1rem', fontSize: '15px',marginLeft:'25px' }}>
                                    {question.questionDescription}
                                  </div>
                                )}
                                 {question.choiceName_array.map((choice, choiceIndex) => {
                                const compositeKey = `${question.question_ID}_${choice.choiceName_ID}`;
                                const selectedAnswer = answers[compositeKey];
                                const isMultiLikert = question.choiceName_array.length > 1;
                                const allowMultipleScales = isCustomLikertQuestion(question);
                                const isMatrix = isMatrixQuestion(question);
                                const controlMenu = isMultiLikert || isMatrix || allowMultipleScales;
                                return (
                                  <LikertDropdown
                                    key={choice.choiceName_ID}
                                    choice={choice}
                                    question={question}
                                    selectedAnswer={selectedAnswer}
                                    compositeKey={compositeKey}
                                    onAnswerChange={(key, value) => {
                                      let skipScrollRestore = false;
                                      if (isMultiLikert && !allowMultipleScales && !isMatrix) {
                                        const updatedAnswers = { ...answers, [key]: value };
                                        const nextIndex = getNextLikertIndexAfterAnswer(
                                          question,
                                          choiceIndex,
                                          updatedAnswers
                                        );
                                        skipScrollRestore = nextIndex >= 0;
                                        setOpenMultiLikertMenu(
                                          nextIndex >= 0
                                            ? { [question.question_ID]: nextIndex }
                                            : {}
                                        );
                                      }
                                      handleAnswerChange(key, value, false, { skipScrollRestore });
                                    }}
                                    menuIsOpen={
                                      controlMenu &&
                                      typeof openMultiLikertMenu[question.question_ID] === 'number' &&
                                      openMultiLikertMenu[question.question_ID] >= 0 &&
                                      openMultiLikertMenu[question.question_ID] === choiceIndex
                                    }
                                    onMenuClose={controlMenu ? () => setOpenMultiLikertMenu(prev => {
                                      if (prev[question.question_ID] !== choiceIndex) {
                                        return prev;
                                      }
                                      return {};
                                    }) : undefined}
                                    onControlledMenuOpen={controlMenu ? () => {
                                      setOpenMultiLikertMenu({
                                        [question.question_ID]: choiceIndex
                                      });
                                    } : undefined}
                                    disabled={!viewedMedia[section.questionPaperSection_ID]}
                                  />
                                );
                              })}
                            </>
                          )}

                          {(question.questionType_ID === 5 ||
                            question.questionType_ID === 6 ||
                            question.questionType_ID === 11) && (
                               <>
                                 {question.questionDescription && (
                                  <div style={{color: '#000000', fontWeight: 'normal', marginBottom: '1rem', fontSize: '15px',marginLeft:'25px' }}>
                                    {question.questionDescription}
                                  </div>
                                )}
                                 <div 
                                 style={{
                                  opacity: viewedMedia[section.questionPaperSection_ID] ? 1 : 0.5,
                                  pointerEvents: viewedMedia[section.questionPaperSection_ID] ? 'auto' : 'none'
                                }}>
                            <TextInputWrapper
                              question={question}
                              value={answers[question.question_ID] || ''}
                              onSave={val => {
                                    if (viewedMedia[section.questionPaperSection_ID]) {
                                    handleAnswerChange(question.question_ID, val);
                                    }
                                    }}
                              disabled={!viewedMedia[section.questionPaperSection_ID]}
                            />
                            </div>
                            </>
                          )}
                          {(question.questionType_ID === 12 || question.questionType_ID === 13) && (
                            <>
                              {question.questionDescription && (
                                  <div style={{color: '#000000', fontWeight: 'normal', marginBottom: '1rem', fontSize: '15px',marginLeft:'25px' }}>
                                    {question.questionDescription}
                                  </div>
                                )}
                              <div>
                              {question.questionType_ID === 12 ? (
                                <AudioRecorder
                                  questionId={question.question_ID}
                                  questionTypeId={question.questionType_ID}
                                  preAssignedUrl={preAssignedImageUrls[question.question_ID]}
                                  disabled={viewedMedia[section.questionPaperSection_ID] || false}
                                  uploadAudio={uploadAudio}
                                  onUploaded={url => {
                                    setMediaUploading(false);
                                    setMediaUrls(prev => ({ ...prev, [question.question_ID]: url }));
                                    handleAudioRecordingStopped(question.question_ID);
                                    handleAudioUploadEnd(question.question_ID);
                                  }}
                                  onDelete={() => {
                                    handleAudioRecordingStopped(question.question_ID);
                                    handleAudioUploadEnd(question.question_ID);
                                    return deleteAudio(question.question_ID);
                                  }}
                                  onUploadStart={qid => {
                                    setMediaUploading(true);
                                    handleAudioUploadStart(qid ?? question.question_ID);
                                  }}
                                  onUploadEnd={qid => {
                                    setMediaUploading(false);
                                    handleAudioUploadEnd(qid ?? question.question_ID);
                                  }}
                                  onRequestStartRecording={handleRequestStartAudioRecording}
                                  onRecordingStarted={handleAudioRecordingStarted}
                                  onRecordingStopped={handleAudioRecordingStopped}
                                />
                              ) : question.questionType_ID === 13 ? (
                                <VideoUploadQuestion
                                  questionId={question.question_ID}
                                  mediaUrls={mediaUrls}
                                  setMediaUrls={setMediaUrls}
                                  setVideoBlobs={setVideoBlobs}
                                  videoBlobs={videoBlobs}
                                  setRecordingStates={setRecordingStates}
                                  recordingStates={recordingStates}
                                  selectedFiles={selectedFiles}
                                  setSelectedFiles={setSelectedFiles}
                                  uploadVideo={uploadVideo}
                                  videoUploading={videoUploading[question.question_ID] || false}
                                  setMediaUploading={setMediaUploading}
                                  setVideoUploading={setVideoUploading}
                                  stopVideoRecording={stopVideoRecording}
                                  videoUploadSuccess={videoUploadSuccess[question.question_ID]}
                                  setVideoUploadSuccess={setVideoUploadSuccess}
                                  successMsg={videoUploadSuccess[question.question_ID]}
                                  setPreAssignedImageUrls={setPreAssignedImageUrls}
                                  preAssignedImageUrl={preAssignedImageUrls[question.question_ID]}
                                  onRequestStartRecording={handleRequestStartRecording}
                                  disabled={viewedMedia[section.questionPaperSection_ID] || false}
                                  savedUploadProgress={
                                    videoUploadProgress[String(question.question_ID)] ||
                                    videoUploadProgress[question.question_ID] ||
                                    0
                                  }
                                  uploadStage={
                                    videoUploadMeta[String(question.question_ID)]?.stage ||
                                    videoUploadMeta[question.question_ID]?.stage
                                  }
                                  remainingUploadSeconds={
                                    videoUploadMeta[String(question.question_ID)]?.remainingSeconds ??
                                    videoUploadMeta[question.question_ID]?.remainingSeconds ??
                                    null
                                  }
                                  uploadActionError={
                                    videoUploadActionError[String(question.question_ID)] ||
                                    videoUploadActionError[question.question_ID] ||
                                    ''
                                  }
                                  connectionMessageStage={
                                    videoConnectionMessageStage[String(question.question_ID)] ||
                                    videoConnectionMessageStage[question.question_ID] ||
                                    null
                                  }
                                  onClearUploadActionError={() =>
                                    clearVideoUploadActionErrorFor(question.question_ID)
                                  }
                                  canResumeVideoUpload={
                                    String(videoResumeOffer?.questionId) === String(question.question_ID)
                                  }
                                  onResumeVideoUpload={() => resumeSavedVideoUpload(videoResumeOffer)}
                                  onDeleteIncompleteVideoUpload={() =>
                                    clearIncompleteVideoUpload(question.question_ID)
                                  }
                                  onUploadInterrupted={() =>
                                    setVideoResumeOffer({
                                      questionId: question.question_ID,
                                      questionTypeId: question.questionType_ID,
                                    })
                                  }
                                />
                              ) : (
                                <>
                                  <div style={{ marginTop: '1rem' }}>
                                    <input
                                      type="file"
                                      accept="image/*"
                                      onChange={e => {
                                        const file = e.target.files[0];
                                        if (file) {
                                          setSelectedFiles(prev => ({ ...prev, [question.question_ID]: file }));
                                        }
                                      }}
                                    />

                                    {question.maxFileSizeInMB && (
                                      <Text as="div" style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }}>
                                        Maximum file size: {question.maxFileSizeInMB}MB
                                      </Text>
                                    )}

                                    {selectedFiles[question.question_ID] && (
                                      <Button
                                        onClick={() => handleSubmit1(question.question_ID, question.questionType_ID)}
                                        style={{ marginTop: '1rem', minWidth: '120px' }}
                                        primary
                                      >
                                        Submit
                                      </Button>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                            </>
                          )}
                          {question.questionType_ID === 14 && question.choiceName_array && (
                            <>
                              {question.questionDescription && (
                                  <div style={{color: '#000000', fontWeight: 'normal', marginBottom: '1rem', fontSize: '15px',marginLeft:'25px' }}>
                                    {question.questionDescription}
                                  </div>
                                )}
                              <RankingQuestion
                              question={question}
                              answers={answers}
                              handleRankingChange={handleRankingChange}
                              disabled={!viewedMedia[section.questionPaperSection_ID]}
                            />
                            </>
                          )}
                          {question.questionType_ID === 3 && (
                            <>
                              {question.questionDescription && (
                                  <div style={{color: '#000000', fontWeight: 'normal', marginBottom: '1rem', fontSize: '15px',marginLeft:'25px' }}>
                                    {question.questionDescription}
                                  </div>
                                )}
                              <div
                                style={{
                                  opacity: viewedMedia[section.questionPaperSection_ID] ? 1 : 0.5,
                                  pointerEvents: viewedMedia[section.questionPaperSection_ID] ? 'auto' : 'none'
                                }}
                              >
                              <CustomSlider
                              questionId={question.question_ID}
                              value={answers[question.question_ID] || 0}
                              onValueChange={handleAnswerChange}
                              minValue={Number(question.choiceName_array?.[0]?.choiceName) || 0}
                              maxValue={Number(question.choiceName_array?.[1]?.choiceName) || 100}
                              leadingLabel={question.choiceName_array?.[0]?.choiceName || '0'}
                              trailingLabel={question.choiceName_array?.[1]?.choiceName || '100'}
                              questionText={question.questionName}
                              questionDescription={question.questionDescription}
                              isRequired={question.isRequired}
                              disabled={!viewedMedia[section.questionPaperSection_ID]}
                            />
                            </div>
                            </>
                          )}
                          {question.questionType_ID === 16 && (
                            <>
                              {question.questionDescription && (
                                  <div style={{color: '#000000', fontWeight: 'normal', marginBottom: '1rem', fontSize: '15px',marginLeft:'25px' }}>
                                    {question.questionDescription}
                                  </div>
                                )}
                              <div 
                                style={{
                                opacity: viewedMedia[section.questionPaperSection_ID] ? 1 : 0.5,
                                pointerEvents: viewedMedia[section.questionPaperSection_ID] ? 'auto' : 'none'
                                }}
                              >
                            <NPSQuestion
                              label={question.questionName}
                              value={answers[question.question_ID]}
                              onValueChange={value => {
                                if (viewedMedia[section.questionPaperSection_ID]) {
                                handleAnswerChange(question.question_ID, value)
                                }
                              }}
                              scale={question.likertScaleName_array.map(scale => scale.questionLikertScaleName)}
                              disabled={!viewedMedia[section.questionPaperSection_ID]}
                            />
                            </div>
                            </>
                          )}
                            {question.questionType_ID === 15 && (
                            <>
                              {question.questionDescription && (
                                  <div style={{color: '#000000', fontWeight: 'normal', marginBottom: '1rem', fontSize: '15px',marginLeft:'25px' }}>
                                    {question.questionDescription}
                                  </div>
                                )}
                              <VideoResponseUpload
                            question={question}
                            mediaUrls={mediaUrls}
                            setMediaUrls={setMediaUrls}
                            selectedFiles={selectedFiles}
                            setSelectedFiles={setSelectedFiles}
                            handleAnswerChange={handleAnswerChange}
                            uploadVideo={uploadVideo}
                            isRequired={question.isRequired === 1}
                            preAssignedVideoUrl={preAssignedImageUrls[question.question_ID]}
                            setPreAssignedVideoUrls={setPreAssignedImageUrls}
                            successMsg={videoSuccess[question.question_ID]}
                            setVideoUploadSuccess={setVideoSuccess}
                            // Show spinner only for the question currently uploading.
                            videoUploadScreenSuccess={
                              videoUploadScreenSuccess &&
                              String(activeMediaUploadingQuestionIdRef.current) === String(question.question_ID)
                            }
                            setMediaUploading={setMediaUploading}
                            onRequestStartRecording={handleRequestStartRecording}
                            disabled={!viewedMedia[section.questionPaperSection_ID]}
                            savedUploadProgress={
                              videoUploadProgress[String(question.question_ID)] ||
                              videoUploadProgress[question.question_ID] ||
                              0
                            }
                            uploadStage={
                              videoUploadMeta[String(question.question_ID)]?.stage ||
                              videoUploadMeta[question.question_ID]?.stage
                            }
                            remainingUploadSeconds={
                              videoUploadMeta[String(question.question_ID)]?.remainingSeconds ??
                              videoUploadMeta[question.question_ID]?.remainingSeconds ??
                              null
                            }
                            uploadActionError={
                              videoUploadActionError[String(question.question_ID)] ||
                              videoUploadActionError[question.question_ID] ||
                              ''
                            }
                            connectionMessageStage={
                              videoConnectionMessageStage[String(question.question_ID)] ||
                              videoConnectionMessageStage[question.question_ID] ||
                              null
                            }
                            onClearUploadActionError={() =>
                              clearVideoUploadActionErrorFor(question.question_ID)
                            }
                            canResumeVideoUpload={
                              String(videoResumeOffer?.questionId) === String(question.question_ID)
                            }
                            onResumeVideoUpload={() => resumeSavedVideoUpload(videoResumeOffer)}
                            onDeleteIncompleteVideoUpload={() =>
                              clearIncompleteVideoUpload(question.question_ID)
                            }
                          />
                            </>
                        )}
                          {question.questionType_ID === 8 && (
                            <>
                              {question.questionDescription && (
                                  <div style={{color: '#000000', fontWeight: 'normal', marginBottom: '1rem', fontSize: '15px',marginLeft:'25px' }}>
                                    {question.questionDescription}
                                  </div>
                                )}
                              <div 
                              style={{
                              opacity: viewedMedia[section.questionPaperSection_ID] ? 1 : 0.5,
                              pointerEvents: viewedMedia[section.questionPaperSection_ID] ? 'auto' : 'none'
                              }}
                              >
                            <ImageUploadQuestion
                              question={question}
                              qIdx={qIdx}
                              mediaUrls={mediaUrls}
                              setMediaUrls={setMediaUrls}
                              selectedFiles={selectedFiles}
                              projectId={projectId}
                              setSelectedFiles={setSelectedFiles}
                              handleAnswerChange={handleAnswerChange}
                              uploadImage={uploadImage}
                              isRequired={question.isRequired === 1}
                              preAssignedImageUrl={preAssignedImageUrls[question.question_ID]}
                              setPreAssignedImageUrls={setPreAssignedImageUrls}
                              successMsg={imageUploadSuccess[question.question_ID]}
                              disabled={!viewedMedia[section.questionPaperSection_ID]}
                            />
                            </div>
                            </>
                          )}
                        </div>
                      ))}
                    {!screenerSubmitted && sectionIdx === sections.length - 1 && isReferral == 1 && (
                      <ReferralCodeContainer>
                        <ReferralCodeTitle>Invite code</ReferralCodeTitle>
                        <ReferralCodeDescription>
                          Enter your invite code here if you have one. No code? You can click submit anyway.
                        </ReferralCodeDescription>
                        <TextInputWrapper
                          question={{
                            question_ID: 'referral_code',
                            questionType_ID: 5,
                            isRequired: false
                          }}
                          value={referralCodeState}
                          onSave={val => {
                            const filteredText = val.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
                            setReferralCodeState(filteredText);
                            setReferralCode(filteredText);
                          }}
                        />
                        {referralCodeError && <ReferralCodeError>{referralCodeError}</ReferralCodeError>}
                      </ReferralCodeContainer>
                    )}

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '1rem',
                        marginTop: '2rem',
                        padding: '1rem 0',
                        borderTop: '1px solid #eee'
                      }}
                    >
                      {currentSectionIndex < sections.length - 1 ? (
                        <Button
                          onClick={handleNextClick}
                          primary
                          style={{ minWidth: '120px' }}
                          disabled={(sections[currentSectionIndex]?.presignedUrlSectionImage && 
                            viewedMedia[sections[currentSectionIndex]?.questionPaperSection_ID] === false)
                            }
                        >
                          Next
                        </Button>
                      ) : (
                        <Button 
                          primary 
                          style={{ minWidth: '120px' }} 
                          onClick={handleSubmit} 
                          disabled={(sections[currentSectionIndex]?.presignedUrlSectionImage && 
                            viewedMedia[sections[currentSectionIndex]?.questionPaperSection_ID] === false)
                          }>
                          Submit
                        </Button>
                      )}
                      {currentSectionIndex > 0 && (
                        <Button
                          onClick={handleBackClick}
                          disabled={mediaUploading}
                          style={{
                            minWidth: '120px',
                            border: '2px solid #9ebe21',
                            color: '#9ebe21',
                            backgroundColor: '#fff'
                          }}
                        >
                          Go Back
                        </Button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* {!loading && !fetchErrorKind && sections.length === 0 && !preProfileData && <LoadingScreen />} */}
          </DashboardContent>
        )}
      </DashboardContainer>
      {showNoconnectionPopup && <NoConnectionPopup onClose={() => setShowNoConnectionPopup(false)} />}
      {isCheckingConnection && <LoadingOverlay />}
      <MobileDatePicker
        date={selectedDate}
        isOpen={isPickerOpen}
        onSelect={handleDateChange}
        onCancel={() => setIsPickerOpen(false)}
        headerFormat="DD/MM/YYYY"
        dateFormat={['DD', 'MM', 'YYYY']}
        confirmText="Confirm"
        cancelText="Cancel"
        max={(() => {
          const today = new Date();
          today.setDate(today.getDate() - 1);
          return today;
        })()}
        min={(() => {
          const date = new Date();
          date.setFullYear(date.getFullYear() - 100);
          return date;
        })()}
      />
    </RespondentFormRootContainer>
  );
}

const ErrorText = styled(Text)`
  color: red;
  margin-top: 1rem;
`;

const GlobalStyles = styled.div`
  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  .has-error {
    border: 1px solid #f44336 !important;
    animation: pulse 1s ease-in-out;
  }

  .required-question::after {
    content: ' *';
    color: #f44336;
  }

  .error-message {
    color: #f44336;
    font-size: 12px;
    margin-top: 4px;
    display: block;
  }
`;

export default RespondentFormDashboard;